/*
    Don't modify this file manually.
    This file auto generated by application.
*/

export const ENUM_CONSTANTS = {
  /*
    Auto generated from file Common.Domain.Models.PeriodEnum.cs.
  */
  PERIOD: [
    { name: 'enum.period.day' as const, value: 'Day' as const },
    { name: 'enum.period.week' as const, value: 'Week' as const },
    { name: 'enum.period.twoWeeks' as const, value: 'TwoWeeks' as const },
    { name: 'enum.period.month' as const, value: 'Month' as const },
    { name: 'enum.period.threeMonths' as const, value: 'ThreeMonths' as const },
    { name: 'enum.period.sixMonths' as const, value: 'SixMonths' as const },
    { name: 'enum.period.overall' as const, value: 'Overall' as const },
  ],

  /*
    Auto generated from file Common.Domain.Models.PeriodEnum.cs.
  */
  CHART_PERIOD: [
    { name: 'enum.period.week' as const, value: 'Week' as const },
    { name: 'enum.period.twoWeeks' as const, value: 'TwoWeeks' as const },
    { name: 'enum.period.month' as const, value: 'Month' as const },
    { name: 'enum.period.threeMonths' as const, value: 'ThreeMonths' as const },
    { name: 'enum.period.sixMonths' as const, value: 'SixMonths' as const },
    { name: 'enum.period.overall' as const, value: 'Overall' as const },
  ],

  /*
    Auto generated from file Common.Domain.Intervals.TimeIntervalTypeEnum.cs.
  */
  TIME_INTERVAL_TYPE: [
    { name: 'enum.timeIntervalType.seconds' as const, value: 'Seconds' as const },
    { name: 'enum.timeIntervalType.minutes' as const, value: 'Minutes' as const },
    { name: 'enum.timeIntervalType.hours' as const, value: 'Hours' as const },
    { name: 'enum.timeIntervalType.days' as const, value: 'Days' as const },
  ],

  /*
    Auto generated from file Common.Domain.Events.EventSourceType.cs.
  */
  EVENT_SOURCE_TYPE: [
    { name: 'enum.eventSourceType.userBirthday' as const, value: 'UserBirthday' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbLanguageEnum.cs.
  */
  LANGUAGE: [
    { name: 'enum.language.english' as const, value: 'English' as const },
    { name: 'enum.language.russian' as const, value: 'Russian' as const },
    { name: 'enum.language.chinese' as const, value: 'Chinese' as const },
    { name: 'enum.language.indonesian' as const, value: 'Indonesian' as const },
    { name: 'enum.language.malaysian' as const, value: 'Malaysian' as const },
    { name: 'enum.language.thai' as const, value: 'Thai' as const },
    { name: 'enum.language.vietnamese' as const, value: 'Vietnamese' as const },
    { name: 'enum.language.spanish' as const, value: 'Spanish' as const },
    { name: 'enum.language.arabic' as const, value: 'Arabic' as const },
    { name: 'enum.language.portuguese' as const, value: 'Portuguese' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  DOCUMENT_TYPE: [
    { name: 'enum.documentType.nationalId' as const, value: 'NationalId' as const },
    { name: 'enum.documentType.passport' as const, value: 'Passport' as const },
    { name: 'enum.documentType.drivingLicense' as const, value: 'DrivingLicense' as const },
    { name: 'enum.documentType.drivingLicenseFront' as const, value: 'DrivingLicenseFront' as const },
    { name: 'enum.documentType.drivingLicenseBack' as const, value: 'DrivingLicenseBack' as const },
    { name: 'enum.documentType.idCardFront' as const, value: 'IdCardFront' as const },
    { name: 'enum.documentType.idCardBack' as const, value: 'IdCardBack' as const },
    { name: 'enum.documentType.utilityBill' as const, value: 'UtilityBill' as const },
    { name: 'enum.documentType.bankStatement' as const, value: 'BankStatement' as const },
    { name: 'enum.documentType.bankCard' as const, value: 'BankCard' as const },
    { name: 'enum.documentType.voterCard' as const, value: 'VoterCard' as const },
    { name: 'enum.documentType.taxIdCard' as const, value: 'TaxIdCard' as const },
    { name: 'enum.documentType.NIN' as const, value: 'NIN' as const },
    { name: 'enum.documentType.birthCertificate' as const, value: 'BirthCertificate' as const },
    { name: 'enum.documentType.courtAffidavit' as const, value: 'CourtAffidavit' as const },
    { name: 'enum.documentType.residencePermit' as const, value: 'ResidencePermit' as const },
    { name: 'enum.documentType.armyOrMilitaryIdCard' as const, value: 'ArmyOrMilitaryIdCard' as const },
    { name: 'enum.documentType.proIdCard' as const, value: 'ProIdCard' as const },
    { name: 'enum.documentType.healthIdCard' as const, value: 'HealthIdCard' as const },
    { name: 'enum.documentType.selfieWithId' as const, value: 'SelfieWithId' as const },
    { name: 'enum.documentType.proofOfAddress' as const, value: 'ProofOfAddress' as const },
    { name: 'enum.documentType.companyRegistrationCertificate' as const, value: 'CompanyRegistrationCertificate' as const },
    { name: 'enum.documentType.legalPersonIdFront' as const, value: 'LegalPersonIdFront' as const },
    { name: 'enum.documentType.legalPersonIdBack' as const, value: 'LegalPersonIdBack' as const },
    { name: 'enum.documentType.legalPersonBankCard' as const, value: 'LegalPersonBankCard' as const },
    { name: 'enum.documentType.authorizationLetter' as const, value: 'AuthorizationLetter' as const },
    { name: 'enum.documentType.firstPersonNationalIdFront' as const, value: 'FirstPersonNationalIdFront' as const },
    { name: 'enum.documentType.firstPersonNationalIdBack' as const, value: 'FirstPersonNationalIdBack' as const },
    { name: 'enum.documentType.secondPersonNationalIdFront' as const, value: 'SecondPersonNationalIdFront' as const },
    { name: 'enum.documentType.secondPersonNationalIdBack' as const, value: 'SecondPersonNationalIdBack' as const },
    { name: 'enum.documentType.individualMoneyManagerApplication' as const, value: 'IndividualMoneyManagerApplication' as const },
    { name: 'enum.documentType.limitedPowerOfAttorney' as const, value: 'LimitedPowerOfAttorney' as const },
    { name: 'enum.documentType.signature' as const, value: 'Signature' as const },
    { name: 'enum.documentType.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  ALL_REQUIRED_DOCUMENT_TYPE: [
    { name: 'enum.documentType.bankCard' as const, value: 'BankCard' as const },
    { name: 'enum.documentType.companyRegistrationCertificate' as const, value: 'CompanyRegistrationCertificate' as const },
    { name: 'enum.documentType.legalPersonIdFront' as const, value: 'LegalPersonIdFront' as const },
    { name: 'enum.documentType.legalPersonIdBack' as const, value: 'LegalPersonIdBack' as const },
    { name: 'enum.documentType.legalPersonBankCard' as const, value: 'LegalPersonBankCard' as const },
    { name: 'enum.documentType.authorizationLetter' as const, value: 'AuthorizationLetter' as const },
    { name: 'enum.documentType.firstPersonNationalIdFront' as const, value: 'FirstPersonNationalIdFront' as const },
    { name: 'enum.documentType.firstPersonNationalIdBack' as const, value: 'FirstPersonNationalIdBack' as const },
    { name: 'enum.documentType.secondPersonNationalIdFront' as const, value: 'SecondPersonNationalIdFront' as const },
    { name: 'enum.documentType.secondPersonNationalIdBack' as const, value: 'SecondPersonNationalIdBack' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  BASE_DOCUMENT_TYPE: [
    { name: 'enum.documentType.passport' as const, value: 'Passport' as const },
    { name: 'enum.documentType.drivingLicenseFront' as const, value: 'DrivingLicenseFront' as const },
    { name: 'enum.documentType.drivingLicenseBack' as const, value: 'DrivingLicenseBack' as const },
    { name: 'enum.documentType.idCardFront' as const, value: 'IdCardFront' as const },
    { name: 'enum.documentType.idCardBack' as const, value: 'IdCardBack' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  BASE_AND_ADDRESS_DOCUMENT_TYPE: [
    { name: 'enum.documentType.nationalId' as const, value: 'NationalId' as const },
    { name: 'enum.documentType.passport' as const, value: 'Passport' as const },
    { name: 'enum.documentType.drivingLicense' as const, value: 'DrivingLicense' as const },
    { name: 'enum.documentType.utilityBill' as const, value: 'UtilityBill' as const },
    { name: 'enum.documentType.bankCard' as const, value: 'BankCard' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  GOVERNMENT_PHOTO_DOCUMENT_TYPE: [
    { name: 'enum.documentType.nationalId' as const, value: 'NationalId' as const },
    { name: 'enum.documentType.passport' as const, value: 'Passport' as const },
    { name: 'enum.documentType.drivingLicense' as const, value: 'DrivingLicense' as const },
    { name: 'enum.documentType.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  MAIN_DOCUMENT_TYPE: [
    { name: 'enum.documentType.idCardFront' as const, value: 'IdCardFront' as const },
    { name: 'enum.documentType.idCardBack' as const, value: 'IdCardBack' as const },
    { name: 'enum.documentType.bankCard' as const, value: 'BankCard' as const },
    { name: 'enum.documentType.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  ONE_REQUIRED_DOCUMENT_TYPE: [
    { name: 'enum.documentType.nationalId' as const, value: 'NationalId' as const },
    { name: 'enum.documentType.passport' as const, value: 'Passport' as const },
    { name: 'enum.documentType.drivingLicense' as const, value: 'DrivingLicense' as const },
    { name: 'enum.documentType.idCardFront' as const, value: 'IdCardFront' as const },
    { name: 'enum.documentType.idCardBack' as const, value: 'IdCardBack' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  USER_CORPORATE_DOCUMENT_TYPE: [
    { name: 'enum.documentType.companyRegistrationCertificate' as const, value: 'CompanyRegistrationCertificate' as const },
    { name: 'enum.documentType.legalPersonIdFront' as const, value: 'LegalPersonIdFront' as const },
    { name: 'enum.documentType.legalPersonIdBack' as const, value: 'LegalPersonIdBack' as const },
    { name: 'enum.documentType.legalPersonBankCard' as const, value: 'LegalPersonBankCard' as const },
    { name: 'enum.documentType.authorizationLetter' as const, value: 'AuthorizationLetter' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbDocumentTypeEnum.cs.
  */
  USER_INDIVIDUAL_DOCUMENT_TYPE: [
    { name: 'enum.documentType.nationalId' as const, value: 'NationalId' as const },
    { name: 'enum.documentType.passport' as const, value: 'Passport' as const },
    { name: 'enum.documentType.drivingLicense' as const, value: 'DrivingLicense' as const },
    { name: 'enum.documentType.idCardFront' as const, value: 'IdCardFront' as const },
    { name: 'enum.documentType.idCardBack' as const, value: 'IdCardBack' as const },
    { name: 'enum.documentType.bankCard' as const, value: 'BankCard' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbCountryEnum.cs.
  */
  COUNTRY: [
    { name: 'enum.country.notAllowed' as const, value: 'NotAllowed' as const },
    { name: 'enum.country.allCountries' as const, value: 'AllCountries' as const },
    { name: 'enum.country.afghanistan' as const, value: 'Afghanistan' as const },
    { name: 'enum.country.ålandIslands' as const, value: 'ÅlandIslands' as const },
    { name: 'enum.country.albania' as const, value: 'Albania' as const },
    { name: 'enum.country.algeria' as const, value: 'Algeria' as const },
    { name: 'enum.country.americanSamoa' as const, value: 'AmericanSamoa' as const },
    { name: 'enum.country.andorra' as const, value: 'Andorra' as const },
    { name: 'enum.country.angola' as const, value: 'Angola' as const },
    { name: 'enum.country.anguilla' as const, value: 'Anguilla' as const },
    { name: 'enum.country.antarctica' as const, value: 'Antarctica' as const },
    { name: 'enum.country.antiguaandBarbuda' as const, value: 'AntiguaandBarbuda' as const },
    { name: 'enum.country.argentina' as const, value: 'Argentina' as const },
    { name: 'enum.country.armenia' as const, value: 'Armenia' as const },
    { name: 'enum.country.aruba' as const, value: 'Aruba' as const },
    { name: 'enum.country.australia' as const, value: 'Australia' as const },
    { name: 'enum.country.austria' as const, value: 'Austria' as const },
    { name: 'enum.country.azerbaijan' as const, value: 'Azerbaijan' as const },
    { name: 'enum.country.bahamas' as const, value: 'Bahamas' as const },
    { name: 'enum.country.bahrain' as const, value: 'Bahrain' as const },
    { name: 'enum.country.bangladesh' as const, value: 'Bangladesh' as const },
    { name: 'enum.country.barbados' as const, value: 'Barbados' as const },
    { name: 'enum.country.belarus' as const, value: 'Belarus' as const },
    { name: 'enum.country.belgium' as const, value: 'Belgium' as const },
    { name: 'enum.country.belize' as const, value: 'Belize' as const },
    { name: 'enum.country.benin' as const, value: 'Benin' as const },
    { name: 'enum.country.bermuda' as const, value: 'Bermuda' as const },
    { name: 'enum.country.bhutan' as const, value: 'Bhutan' as const },
    { name: 'enum.country.bolivia' as const, value: 'Bolivia' as const },
    { name: 'enum.country.bosniaandHerzegovina' as const, value: 'BosniaandHerzegovina' as const },
    { name: 'enum.country.botswana' as const, value: 'Botswana' as const },
    { name: 'enum.country.bouvetIsland' as const, value: 'BouvetIsland' as const },
    { name: 'enum.country.brazil' as const, value: 'Brazil' as const },
    { name: 'enum.country.britishIndianOceanTerritory' as const, value: 'BritishIndianOceanTerritory' as const },
    { name: 'enum.country.britishVirginIslands' as const, value: 'BritishVirginIslands' as const },
    { name: 'enum.country.brunei' as const, value: 'Brunei' as const },
    { name: 'enum.country.bulgaria' as const, value: 'Bulgaria' as const },
    { name: 'enum.country.burkinaFaso' as const, value: 'BurkinaFaso' as const },
    { name: 'enum.country.burundi' as const, value: 'Burundi' as const },
    { name: 'enum.country.cambodia' as const, value: 'Cambodia' as const },
    { name: 'enum.country.cameroon' as const, value: 'Cameroon' as const },
    { name: 'enum.country.canada' as const, value: 'Canada' as const },
    { name: 'enum.country.capeVerde' as const, value: 'CapeVerde' as const },
    { name: 'enum.country.caribbeanNetherlands' as const, value: 'CaribbeanNetherlands' as const },
    { name: 'enum.country.caymanIslands' as const, value: 'CaymanIslands' as const },
    { name: 'enum.country.centralAfricanRepublic' as const, value: 'CentralAfricanRepublic' as const },
    { name: 'enum.country.chad' as const, value: 'Chad' as const },
    { name: 'enum.country.chile' as const, value: 'Chile' as const },
    { name: 'enum.country.china' as const, value: 'China' as const },
    { name: 'enum.country.christmasIsland' as const, value: 'ChristmasIsland' as const },
    { name: 'enum.country.cocos' as const, value: 'Cocos' as const },
    { name: 'enum.country.colombia' as const, value: 'Colombia' as const },
    { name: 'enum.country.comoros' as const, value: 'Comoros' as const },
    { name: 'enum.country.congoBrazzaville' as const, value: 'CongoBrazzaville' as const },
    { name: 'enum.country.congoDCR' as const, value: 'CongoDCR' as const },
    { name: 'enum.country.cookIslands' as const, value: 'CookIslands' as const },
    { name: 'enum.country.costaRica' as const, value: 'CostaRica' as const },
    { name: 'enum.country.côtedIvoire' as const, value: 'CôtedIvoire' as const },
    { name: 'enum.country.croatia' as const, value: 'Croatia' as const },
    { name: 'enum.country.cuba' as const, value: 'Cuba' as const },
    { name: 'enum.country.curaçao' as const, value: 'Curaçao' as const },
    { name: 'enum.country.cyprus' as const, value: 'Cyprus' as const },
    { name: 'enum.country.czechRepublic' as const, value: 'CzechRepublic' as const },
    { name: 'enum.country.denmark' as const, value: 'Denmark' as const },
    { name: 'enum.country.djibouti' as const, value: 'Djibouti' as const },
    { name: 'enum.country.dominica' as const, value: 'Dominica' as const },
    { name: 'enum.country.dominicanRepublic' as const, value: 'DominicanRepublic' as const },
    { name: 'enum.country.ecuador' as const, value: 'Ecuador' as const },
    { name: 'enum.country.egypt' as const, value: 'Egypt' as const },
    { name: 'enum.country.elSalvador' as const, value: 'ElSalvador' as const },
    { name: 'enum.country.equatorialGuinea' as const, value: 'EquatorialGuinea' as const },
    { name: 'enum.country.eritrea' as const, value: 'Eritrea' as const },
    { name: 'enum.country.estonia' as const, value: 'Estonia' as const },
    { name: 'enum.country.ethiopia' as const, value: 'Ethiopia' as const },
    { name: 'enum.country.falklandIslands' as const, value: 'FalklandIslands' as const },
    { name: 'enum.country.faroeIslands' as const, value: 'FaroeIslands' as const },
    { name: 'enum.country.fiji' as const, value: 'Fiji' as const },
    { name: 'enum.country.finland' as const, value: 'Finland' as const },
    { name: 'enum.country.france' as const, value: 'France' as const },
    { name: 'enum.country.frenchGuiana' as const, value: 'FrenchGuiana' as const },
    { name: 'enum.country.frenchPolynesia' as const, value: 'FrenchPolynesia' as const },
    { name: 'enum.country.frenchSouthernandAntarcticLands' as const, value: 'FrenchSouthernandAntarcticLands' as const },
    { name: 'enum.country.gabon' as const, value: 'Gabon' as const },
    { name: 'enum.country.gambia' as const, value: 'Gambia' as const },
    { name: 'enum.country.georgia' as const, value: 'Georgia' as const },
    { name: 'enum.country.germany' as const, value: 'Germany' as const },
    { name: 'enum.country.ghana' as const, value: 'Ghana' as const },
    { name: 'enum.country.gibraltar' as const, value: 'Gibraltar' as const },
    { name: 'enum.country.greece' as const, value: 'Greece' as const },
    { name: 'enum.country.greenland' as const, value: 'Greenland' as const },
    { name: 'enum.country.grenada' as const, value: 'Grenada' as const },
    { name: 'enum.country.guadeloupe' as const, value: 'Guadeloupe' as const },
    { name: 'enum.country.guam' as const, value: 'Guam' as const },
    { name: 'enum.country.guatemala' as const, value: 'Guatemala' as const },
    { name: 'enum.country.guernsey' as const, value: 'Guernsey' as const },
    { name: 'enum.country.guinea' as const, value: 'Guinea' as const },
    { name: 'enum.country.guineaBissau' as const, value: 'GuineaBissau' as const },
    { name: 'enum.country.guyana' as const, value: 'Guyana' as const },
    { name: 'enum.country.haiti' as const, value: 'Haiti' as const },
    { name: 'enum.country.heardIslandandMcDonaldIslands' as const, value: 'HeardIslandandMcDonaldIslands' as const },
    { name: 'enum.country.honduras' as const, value: 'Honduras' as const },
    { name: 'enum.country.hongKong' as const, value: 'HongKong' as const },
    { name: 'enum.country.hungary' as const, value: 'Hungary' as const },
    { name: 'enum.country.iceland' as const, value: 'Iceland' as const },
    { name: 'enum.country.india' as const, value: 'India' as const },
    { name: 'enum.country.indonesia' as const, value: 'Indonesia' as const },
    { name: 'enum.country.iran' as const, value: 'Iran' as const },
    { name: 'enum.country.iraq' as const, value: 'Iraq' as const },
    { name: 'enum.country.ireland' as const, value: 'Ireland' as const },
    { name: 'enum.country.isleofMan' as const, value: 'IsleofMan' as const },
    { name: 'enum.country.israel' as const, value: 'Israel' as const },
    { name: 'enum.country.italy' as const, value: 'Italy' as const },
    { name: 'enum.country.jamaica' as const, value: 'Jamaica' as const },
    { name: 'enum.country.japan' as const, value: 'Japan' as const },
    { name: 'enum.country.jersey' as const, value: 'Jersey' as const },
    { name: 'enum.country.jordan' as const, value: 'Jordan' as const },
    { name: 'enum.country.kazakhstan' as const, value: 'Kazakhstan' as const },
    { name: 'enum.country.kenya' as const, value: 'Kenya' as const },
    { name: 'enum.country.kiribati' as const, value: 'Kiribati' as const },
    { name: 'enum.country.kosovo' as const, value: 'Kosovo' as const },
    { name: 'enum.country.kuwait' as const, value: 'Kuwait' as const },
    { name: 'enum.country.kyrgyzstan' as const, value: 'Kyrgyzstan' as const },
    { name: 'enum.country.laos' as const, value: 'Laos' as const },
    { name: 'enum.country.latvia' as const, value: 'Latvia' as const },
    { name: 'enum.country.lebanon' as const, value: 'Lebanon' as const },
    { name: 'enum.country.lesotho' as const, value: 'Lesotho' as const },
    { name: 'enum.country.liberia' as const, value: 'Liberia' as const },
    { name: 'enum.country.libya' as const, value: 'Libya' as const },
    { name: 'enum.country.liechtenstein' as const, value: 'Liechtenstein' as const },
    { name: 'enum.country.lithuania' as const, value: 'Lithuania' as const },
    { name: 'enum.country.luxembourg' as const, value: 'Luxembourg' as const },
    { name: 'enum.country.macau' as const, value: 'Macau' as const },
    { name: 'enum.country.macedonia' as const, value: 'Macedonia' as const },
    { name: 'enum.country.madagascar' as const, value: 'Madagascar' as const },
    { name: 'enum.country.malawi' as const, value: 'Malawi' as const },
    { name: 'enum.country.malaysia' as const, value: 'Malaysia' as const },
    { name: 'enum.country.maldives' as const, value: 'Maldives' as const },
    { name: 'enum.country.mali' as const, value: 'Mali' as const },
    { name: 'enum.country.malta' as const, value: 'Malta' as const },
    { name: 'enum.country.marshallIslands' as const, value: 'MarshallIslands' as const },
    { name: 'enum.country.martinique' as const, value: 'Martinique' as const },
    { name: 'enum.country.mauritania' as const, value: 'Mauritania' as const },
    { name: 'enum.country.mauritius' as const, value: 'Mauritius' as const },
    { name: 'enum.country.mayotte' as const, value: 'Mayotte' as const },
    { name: 'enum.country.mexico' as const, value: 'Mexico' as const },
    { name: 'enum.country.micronesia' as const, value: 'Micronesia' as const },
    { name: 'enum.country.moldova' as const, value: 'Moldova' as const },
    { name: 'enum.country.monaco' as const, value: 'Monaco' as const },
    { name: 'enum.country.mongolia' as const, value: 'Mongolia' as const },
    { name: 'enum.country.montenegro' as const, value: 'Montenegro' as const },
    { name: 'enum.country.montserrat' as const, value: 'Montserrat' as const },
    { name: 'enum.country.morocco' as const, value: 'Morocco' as const },
    { name: 'enum.country.mozambique' as const, value: 'Mozambique' as const },
    { name: 'enum.country.myanmar' as const, value: 'Myanmar' as const },
    { name: 'enum.country.namibia' as const, value: 'Namibia' as const },
    { name: 'enum.country.nauru' as const, value: 'Nauru' as const },
    { name: 'enum.country.nepal' as const, value: 'Nepal' as const },
    { name: 'enum.country.netherlands' as const, value: 'Netherlands' as const },
    { name: 'enum.country.newCaledonia' as const, value: 'NewCaledonia' as const },
    { name: 'enum.country.newZealand' as const, value: 'NewZealand' as const },
    { name: 'enum.country.nicaragua' as const, value: 'Nicaragua' as const },
    { name: 'enum.country.niger' as const, value: 'Niger' as const },
    { name: 'enum.country.nigeria' as const, value: 'Nigeria' as const },
    { name: 'enum.country.niue' as const, value: 'Niue' as const },
    { name: 'enum.country.norfolkIsland' as const, value: 'NorfolkIsland' as const },
    { name: 'enum.country.northernMarianaIslands' as const, value: 'NorthernMarianaIslands' as const },
    { name: 'enum.country.northKorea' as const, value: 'NorthKorea' as const },
    { name: 'enum.country.norway' as const, value: 'Norway' as const },
    { name: 'enum.country.oman' as const, value: 'Oman' as const },
    { name: 'enum.country.pakistan' as const, value: 'Pakistan' as const },
    { name: 'enum.country.palau' as const, value: 'Palau' as const },
    { name: 'enum.country.palestine' as const, value: 'Palestine' as const },
    { name: 'enum.country.panama' as const, value: 'Panama' as const },
    { name: 'enum.country.papuaNewGuinea' as const, value: 'PapuaNewGuinea' as const },
    { name: 'enum.country.paraguay' as const, value: 'Paraguay' as const },
    { name: 'enum.country.peru' as const, value: 'Peru' as const },
    { name: 'enum.country.philippines' as const, value: 'Philippines' as const },
    { name: 'enum.country.pitcairnIslands' as const, value: 'PitcairnIslands' as const },
    { name: 'enum.country.poland' as const, value: 'Poland' as const },
    { name: 'enum.country.portugal' as const, value: 'Portugal' as const },
    { name: 'enum.country.puertoRico' as const, value: 'PuertoRico' as const },
    { name: 'enum.country.qatar' as const, value: 'Qatar' as const },
    { name: 'enum.country.réunion' as const, value: 'Réunion' as const },
    { name: 'enum.country.romania' as const, value: 'Romania' as const },
    { name: 'enum.country.russia' as const, value: 'Russia' as const },
    { name: 'enum.country.rwanda' as const, value: 'Rwanda' as const },
    { name: 'enum.country.saintBarthélemy' as const, value: 'SaintBarthélemy' as const },
    { name: 'enum.country.saintHelena' as const, value: 'SaintHelena' as const },
    { name: 'enum.country.saintKittsandNevis' as const, value: 'SaintKittsandNevis' as const },
    { name: 'enum.country.saintLucia' as const, value: 'SaintLucia' as const },
    { name: 'enum.country.saintMartin' as const, value: 'SaintMartin' as const },
    { name: 'enum.country.saintPierreAndMiquelon' as const, value: 'SaintPierreAndMiquelon' as const },
    { name: 'enum.country.saintVincentandtheGrenadines' as const, value: 'SaintVincentandtheGrenadines' as const },
    { name: 'enum.country.samoa' as const, value: 'Samoa' as const },
    { name: 'enum.country.sanMarino' as const, value: 'SanMarino' as const },
    { name: 'enum.country.sãoToméandPríncipe' as const, value: 'SãoToméandPríncipe' as const },
    { name: 'enum.country.saudiArabia' as const, value: 'SaudiArabia' as const },
    { name: 'enum.country.senegal' as const, value: 'Senegal' as const },
    { name: 'enum.country.serbia' as const, value: 'Serbia' as const },
    { name: 'enum.country.seychelles' as const, value: 'Seychelles' as const },
    { name: 'enum.country.sierraLeone' as const, value: 'SierraLeone' as const },
    { name: 'enum.country.singapore' as const, value: 'Singapore' as const },
    { name: 'enum.country.sintMaarten' as const, value: 'SintMaarten' as const },
    { name: 'enum.country.slovakia' as const, value: 'Slovakia' as const },
    { name: 'enum.country.slovenia' as const, value: 'Slovenia' as const },
    { name: 'enum.country.solomonIslands' as const, value: 'SolomonIslands' as const },
    { name: 'enum.country.somalia' as const, value: 'Somalia' as const },
    { name: 'enum.country.southAfrica' as const, value: 'SouthAfrica' as const },
    { name: 'enum.country.southGeorgiaandtheSouthSandwichIslands' as const, value: 'SouthGeorgiaandtheSouthSandwichIslands' as const },
    { name: 'enum.country.southKorea' as const, value: 'SouthKorea' as const },
    { name: 'enum.country.southSudan' as const, value: 'SouthSudan' as const },
    { name: 'enum.country.spain' as const, value: 'Spain' as const },
    { name: 'enum.country.sriLanka' as const, value: 'SriLanka' as const },
    { name: 'enum.country.sudan' as const, value: 'Sudan' as const },
    { name: 'enum.country.suriname' as const, value: 'Suriname' as const },
    { name: 'enum.country.svalbardandJanMayen' as const, value: 'SvalbardandJanMayen' as const },
    { name: 'enum.country.swaziland' as const, value: 'Swaziland' as const },
    { name: 'enum.country.sweden' as const, value: 'Sweden' as const },
    { name: 'enum.country.switzerland' as const, value: 'Switzerland' as const },
    { name: 'enum.country.syria' as const, value: 'Syria' as const },
    { name: 'enum.country.taiwan' as const, value: 'Taiwan' as const },
    { name: 'enum.country.tajikistan' as const, value: 'Tajikistan' as const },
    { name: 'enum.country.tanzania' as const, value: 'Tanzania' as const },
    { name: 'enum.country.thailand' as const, value: 'Thailand' as const },
    { name: 'enum.country.timorLeste' as const, value: 'TimorLeste' as const },
    { name: 'enum.country.togo' as const, value: 'Togo' as const },
    { name: 'enum.country.tokelau' as const, value: 'Tokelau' as const },
    { name: 'enum.country.tonga' as const, value: 'Tonga' as const },
    { name: 'enum.country.trinidadandTobago' as const, value: 'TrinidadandTobago' as const },
    { name: 'enum.country.tunisia' as const, value: 'Tunisia' as const },
    { name: 'enum.country.turkey' as const, value: 'Turkey' as const },
    { name: 'enum.country.turkmenistan' as const, value: 'Turkmenistan' as const },
    { name: 'enum.country.turksandCaicosIslands' as const, value: 'TurksandCaicosIslands' as const },
    { name: 'enum.country.tuvalu' as const, value: 'Tuvalu' as const },
    { name: 'enum.country.uganda' as const, value: 'Uganda' as const },
    { name: 'enum.country.ukraine' as const, value: 'Ukraine' as const },
    { name: 'enum.country.unitedArabEmirates' as const, value: 'UnitedArabEmirates' as const },
    { name: 'enum.country.unitedKingdom' as const, value: 'UnitedKingdom' as const },
    { name: 'enum.country.unitedStates' as const, value: 'UnitedStates' as const },
    { name: 'enum.country.unitedStatesMinorOutlyingIslands' as const, value: 'UnitedStatesMinorOutlyingIslands' as const },
    { name: 'enum.country.uruguay' as const, value: 'Uruguay' as const },
    { name: 'enum.country.USVirginIslands' as const, value: 'USVirginIslands' as const },
    { name: 'enum.country.uzbekistan' as const, value: 'Uzbekistan' as const },
    { name: 'enum.country.vanuatu' as const, value: 'Vanuatu' as const },
    { name: 'enum.country.vaticanCity' as const, value: 'VaticanCity' as const },
    { name: 'enum.country.venezuela' as const, value: 'Venezuela' as const },
    { name: 'enum.country.vietnam' as const, value: 'Vietnam' as const },
    { name: 'enum.country.wallisandFutuna' as const, value: 'WallisandFutuna' as const },
    { name: 'enum.country.westernSahara' as const, value: 'WesternSahara' as const },
    { name: 'enum.country.yemen' as const, value: 'Yemen' as const },
    { name: 'enum.country.zambia' as const, value: 'Zambia' as const },
    { name: 'enum.country.zimbabwe' as const, value: 'Zimbabwe' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbGenderEnum.cs.
  */
  GENDER: [
    { name: 'enum.gender.male' as const, value: 'Male' as const },
    { name: 'enum.gender.female' as const, value: 'Female' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbProfileStatusEnum.cs.
  */
  PROFILE_STATUS: [
    { name: 'enum.profileStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.profileStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.profileStatus.draft' as const, value: 'Draft' as const },
    { name: 'enum.profileStatus.duplicated' as const, value: 'Duplicated' as const },
    { name: 'enum.profileStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.profileStatus.updateRequired' as const, value: 'UpdateRequired' as const },
    { name: 'enum.profileStatus.urgentUpdate' as const, value: 'UrgentUpdate' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbProfileStatusEnum.cs.
  */
  PROMOTE_PROFILE_STATUS: [
    { name: 'enum.profileStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.profileStatus.declined' as const, value: 'Declined' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Wallet.DbExecutionTypeEnum.cs.
  */
  EXECUTION_TYPE: [
    { name: 'enum.executionType.automatic' as const, value: 'Automatic' as const },
    { name: 'enum.executionType.manually' as const, value: 'Manually' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Wallet.DbWalletAccountTypeEnum.cs.
  */
  WALLET_ACCOUNT_TYPE: [
    { name: 'enum.walletAccountType.regular' as const, value: 'Regular' as const },
    { name: 'enum.walletAccountType.transit' as const, value: 'Transit' as const },
    { name: 'enum.walletAccountType.all' as const, value: 'All' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Wallet.DbWalletOperationCategoryEnum.cs.
  */
  WALLET_OPERATION_CATEGORY: [
    { name: 'enum.walletOperationCategory.electronicPayment' as const, value: 'ElectronicPayment' as const },
    { name: 'enum.walletOperationCategory.bankTransfer' as const, value: 'BankTransfer' as const },
    { name: 'enum.walletOperationCategory.CUP' as const, value: 'CUP' as const },
    { name: 'enum.walletOperationCategory.localDeposit' as const, value: 'LocalDeposit' as const },
    { name: 'enum.walletOperationCategory.ibBonus' as const, value: 'IbBonus' as const },
    { name: 'enum.walletOperationCategory.localBankIndonesia' as const, value: 'LocalBankIndonesia' as const },
    { name: 'enum.walletOperationCategory.localBankMalaysia' as const, value: 'LocalBankMalaysia' as const },
    { name: 'enum.walletOperationCategory.localBankThailand' as const, value: 'LocalBankThailand' as const },
    { name: 'enum.walletOperationCategory.localBankVietnam' as const, value: 'LocalBankVietnam' as const },
    { name: 'enum.walletOperationCategory.cryptoPayments' as const, value: 'CryptoPayments' as const },
    { name: 'enum.walletOperationCategory.localBankPhilippines' as const, value: 'LocalBankPhilippines' as const },
    { name: 'enum.walletOperationCategory.electronicTransfer' as const, value: 'ElectronicTransfer' as const },
    { name: 'enum.walletOperationCategory.onlineBankNigeria' as const, value: 'OnlineBankNigeria' as const },
    { name: 'enum.walletOperationCategory.onlineBankSouthAfrica' as const, value: 'OnlineBankSouthAfrica' as const },
    { name: 'enum.walletOperationCategory.onlineBankIndia' as const, value: 'OnlineBankIndia' as const },
    { name: 'enum.walletOperationCategory.onlineBank' as const, value: 'OnlineBank' as const },
    { name: 'enum.walletOperationCategory.cashPayment' as const, value: 'CashPayment' as const },
    { name: 'enum.walletOperationCategory.onlineBankUzbekistan' as const, value: 'OnlineBankUzbekistan' as const },
    { name: 'enum.walletOperationCategory.onlineBankAlbania' as const, value: 'OnlineBankAlbania' as const },
    { name: 'enum.walletOperationCategory.onlineBankAlgeria' as const, value: 'OnlineBankAlgeria' as const },
    { name: 'enum.walletOperationCategory.onlineBankArgentina' as const, value: 'OnlineBankArgentina' as const },
    { name: 'enum.walletOperationCategory.onlineBankAzerbaijan' as const, value: 'OnlineBankAzerbaijan' as const },
    { name: 'enum.walletOperationCategory.onlineBankBahrain' as const, value: 'OnlineBankBahrain' as const },
    { name: 'enum.walletOperationCategory.onlineBankBangladesh' as const, value: 'OnlineBankBangladesh' as const },
    { name: 'enum.walletOperationCategory.onlineBankBolivia' as const, value: 'OnlineBankBolivia' as const },
    { name: 'enum.walletOperationCategory.onlineBankBrazil' as const, value: 'OnlineBankBrazil' as const },
    { name: 'enum.walletOperationCategory.onlineBankBrunei' as const, value: 'OnlineBankBrunei' as const },
    { name: 'enum.walletOperationCategory.onlineBankCambodia' as const, value: 'OnlineBankCambodia' as const },
    { name: 'enum.walletOperationCategory.onlineBankCameroon' as const, value: 'OnlineBankCameroon' as const },
    { name: 'enum.walletOperationCategory.onlineBankChile' as const, value: 'OnlineBankChile' as const },
    { name: 'enum.walletOperationCategory.onlineBankColombia' as const, value: 'OnlineBankColombia' as const },
    { name: 'enum.walletOperationCategory.onlineBankCostaRica' as const, value: 'OnlineBankCostaRica' as const },
    { name: 'enum.walletOperationCategory.onlineBankDRCongo' as const, value: 'OnlineBankDRCongo' as const },
    { name: 'enum.walletOperationCategory.onlineBankEcuador' as const, value: 'OnlineBankEcuador' as const },
    { name: 'enum.walletOperationCategory.onlineBankEgypt' as const, value: 'OnlineBankEgypt' as const },
    { name: 'enum.walletOperationCategory.onlineBankEthiopia' as const, value: 'OnlineBankEthiopia' as const },
    { name: 'enum.walletOperationCategory.onlineBankGhana' as const, value: 'OnlineBankGhana' as const },
    { name: 'enum.walletOperationCategory.onlineBankGuatemala' as const, value: 'OnlineBankGuatemala' as const },
    { name: 'enum.walletOperationCategory.onlineBankJordan' as const, value: 'OnlineBankJordan' as const },
    { name: 'enum.walletOperationCategory.onlineBankJamaica' as const, value: 'OnlineBankJamaica' as const },
    { name: 'enum.walletOperationCategory.onlineBankKazakhstan' as const, value: 'OnlineBankKazakhstan' as const },
    { name: 'enum.walletOperationCategory.onlineBankKenya' as const, value: 'OnlineBankKenya' as const },
    { name: 'enum.walletOperationCategory.onlineBankLaos' as const, value: 'OnlineBankLaos' as const },
    { name: 'enum.walletOperationCategory.onlineBankMadagascar' as const, value: 'OnlineBankMadagascar' as const },
    { name: 'enum.walletOperationCategory.onlineBankMalawi' as const, value: 'OnlineBankMalawi' as const },
    { name: 'enum.walletOperationCategory.onlineBankMaldives' as const, value: 'OnlineBankMaldives' as const },
    { name: 'enum.walletOperationCategory.onlineBankMexico' as const, value: 'OnlineBankMexico' as const },
    { name: 'enum.walletOperationCategory.onlineBankMongolia' as const, value: 'OnlineBankMongolia' as const },
    { name: 'enum.walletOperationCategory.onlineBankMorocco' as const, value: 'OnlineBankMorocco' as const },
    { name: 'enum.walletOperationCategory.onlineBankMozambique' as const, value: 'OnlineBankMozambique' as const },
    { name: 'enum.walletOperationCategory.onlineBankMyanmar' as const, value: 'OnlineBankMyanmar' as const },
    { name: 'enum.walletOperationCategory.onlineBankNamibia' as const, value: 'OnlineBankNamibia' as const },
    { name: 'enum.walletOperationCategory.onlineBankNicaragua' as const, value: 'OnlineBankNicaragua' as const },
    { name: 'enum.walletOperationCategory.onlineBankNepal' as const, value: 'OnlineBankNepal' as const },
    { name: 'enum.walletOperationCategory.onlineBankOman' as const, value: 'OnlineBankOman' as const },
    { name: 'enum.walletOperationCategory.onlineBankPakistan' as const, value: 'OnlineBankPakistan' as const },
    { name: 'enum.walletOperationCategory.onlineBankParaguay' as const, value: 'OnlineBankParaguay' as const },
    { name: 'enum.walletOperationCategory.onlineBankPeru' as const, value: 'OnlineBankPeru' as const },
    { name: 'enum.walletOperationCategory.onlineBankQatar' as const, value: 'OnlineBankQatar' as const },
    { name: 'enum.walletOperationCategory.onlineBankRussia' as const, value: 'OnlineBankRussia' as const },
    { name: 'enum.walletOperationCategory.onlineBankSaudiArabia' as const, value: 'OnlineBankSaudiArabia' as const },
    { name: 'enum.walletOperationCategory.onlineBankSriLanka' as const, value: 'OnlineBankSriLanka' as const },
    { name: 'enum.walletOperationCategory.onlineBankTanzania' as const, value: 'OnlineBankTanzania' as const },
    { name: 'enum.walletOperationCategory.onlineBankTunisia' as const, value: 'OnlineBankTunisia' as const },
    { name: 'enum.walletOperationCategory.onlineBankTurkey' as const, value: 'OnlineBankTurkey' as const },
    { name: 'enum.walletOperationCategory.onlineBankUkraine' as const, value: 'OnlineBankUkraine' as const },
    { name: 'enum.walletOperationCategory.onlineBankUganda' as const, value: 'OnlineBankUganda' as const },
    { name: 'enum.walletOperationCategory.onlineBankUnitedArabEmirates' as const, value: 'OnlineBankUnitedArabEmirates' as const },
    { name: 'enum.walletOperationCategory.onlineBankVenezuela' as const, value: 'OnlineBankVenezuela' as const },
    { name: 'enum.walletOperationCategory.onlineBankYemen' as const, value: 'OnlineBankYemen' as const },
    { name: 'enum.walletOperationCategory.onlineBankZambia' as const, value: 'OnlineBankZambia' as const },
    { name: 'enum.walletOperationCategory.onlineBankZimbabwe' as const, value: 'OnlineBankZimbabwe' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Wallet.DbWalletOperationStatusEnum.cs.
  */
  WALLET_OPERATION_STATUS: [
    { name: 'enum.walletOperationStatus.succeed' as const, value: 'Succeed' as const },
    { name: 'enum.walletOperationStatus.failed' as const, value: 'Failed' as const },
    { name: 'enum.walletOperationStatus.blocked' as const, value: 'Blocked' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Wallet.DbWalletOperationTransferTypeEnum.cs.
  */
  WALLET_OPERATION_TRANSFER_TYPE: [
    { name: 'enum.walletOperationTransferType.depositFromPaymentSystem' as const, value: 'DepositFromPaymentSystem' as const },
    { name: 'enum.walletOperationTransferType.withdrawalToPaymentSystem' as const, value: 'WithdrawalToPaymentSystem' as const },
    { name: 'enum.walletOperationTransferType.internalTransferToTradingAccount' as const, value: 'InternalTransferToTradingAccount' as const },
    { name: 'enum.walletOperationTransferType.internalTransferFromTradingAccount' as const, value: 'InternalTransferFromTradingAccount' as const },
    { name: 'enum.walletOperationTransferType.internalTransferToEwallet' as const, value: 'InternalTransferToEwallet' as const },
    { name: 'enum.walletOperationTransferType.internalTransferFromEwallet' as const, value: 'InternalTransferFromEwallet' as const },
    { name: 'enum.walletOperationTransferType.manualAdjustment' as const, value: 'ManualAdjustment' as const },
    { name: 'enum.walletOperationTransferType.commissionPayout' as const, value: 'CommissionPayout' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Wallet.DbWalletOperationTypeEnum.cs.
  */
  WALLET_OPERATION_TYPE: [
    { name: 'enum.walletOperationType.withdrawal' as const, value: 'Withdrawal' as const },
    { name: 'enum.walletOperationType.deposit' as const, value: 'Deposit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.VideoConfiguration.DbVideoCategoryEnum.cs.
  */
  VIDEO_CATEGORY: [
    { name: 'enum.videoCategory.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.videoCategory.depositAndWithdrawal' as const, value: 'DepositAndWithdrawal' as const },
    { name: 'enum.videoCategory.forex' as const, value: 'Forex' as const },
    { name: 'enum.videoCategory.forexTrading' as const, value: 'ForexTrading' as const },
    { name: 'enum.videoCategory.socialTrading' as const, value: 'SocialTrading' as const },
    { name: 'enum.videoCategory.mt4TradingPlatform' as const, value: 'Mt4TradingPlatform' as const },
    { name: 'enum.videoCategory.edgeTradingPlatform' as const, value: 'EdgeTradingPlatform' as const },
    { name: 'enum.videoCategory.mt5TradingPlatform' as const, value: 'Mt5TradingPlatform' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.VideoConfiguration.DbVideoLocationEnum.cs.
  */
  VIDEO_LOCATION: [
    { name: 'enum.videoLocation.EWallet' as const, value: 'EWallet' as const },
    { name: 'enum.videoLocation.tradingPlatforms' as const, value: 'TradingPlatforms' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbApplicationEnum.cs.
  */
  APPLICATION: [
    { name: 'enum.application.membersArea' as const, value: 'MembersArea' as const },
    { name: 'enum.application.partnershipPortal' as const, value: 'PartnershipPortal' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbClientAppTypeEnum.cs.
  */
  CLIENT_APP_TYPE: [
    { name: 'enum.clientAppType.webApp' as const, value: 'WebApp' as const },
    { name: 'enum.clientAppType.mobileApp' as const, value: 'MobileApp' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbClientSourceTypeEnum.cs.
  */
  CLIENT_SOURCE_TYPE: [
    { name: 'enum.clientSourceType.direct' as const, value: 'Direct' as const },
    { name: 'enum.clientSourceType.ibTree' as const, value: 'IbTree' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbContactMethodEnum.cs.
  */
  CONTACT_METHOD: [
    { name: 'enum.contactMethod.call' as const, value: 'Call' as const },
    { name: 'enum.contactMethod.messenger' as const, value: 'Messenger' as const },
    { name: 'enum.contactMethod.email' as const, value: 'Email' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbOccupationEnum.cs.
  */
  OCCUPATION: [
    { name: 'enum.occupation.accounting' as const, value: 'Accounting' as const },
    { name: 'enum.occupation.agricultural' as const, value: 'Agricultural' as const },
    { name: 'enum.occupation.architectureOrEngineering' as const, value: 'ArchitectureOrEngineering' as const },
    { name: 'enum.occupation.armsTradeOrDefence' as const, value: 'ArmsTradeOrDefence' as const },
    { name: 'enum.occupation.artsOrDesign' as const, value: 'ArtsOrDesign' as const },
    { name: 'enum.occupation.buildingOrConstruction' as const, value: 'BuildingOrConstruction' as const },
    { name: 'enum.occupation.computerOrITServices' as const, value: 'ComputerOrITServices' as const },
    { name: 'enum.occupation.consultancy' as const, value: 'Consultancy' as const },
    { name: 'enum.occupation.exchangeOrCurrencyServices' as const, value: 'ExchangeOrCurrencyServices' as const },
    { name: 'enum.occupation.oilAndGasIndustry' as const, value: 'OilAndGasIndustry' as const },
    { name: 'enum.occupation.financeIndustryOrFinancialServices' as const, value: 'FinanceIndustryOrFinancialServices' as const },
    { name: 'enum.occupation.foodAndBeverage' as const, value: 'FoodAndBeverage' as const },
    { name: 'enum.occupation.fisheriesOrLogging' as const, value: 'FisheriesOrLogging' as const },
    { name: 'enum.occupation.gamblingIndustry' as const, value: 'GamblingIndustry' as const },
    { name: 'enum.occupation.healthcare' as const, value: 'Healthcare' as const },
    { name: 'enum.occupation.insurance' as const, value: 'Insurance' as const },
    { name: 'enum.occupation.legal' as const, value: 'Legal' as const },
    { name: 'enum.occupation.mediaOrCreative' as const, value: 'MediaOrCreative' as const },
    { name: 'enum.occupation.moneyServices' as const, value: 'MoneyServices' as const },
    { name: 'enum.occupation.nonProfit' as const, value: 'NonProfit' as const },
    { name: 'enum.occupation.pharmaceuticals' as const, value: 'Pharmaceuticals' as const },
    { name: 'enum.occupation.politicsOrGovernmentOrMinistry' as const, value: 'PoliticsOrGovernmentOrMinistry' as const },
    { name: 'enum.occupation.preciousMetalsOrStones' as const, value: 'PreciousMetalsOrStones' as const },
    { name: 'enum.occupation.publicServices' as const, value: 'PublicServices' as const },
    { name: 'enum.occupation.realEstate' as const, value: 'RealEstate' as const },
    { name: 'enum.occupation.retailTrade' as const, value: 'RetailTrade' as const },
    { name: 'enum.occupation.retiredOrPension' as const, value: 'RetiredOrPension' as const },
    { name: 'enum.occupation.salesOrMarketing' as const, value: 'SalesOrMarketing' as const },
    { name: 'enum.occupation.sportsIndustry' as const, value: 'SportsIndustry' as const },
    { name: 'enum.occupation.student' as const, value: 'Student' as const },
    { name: 'enum.occupation.telecommunications' as const, value: 'Telecommunications' as const },
    { name: 'enum.occupation.tourism' as const, value: 'Tourism' as const },
    { name: 'enum.occupation.transportLogistics' as const, value: 'TransportLogistics' as const },
    { name: 'enum.occupation.unemployed' as const, value: 'Unemployed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbUserAccessItemTypeEnum.cs.
  */
  USER_ACCESS_ITEM_TYPE: [
    { name: 'enum.userAccessItemType.tradingAccountType' as const, value: 'TradingAccountType' as const },
    { name: 'enum.userAccessItemType.contest' as const, value: 'Contest' as const },
    { name: 'enum.userAccessItemType.component' as const, value: 'Component' as const },
    { name: 'enum.userAccessItemType.loyaltyProgram' as const, value: 'LoyaltyProgram' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.DbUserNameAliasStatus.cs.
  */
  USER_NAME_ALIAS_STATUS: [
    { name: 'enum.userNameAliasStatus.created' as const, value: 'Created' as const },
    { name: 'enum.userNameAliasStatus.verified' as const, value: 'Verified' as const },
    { name: 'enum.userNameAliasStatus.rejected' as const, value: 'Rejected' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.UserAccessType.cs.
  */
  USER_ACCESS_TYPE: [
    { name: 'enum.userAccessType.allowed' as const, value: 'Allowed' as const },
    { name: 'enum.userAccessType.forbidden' as const, value: 'Forbidden' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.UserMovementHistoryAccountTypeEnum.cs.
  */
  USER_MOVEMENT_HISTORY_ACCOUNT_TYPE: [
    { name: 'enum.userMovementHistoryAccountType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.userMovementHistoryAccountType.walletAccount' as const, value: 'WalletAccount' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.TrustedDevice.DbTrustedDeviceStatus.cs.
  */
  TRUSTED_DEVICE_STATUS: [
    { name: 'enum.trustedDeviceStatus.pending' as const, value: 'Pending' as const },
    { name: 'enum.trustedDeviceStatus.verified' as const, value: 'Verified' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.BonusReductionMethod.cs.
  */
  BONUS_REDUCTION_METHOD: [
    { name: 'enum.bonusReductionMethod.proportional' as const, value: 'Proportional' as const },
    { name: 'enum.bonusReductionMethod.complete' as const, value: 'Complete' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbCommissionGroupTypeEnum.cs.
  */
  COMMISSION_GROUP_TYPE: [
    { name: 'enum.commissionGroupType.cost' as const, value: 'Cost' as const },
    { name: 'enum.commissionGroupType.rebate' as const, value: 'Rebate' as const },
    { name: 'enum.commissionGroupType.agentCommission' as const, value: 'AgentCommission' as const },
    { name: 'enum.commissionGroupType.commission' as const, value: 'Commission' as const },
    { name: 'enum.commissionGroupType.spread' as const, value: 'Spread' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbCommissionPrefixEnum.cs.
  */
  COMMISSION_PREFIX: [
    { name: 'enum.commissionPrefix.C' as const, value: 'C' as const },
    { name: 'enum.commissionPrefix.D' as const, value: 'D' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbCostPrefixEnum.cs.
  */
  COST_PREFIX: [
    { name: 'enum.costPrefix.P' as const, value: 'P' as const },
    { name: 'enum.costPrefix.Q' as const, value: 'Q' as const },
    { name: 'enum.costPrefix.Y' as const, value: 'Y' as const },
    { name: 'enum.costPrefix.Z' as const, value: 'Z' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbGroupMappingEnum.cs.
  */
  GROUP_MAPPING: [
    { name: 'enum.groupMapping.realStandard' as const, value: 'RealStandard' as const },
    { name: 'enum.groupMapping.realCent' as const, value: 'RealCent' as const },
    { name: 'enum.groupMapping.realStandardBonus' as const, value: 'RealStandardBonus' as const },
    { name: 'enum.groupMapping.realCentBonus' as const, value: 'RealCentBonus' as const },
    { name: 'enum.groupMapping.realLocalDeposit' as const, value: 'RealLocalDeposit' as const },
    { name: 'enum.groupMapping.realPartner' as const, value: 'RealPartner' as const },
    { name: 'enum.groupMapping.realEcn' as const, value: 'RealEcn' as const },
    { name: 'enum.groupMapping.realMamMaster' as const, value: 'RealMamMaster' as const },
    { name: 'enum.groupMapping.realMamInvestor' as const, value: 'RealMamInvestor' as const },
    { name: 'enum.groupMapping.realMamInvestorEcn' as const, value: 'RealMamInvestorEcn' as const },
    { name: 'enum.groupMapping.realSales' as const, value: 'RealSales' as const },
    { name: 'enum.groupMapping.realPlus' as const, value: 'RealPlus' as const },
    { name: 'enum.groupMapping.realPro' as const, value: 'RealPro' as const },
    { name: 'enum.groupMapping.realCrypto' as const, value: 'RealCrypto' as const },
    { name: 'enum.groupMapping.realCopyTradingMasterStandard' as const, value: 'RealCopyTradingMasterStandard' as const },
    { name: 'enum.groupMapping.realCopyTradingMasterEcn' as const, value: 'RealCopyTradingMasterEcn' as const },
    { name: 'enum.groupMapping.realCopyTradingInvestorStandard' as const, value: 'RealCopyTradingInvestorStandard' as const },
    { name: 'enum.groupMapping.realCopyTradingInvestorEcn' as const, value: 'RealCopyTradingInvestorEcn' as const },
    { name: 'enum.groupMapping.realCommissionStandard' as const, value: 'RealCommissionStandard' as const },
    { name: 'enum.groupMapping.realCommissionEcn' as const, value: 'RealCommissionEcn' as const },
    { name: 'enum.groupMapping.realMamCommissionStandard' as const, value: 'RealMamCommissionStandard' as const },
    { name: 'enum.groupMapping.realMamCommissionEcn' as const, value: 'RealMamCommissionEcn' as const },
    { name: 'enum.groupMapping.realMamMasterEcn' as const, value: 'RealMamMasterEcn' as const },
    { name: 'enum.groupMapping.demoStandard' as const, value: 'DemoStandard' as const },
    { name: 'enum.groupMapping.demoCent' as const, value: 'DemoCent' as const },
    { name: 'enum.groupMapping.demoEcn' as const, value: 'DemoEcn' as const },
    { name: 'enum.groupMapping.test' as const, value: 'Test' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbGroupMappingEnum.cs.
  */
  SOCIAL_TRADING_INVESTOR_GROUP_MAPPING: [
    { name: 'enum.groupMapping.realCopyTradingInvestorStandard' as const, value: 'RealCopyTradingInvestorStandard' as const },
    { name: 'enum.groupMapping.realCopyTradingInvestorEcn' as const, value: 'RealCopyTradingInvestorEcn' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbGroupMappingEnum.cs.
  */
  SOCIAL_TRADING_MASTER_GROUP_MAPPING: [
    { name: 'enum.groupMapping.realCopyTradingMasterStandard' as const, value: 'RealCopyTradingMasterStandard' as const },
    { name: 'enum.groupMapping.realCopyTradingMasterEcn' as const, value: 'RealCopyTradingMasterEcn' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbPayoutType.cs.
  */
  PAYOUT_TYPE: [
    { name: 'enum.payoutType.profitShare' as const, value: 'ProfitShare' as const },
    { name: 'enum.payoutType.profitShareOnConditions' as const, value: 'ProfitShareOnConditions' as const },
    { name: 'enum.payoutType.rebate' as const, value: 'Rebate' as const },
    { name: 'enum.payoutType.rebateZero' as const, value: 'RebateZero' as const },
    { name: 'enum.payoutType.standard' as const, value: 'Standard' as const },
    { name: 'enum.payoutType.noPayout' as const, value: 'NoPayout' as const },
    { name: 'enum.payoutType.zeroRebateByIbTree' as const, value: 'ZeroRebateByIbTree' as const },
    { name: 'enum.payoutType.zeroRebateByIbSpecification' as const, value: 'ZeroRebateByIbSpecification' as const },
    { name: 'enum.payoutType.proximity' as const, value: 'Proximity' as const },
    { name: 'enum.payoutType.mainIbPriority' as const, value: 'MainIbPriority' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbSpreadPrefixEnum.cs.
  */
  SPREAD_PREFIX: [
    { name: 'enum.spreadPrefix.S' as const, value: 'S' as const },
    { name: 'enum.spreadPrefix.T' as const, value: 'T' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingAccountTypeAccountEnum.cs.
  */
  TRADING_ACCOUNT_TYPE_ACCOUNT: [
    { name: 'enum.tradingAccountTypeAccount.real' as const, value: 'Real' as const },
    { name: 'enum.tradingAccountTypeAccount.demo' as const, value: 'Demo' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingBonusLinkStatusEnum.cs.
  */
  TRADING_BONUS_LINK_STATUS: [
    { name: 'enum.tradingBonusLinkStatus.new' as const, value: 'New' as const },
    { name: 'enum.tradingBonusLinkStatus.active' as const, value: 'Active' as const },
    { name: 'enum.tradingBonusLinkStatus.initiated' as const, value: 'Initiated' as const },
    { name: 'enum.tradingBonusLinkStatus.completed' as const, value: 'Completed' as const },
    { name: 'enum.tradingBonusLinkStatus.expired' as const, value: 'Expired' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingBonusLinkStatusEnum.cs.
  */
  PROMOTE_TRADING_BONUS_LINK_STATUS: [
    { name: 'enum.tradingBonusLinkStatus.expired' as const, value: 'Expired' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingClassEnum.cs.
  */
  TRADING_CLASS: [
    { name: 'enum.tradingClass.standard' as const, value: 'Standard' as const },
    { name: 'enum.tradingClass.ECN' as const, value: 'ECN' as const },
    { name: 'enum.tradingClass.bonus' as const, value: 'Bonus' as const },
    { name: 'enum.tradingClass.copyTrading' as const, value: 'CopyTrading' as const },
    { name: 'enum.tradingClass.MAM' as const, value: 'MAM' as const },
    { name: 'enum.tradingClass.cent' as const, value: 'Cent' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingPlatformTypeEnum.cs.
  */
  TRADING_PLATFORM_TYPE: [
    { name: 'enum.tradingPlatformType.meta4' as const, value: 'Meta4' as const },
    { name: 'enum.tradingPlatformType.meta5' as const, value: 'Meta5' as const },
    { name: 'enum.tradingPlatformType.gmi' as const, value: 'Gmi' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingPlatformTypeEnum.cs.
  */
  COPY_TRADING_TRADING_PLATFORM_TYPE: [
    { name: 'enum.tradingPlatformType.meta4' as const, value: 'Meta4' as const },
    { name: 'enum.tradingPlatformType.meta5' as const, value: 'Meta5' as const },
    { name: 'enum.tradingPlatformType.gmi' as const, value: 'Gmi' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingSymbolGroupEnum.cs.
  */
  TRADING_SYMBOL_GROUP: [
    { name: 'enum.tradingSymbolGroup.crypto' as const, value: 'Crypto' as const },
    { name: 'enum.tradingSymbolGroup.energy' as const, value: 'Energy' as const },
    { name: 'enum.tradingSymbolGroup.fx' as const, value: 'Fx' as const },
    { name: 'enum.tradingSymbolGroup.indices' as const, value: 'Indices' as const },
    { name: 'enum.tradingSymbolGroup.metals' as const, value: 'Metals' as const },
    { name: 'enum.tradingSymbolGroup.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbTradingSymbolTypeEnum.cs.
  */
  TRADING_SYMBOL_TYPE: [
    { name: 'enum.tradingSymbolType.CFD' as const, value: 'CFD' as const },
    { name: 'enum.tradingSymbolType.forex' as const, value: 'Forex' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbUnitEnum.cs.
  */
  UNIT: [
    { name: 'enum.unit.usd' as const, value: 'Usd' as const },
    { name: 'enum.unit.pips' as const, value: 'Pips' as const },
    { name: 'enum.unit.percentage' as const, value: 'Percentage' as const },
    { name: 'enum.unit.points' as const, value: 'Points' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.HlbCommissionMode.cs.
  */
  HLB_COMMISSION_MODE: [
    { name: 'enum.hlbCommissionMode.ownMoneyDivByMargin' as const, value: 'OwnMoneyDivByMargin' as const },
    { name: 'enum.hlbCommissionMode.ownMoneyDivByEquity' as const, value: 'OwnMoneyDivByEquity' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.DbProcessedTicketResultEnum.cs.
  */
  PROCESSED_TICKET_RESULT: [
    { name: 'enum.processedTicketResult.success' as const, value: 'Success' as const },
    { name: 'enum.processedTicketResult.failedToGetRate' as const, value: 'FailedToGetRate' as const },
    { name: 'enum.processedTicketResult.zeroRate' as const, value: 'ZeroRate' as const },
    { name: 'enum.processedTicketResult.tradingAccountNotFound' as const, value: 'TradingAccountNotFound' as const },
    { name: 'enum.processedTicketResult.tradingAccountIsArchived' as const, value: 'TradingAccountIsArchived' as const },
    { name: 'enum.processedTicketResult.tradingAccountIsDemo' as const, value: 'TradingAccountIsDemo' as const },
    { name: 'enum.processedTicketResult.tradingAccountWithoutIb' as const, value: 'TradingAccountWithoutIb' as const },
    { name: 'enum.processedTicketResult.tradingAccountIsMam' as const, value: 'TradingAccountIsMam' as const },
    { name: 'enum.processedTicketResult.rootIbWithoutSpecification' as const, value: 'RootIbWithoutSpecification' as const },
    { name: 'enum.processedTicketResult.rootIbSpecificationNotFound' as const, value: 'RootIbSpecificationNotFound' as const },
    { name: 'enum.processedTicketResult.someIbsAreDisabled' as const, value: 'SomeIbsAreDisabled' as const },
    { name: 'enum.processedTicketResult.someIbsSkippedDueToNonPositiveCommission' as const, value: 'SomeIbsSkippedDueToNonPositiveCommission' as const },
    { name: 'enum.processedTicketResult.zeroVolume' as const, value: 'ZeroVolume' as const },
    { name: 'enum.processedTicketResult.unexpectedErrorDuringCalculation' as const, value: 'UnexpectedErrorDuringCalculation' as const },
    { name: 'enum.processedTicketResult.distributionInvalid' as const, value: 'DistributionInvalid' as const },
    { name: 'enum.processedTicketResult.distributionNotFound' as const, value: 'DistributionNotFound' as const },
    { name: 'enum.processedTicketResult.groupNotFound' as const, value: 'GroupNotFound' as const },
    { name: 'enum.processedTicketResult.groupPayoutDisabled' as const, value: 'GroupPayoutDisabled' as const },
    { name: 'enum.processedTicketResult.groupPayoutTypeNotFound' as const, value: 'GroupPayoutTypeNotFound' as const },
    { name: 'enum.processedTicketResult.groupPayoutTypeNotSupported' as const, value: 'GroupPayoutTypeNotSupported' as const },
    { name: 'enum.processedTicketResult.payoutInvalid' as const, value: 'PayoutInvalid' as const },
    { name: 'enum.processedTicketResult.payoutNotFound' as const, value: 'PayoutNotFound' as const },
    { name: 'enum.processedTicketResult.payoutRateInvalid' as const, value: 'PayoutRateInvalid' as const },
    { name: 'enum.processedTicketResult.payoutUnitTypeNotSupported' as const, value: 'PayoutUnitTypeNotSupported' as const },
    { name: 'enum.processedTicketResult.symbolNotFound' as const, value: 'SymbolNotFound' as const },
    { name: 'enum.processedTicketResult.tradeAlreadyProcessed' as const, value: 'TradeAlreadyProcessed' as const },
    { name: 'enum.processedTicketResult.accountCurrencyNotSupported' as const, value: 'AccountCurrencyNotSupported' as const },
    { name: 'enum.processedTicketResult.groupIsArchived' as const, value: 'GroupIsArchived' as const },
    { name: 'enum.processedTicketResult.symbolContractSizeInvalid' as const, value: 'SymbolContractSizeInvalid' as const },
    { name: 'enum.processedTicketResult.tradeVolumeZero' as const, value: 'TradeVolumeZero' as const },
    { name: 'enum.processedTicketResult.minCloseTimeRestriction' as const, value: 'MinCloseTimeRestriction' as const },
    { name: 'enum.processedTicketResult.closeTimeIntervalRestriction' as const, value: 'CloseTimeIntervalRestriction' as const },
    { name: 'enum.processedTicketResult.noIbCodeForUser' as const, value: 'NoIbCodeForUser' as const },
    { name: 'enum.processedTicketResult.rootIbIsExcluded' as const, value: 'RootIbIsExcluded' as const },
    { name: 'enum.processedTicketResult.magicFieldRestriction' as const, value: 'MagicFieldRestriction' as const },
    { name: 'enum.processedTicketResult.commentRestriction' as const, value: 'CommentRestriction' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.User.AccountTypeUserType.cs.
  */
  ACCOUNT_TYPE_USER_TYPE: [
    { name: 'enum.accountTypeUserType.individual' as const, value: 'Individual' as const },
    { name: 'enum.accountTypeUserType.mib' as const, value: 'Mib' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.ThirdPartyService.DbJobStatusEnum.cs.
  */
  JOB_STATUS: [
    { name: 'enum.jobStatus.init' as const, value: 'Init' as const },
    { name: 'enum.jobStatus.start' as const, value: 'Start' as const },
    { name: 'enum.jobStatus.inProgress' as const, value: 'InProgress' as const },
    { name: 'enum.jobStatus.completed' as const, value: 'Completed' as const },
    { name: 'enum.jobStatus.cancelled' as const, value: 'Cancelled' as const },
    { name: 'enum.jobStatus.failed' as const, value: 'Failed' as const },
    { name: 'enum.jobStatus.exception' as const, value: 'Exception' as const },
    { name: 'enum.jobStatus.obsolete' as const, value: 'Obsolete' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.ThirdPartyService.DbTenantEnum.cs.
  */
  TENANT: [
    { name: 'enum.tenant.ROW' as const, value: 'ROW' as const },
    { name: 'enum.tenant.china' as const, value: 'China' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Reports.ClosedTradesTypeEnum.cs.
  */
  CLOSED_TRADES_TYPE: [
    { name: 'enum.closedTradesType.direct' as const, value: 'Direct' as const },
    { name: 'enum.closedTradesType.indirect' as const, value: 'Indirect' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Reports.DbReportStatusEnum.cs.
  */
  REPORT_STATUS: [
    { name: 'enum.reportStatus.inProgress' as const, value: 'InProgress' as const },
    { name: 'enum.reportStatus.success' as const, value: 'Success' as const },
    { name: 'enum.reportStatus.failed' as const, value: 'Failed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Reports.DbReportTypeEnum.cs.
  */
  REPORT_TYPE: [
    { name: 'enum.reportType.closedTrades' as const, value: 'ClosedTrades' as const },
    { name: 'enum.reportType.tradingVolume' as const, value: 'TradingVolume' as const },
    { name: 'enum.reportType.walletAccountReport' as const, value: 'WalletAccountReport' as const },
    { name: 'enum.reportType.accountsArchiverReport' as const, value: 'AccountsArchiverReport' as const },
    { name: 'enum.reportType.commissionHistoryReport' as const, value: 'CommissionHistoryReport' as const },
    { name: 'enum.reportType.walletOperationReport' as const, value: 'WalletOperationReport' as const },
    { name: 'enum.reportType.tradingBonusReport' as const, value: 'TradingBonusReport' as const },
    { name: 'enum.reportType.paymentOperationsReport' as const, value: 'PaymentOperationsReport' as const },
    { name: 'enum.reportType.autoArchivedAccountsReport' as const, value: 'AutoArchivedAccountsReport' as const },
    { name: 'enum.reportType.preArchivedAccountsReport' as const, value: 'PreArchivedAccountsReport' as const },
    { name: 'enum.reportType.depositOnHoldReport' as const, value: 'DepositOnHoldReport' as const },
    { name: 'enum.reportType.commissionTicketsReport' as const, value: 'CommissionTicketsReport' as const },
    { name: 'enum.reportType.tradingPlatformBalanceOperationReport' as const, value: 'TradingPlatformBalanceOperationReport' as const },
    { name: 'enum.reportType.tradingPlatformAdjustmentReport' as const, value: 'TradingPlatformAdjustmentReport' as const },
    { name: 'enum.reportType.tradingPlatformInactiveAccountsReport' as const, value: 'TradingPlatformInactiveAccountsReport' as const },
    { name: 'enum.reportType.tradingPlatformIBDetailReport' as const, value: 'TradingPlatformIBDetailReport' as const },
    { name: 'enum.reportType.tradingPlatformCreditFacilityReport' as const, value: 'TradingPlatformCreditFacilityReport' as const },
    { name: 'enum.reportType.tradingPlatformSummaryReport' as const, value: 'TradingPlatformSummaryReport' as const },
    { name: 'enum.reportType.tradingPlatformDailyEquityReport' as const, value: 'TradingPlatformDailyEquityReport' as const },
    { name: 'enum.reportType.commissionTicketsV4Report' as const, value: 'CommissionTicketsV4Report' as const },
    { name: 'enum.reportType.topWithdrawalsSummaryReport' as const, value: 'TopWithdrawalsSummaryReport' as const },
    { name: 'enum.reportType.topWithdrawalsDetailsReport' as const, value: 'TopWithdrawalsDetailsReport' as const },
    { name: 'enum.reportType.topDepositsSummaryReport' as const, value: 'TopDepositsSummaryReport' as const },
    { name: 'enum.reportType.topDepositsDetailsReport' as const, value: 'TopDepositsDetailsReport' as const },
    { name: 'enum.reportType.manualDepositsReport' as const, value: 'ManualDepositsReport' as const },
    { name: 'enum.reportType.nonUsdWalletOperationsReport' as const, value: 'NonUsdWalletOperationsReport' as const },
    { name: 'enum.reportType.topIbRebateSummaryReport' as const, value: 'TopIbRebateSummaryReport' as const },
    { name: 'enum.reportType.topIbRebateDetailsReport' as const, value: 'TopIbRebateDetailsReport' as const },
    { name: 'enum.reportType.volumeBySecuritySummaryReport' as const, value: 'VolumeBySecuritySummaryReport' as const },
    { name: 'enum.reportType.volumeBySecurityDetailsReport' as const, value: 'VolumeBySecurityDetailsReport' as const },
    { name: 'enum.reportType.contestRatingReport' as const, value: 'ContestRatingReport' as const },
    { name: 'enum.reportType.pspBalanceReport' as const, value: 'PspBalanceReport' as const },
    { name: 'enum.reportType.volumeBySecuritySummaryStandardReport' as const, value: 'VolumeBySecuritySummaryStandardReport' as const },
    { name: 'enum.reportType.volumeBySecuritySummaryCentReport' as const, value: 'VolumeBySecuritySummaryCentReport' as const },
    { name: 'enum.reportType.volumeBySecuritySummaryEcnReport' as const, value: 'VolumeBySecuritySummaryEcnReport' as const },
    { name: 'enum.reportType.volumeBySecurityDetailsStandardReport' as const, value: 'VolumeBySecurityDetailsStandardReport' as const },
    { name: 'enum.reportType.volumeBySecurityDetailsCentReport' as const, value: 'VolumeBySecurityDetailsCentReport' as const },
    { name: 'enum.reportType.volumeBySecurityDetailsEcnReport' as const, value: 'VolumeBySecurityDetailsEcnReport' as const },
    { name: 'enum.reportType.combinedTradingPlatformDailyEquityReport' as const, value: 'CombinedTradingPlatformDailyEquityReport' as const },
    { name: 'enum.reportType.usdAdjustedWalletAccountReport' as const, value: 'UsdAdjustedWalletAccountReport' as const },
    { name: 'enum.reportType.usdAdjustedWalletOperationReport' as const, value: 'UsdAdjustedWalletOperationReport' as const },
    { name: 'enum.reportType.countryBasedWalletAccountReport' as const, value: 'CountryBasedWalletAccountReport' as const },
    { name: 'enum.reportType.manualAdjustmentWalletOperationReport' as const, value: 'ManualAdjustmentWalletOperationReport' as const },
    { name: 'enum.reportType.succeedTransactionWalletOperationReport' as const, value: 'SucceedTransactionWalletOperationReport' as const },
    { name: 'enum.reportType.tradingVolumeReport' as const, value: 'TradingVolumeReport' as const },
    { name: 'enum.reportType.depositWithdrawalReport' as const, value: 'DepositWithdrawalReport' as const },
    { name: 'enum.reportType.MTPayPaymentSystemReport' as const, value: 'MTPayPaymentSystemReport' as const },
    { name: 'enum.reportType.ibTreeReport' as const, value: 'IbTreeReport' as const },
    { name: 'enum.reportType.combinedTradingPlatformSummaryReport' as const, value: 'CombinedTradingPlatformSummaryReport' as const },
    { name: 'enum.reportType.excludedRebatesTradingPayoutsReport' as const, value: 'ExcludedRebatesTradingPayoutsReport' as const },
    { name: 'enum.reportType.clientEquitySummaryReport' as const, value: 'ClientEquitySummaryReport' as const },
    { name: 'enum.reportType.chipPayPaymentSystemReport' as const, value: 'ChipPayPaymentSystemReport' as const },
    { name: 'enum.reportType.exlinkPaymentSystemReport' as const, value: 'ExlinkPaymentSystemReport' as const },
    { name: 'enum.reportType.exlinkCryptoPaymentSystemReport' as const, value: 'ExlinkCryptoPaymentSystemReport' as const },
    { name: 'enum.reportType.paySolPaymentSystemReport' as const, value: 'PaySolPaymentSystemReport' as const },
    { name: 'enum.reportType.openTradesReport' as const, value: 'OpenTradesReport' as const },
    { name: 'enum.reportType.equityIbMovementReport' as const, value: 'EquityIbMovementReport' as const },
    { name: 'enum.reportType.balanceServerCountryOperationReport' as const, value: 'BalanceServerCountryOperationReport' as const },
    { name: 'enum.reportType.usePayPaymentSystemReport' as const, value: 'UsePayPaymentSystemReport' as const },
    { name: 'enum.reportType.oneTwoPayPaymentSystemReport' as const, value: 'OneTwoPayPaymentSystemReport' as const },
    { name: 'enum.reportType.summaryAmountByServerCountryReport' as const, value: 'SummaryAmountByServerCountryReport' as const },
    { name: 'enum.reportType.equityWalletAccountReport' as const, value: 'EquityWalletAccountReport' as const },
    { name: 'enum.reportType.carboPayPaymentSystemReport' as const, value: 'CarboPayPaymentSystemReport' as const },
    { name: 'enum.reportType.RPNPayPaymentSystemReport' as const, value: 'RPNPayPaymentSystemReport' as const },
    { name: 'enum.reportType.nowPayPaymentSystemReport' as const, value: 'NowPayPaymentSystemReport' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Reports.DbReportTypeEnum.cs.
  */
  USER_REPORT_TYPE: [
    { name: 'enum.reportType.closedTrades' as const, value: 'ClosedTrades' as const },
    { name: 'enum.reportType.tradingVolume' as const, value: 'TradingVolume' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbAvgPositionHoldingTimeEnum.cs.
  */
  AVG_POSITION_HOLDING_TIME: [
    { name: 'enum.avgPositionHoldingTime.lessThan1Seconds' as const, value: 'LessThan1Seconds' as const },
    { name: 'enum.avgPositionHoldingTime.from1To10Seconds' as const, value: 'From1To10Seconds' as const },
    { name: 'enum.avgPositionHoldingTime.from10To60Seconds' as const, value: 'From10To60Seconds' as const },
    { name: 'enum.avgPositionHoldingTime.from1To10Minutes' as const, value: 'From1To10Minutes' as const },
    { name: 'enum.avgPositionHoldingTime.from10To60Minutes' as const, value: 'From10To60Minutes' as const },
    { name: 'enum.avgPositionHoldingTime.severalHours' as const, value: 'SeveralHours' as const },
    { name: 'enum.avgPositionHoldingTime.severalDays' as const, value: 'SeveralDays' as const },
    { name: 'enum.avgPositionHoldingTime.severalWeeks' as const, value: 'SeveralWeeks' as const },
    { name: 'enum.avgPositionHoldingTime.severalMonths' as const, value: 'SeveralMonths' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbAvgPositionSizeEnum.cs.
  */
  AVG_POSITION_SIZE: [
    { name: 'enum.avgPositionSize.from1To10Lots' as const, value: 'From1To10Lots' as const },
    { name: 'enum.avgPositionSize.from10To20Lots' as const, value: 'From10To20Lots' as const },
    { name: 'enum.avgPositionSize.from20To50Lots' as const, value: 'From20To50Lots' as const },
    { name: 'enum.avgPositionSize.from50To100Lots' as const, value: 'From50To100Lots' as const },
    { name: 'enum.avgPositionSize.from100To200Lots' as const, value: 'From100To200Lots' as const },
    { name: 'enum.avgPositionSize.from200To500Lots' as const, value: 'From200To500Lots' as const },
    { name: 'enum.avgPositionSize.moreThan500Lots' as const, value: 'MoreThan500Lots' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbClientIntroduce.cs.
  */
  CLIENT_INTRODUCE: [
    { name: 'enum.clientIntroduce.from0To10' as const, value: 'From0To10' as const },
    { name: 'enum.clientIntroduce.from10To50' as const, value: 'From10To50' as const },
    { name: 'enum.clientIntroduce.from50To100' as const, value: 'From50To100' as const },
    { name: 'enum.clientIntroduce.from100To1000' as const, value: 'From100To1000' as const },
    { name: 'enum.clientIntroduce.moreThan1000' as const, value: 'MoreThan1000' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbCompanyTypeEnum.cs.
  */
  COMPANY_TYPE: [
    { name: 'enum.companyType.partnerBusiness' as const, value: 'PartnerBusiness' as const },
    { name: 'enum.companyType.limitedLiabilityCompany' as const, value: 'LimitedLiabilityCompany' as const },
    { name: 'enum.companyType.soleProprietorship' as const, value: 'SoleProprietorship' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbEmploymentStatusEnum.cs.
  */
  EMPLOYMENT_STATUS: [
    { name: 'enum.employmentStatus.employed' as const, value: 'Employed' as const },
    { name: 'enum.employmentStatus.selfEmployed' as const, value: 'SelfEmployed' as const },
    { name: 'enum.employmentStatus.notEmployed' as const, value: 'NotEmployed' as const },
    { name: 'enum.employmentStatus.retirement' as const, value: 'Retirement' as const },
    { name: 'enum.employmentStatus.student' as const, value: 'Student' as const },
    { name: 'enum.employmentStatus.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbHowManyTradesEnum.cs.
  */
  HOW_MANY_TRADES: [
    { name: 'enum.howManyTrades.neverDeal' as const, value: 'NeverDeal' as const },
    { name: 'enum.howManyTrades.tenTimesSmaller' as const, value: 'TenTimesSmaller' as const },
    { name: 'enum.howManyTrades.moreThenTenTimes' as const, value: 'MoreThenTenTimes' as const },
    { name: 'enum.howManyTrades.fortyTimesLess' as const, value: 'FortyTimesLess' as const },
    { name: 'enum.howManyTrades.moreThanFortyTimes' as const, value: 'MoreThanFortyTimes' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbIntroductionChannelEnum.cs.
  */
  INTRODUCTION_CHANNEL: [
    { name: 'enum.introductionChannel.introducingBrokers' as const, value: 'IntroducingBrokers' as const },
    { name: 'enum.introductionChannel.onlineAdvertising' as const, value: 'OnlineAdvertising' as const },
    { name: 'enum.introductionChannel.magazine' as const, value: 'Magazine' as const },
    { name: 'enum.introductionChannel.searchEngine' as const, value: 'SearchEngine' as const },
    { name: 'enum.introductionChannel.companyTour' as const, value: 'CompanyTour' as const },
    { name: 'enum.introductionChannel.fair' as const, value: 'Fair' as const },
    { name: 'enum.introductionChannel.friend' as const, value: 'Friend' as const },
    { name: 'enum.introductionChannel.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbInvestmentPurposeEnum.cs.
  */
  INVESTMENT_PURPOSE: [
    { name: 'enum.investmentPurpose.speculate' as const, value: 'Speculate' as const },
    { name: 'enum.investmentPurpose.hedging' as const, value: 'Hedging' as const },
    { name: 'enum.investmentPurpose.diversification' as const, value: 'Diversification' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbMainActivitiesEnum.cs.
  */
  MAIN_ACTIVITIES: [
    { name: 'enum.mainActivities.tradingPrivateAccounts' as const, value: 'TradingPrivateAccounts' as const },
    { name: 'enum.mainActivities.developmentOfPersonalTradingClients' as const, value: 'DevelopmentOfPersonalTradingClients' as const },
    { name: 'enum.mainActivities.educationAndTraining' as const, value: 'EducationAndTraining' as const },
    { name: 'enum.mainActivities.fundManagers' as const, value: 'FundManagers' as const },
    { name: 'enum.mainActivities.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbMarketSessionEnum.cs.
  */
  MARKET_SESSION: [
    { name: 'enum.marketSession.sydneySession' as const, value: 'SydneySession' as const },
    { name: 'enum.marketSession.tokyoSession' as const, value: 'TokyoSession' as const },
    { name: 'enum.marketSession.londonSession' as const, value: 'LondonSession' as const },
    { name: 'enum.marketSession.NYSession' as const, value: 'NYSession' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbMoneyRangeEnum.cs.
  */
  MONEY_RANGE: [
    { name: 'enum.moneyRange.from0To50' as const, value: 'From0To50' as const },
    { name: 'enum.moneyRange.from50To250' as const, value: 'From50To250' as const },
    { name: 'enum.moneyRange.from250ToMillion' as const, value: 'From250ToMillion' as const },
    { name: 'enum.moneyRange.moreThanMillion' as const, value: 'MoreThanMillion' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbPlanningTradeInstrumentsEnum.cs.
  */
  PLANNING_TRADE_INSTRUMENTS: [
    { name: 'enum.planningTradeInstruments.FXMajors' as const, value: 'FXMajors' as const },
    { name: 'enum.planningTradeInstruments.FXMinorCrosses' as const, value: 'FXMinorCrosses' as const },
    { name: 'enum.planningTradeInstruments.FXExotics' as const, value: 'FXExotics' as const },
    { name: 'enum.planningTradeInstruments.metals' as const, value: 'Metals' as const },
    { name: 'enum.planningTradeInstruments.energy' as const, value: 'Energy' as const },
    { name: 'enum.planningTradeInstruments.indices' as const, value: 'Indices' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbQFormStatusEnum.cs.
  */
  Q_FORM_STATUS: [
    { name: 'enum.QFormStatus.draft' as const, value: 'Draft' as const },
    { name: 'enum.QFormStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.QFormStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.QFormStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.QFormStatus.new' as const, value: 'New' as const },
    { name: 'enum.QFormStatus.terminated' as const, value: 'Terminated' as const },
    { name: 'enum.QFormStatus.completed' as const, value: 'Completed' as const },
    { name: 'enum.QFormStatus.terminationInProgress' as const, value: 'TerminationInProgress' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbQFormStatusEnum.cs.
  */
  PROMOTE_Q_FORM_STATUS: [
    { name: 'enum.QFormStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.QFormStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.QFormStatus.terminated' as const, value: 'Terminated' as const },
    { name: 'enum.QFormStatus.completed' as const, value: 'Completed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbQFormTypeEnum.cs.
  */
  Q_FORM_TYPE: [
    { name: 'enum.QFormType.IIbQForm' as const, value: 'IIbQForm' as const },
    { name: 'enum.QFormType.IUserQForm' as const, value: 'IUserQForm' as const },
    { name: 'enum.QFormType.IMarkupQForm' as const, value: 'IMarkupQForm' as const },
    { name: 'enum.QFormType.IMAMMasterQForm' as const, value: 'IMAMMasterQForm' as const },
    { name: 'enum.QFormType.IMAMInvestorQForm' as const, value: 'IMAMInvestorQForm' as const },
    { name: 'enum.QFormType.IMAMMasterWithLPOAQForm' as const, value: 'IMAMMasterWithLPOAQForm' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbRateYourKnowledgeEnum.cs.
  */
  RATE_YOUR_KNOWLEDGE: [
    { name: 'enum.rateYourKnowledge.dontKnow' as const, value: 'DontKnow' as const },
    { name: 'enum.rateYourKnowledge.low' as const, value: 'Low' as const },
    { name: 'enum.rateYourKnowledge.good' as const, value: 'Good' as const },
    { name: 'enum.rateYourKnowledge.excellent' as const, value: 'Excellent' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbScopeClient.cs.
  */
  SCOPE_CLIENT: [
    { name: 'enum.scopeClient.fundsManager' as const, value: 'FundsManager' as const },
    { name: 'enum.scopeClient.retailClients' as const, value: 'RetailClients' as const },
    { name: 'enum.scopeClient.otherIbs' as const, value: 'OtherIbs' as const },
    { name: 'enum.scopeClient.highNetWorthIndividuals' as const, value: 'HighNetWorthIndividuals' as const },
    { name: 'enum.scopeClient.corporationsInstitutions' as const, value: 'CorporationsInstitutions' as const },
    { name: 'enum.scopeClient.other' as const, value: 'Other' as const },
    { name: 'enum.scopeClient.individualClient' as const, value: 'IndividualClient' as const },
    { name: 'enum.scopeClient.highAssets' as const, value: 'HighAssets' as const },
    { name: 'enum.scopeClient.company' as const, value: 'Company' as const },
    { name: 'enum.scopeClient.otherAgents' as const, value: 'OtherAgents' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbScopeClient.cs.
  */
  MAM_SCOPE_CLIENT: [
    { name: 'enum.scopeClient.fundsManager' as const, value: 'FundsManager' as const },
    { name: 'enum.scopeClient.retailClients' as const, value: 'RetailClients' as const },
    { name: 'enum.scopeClient.otherIbs' as const, value: 'OtherIbs' as const },
    { name: 'enum.scopeClient.highNetWorthIndividuals' as const, value: 'HighNetWorthIndividuals' as const },
    { name: 'enum.scopeClient.corporationsInstitutions' as const, value: 'CorporationsInstitutions' as const },
    { name: 'enum.scopeClient.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbSourceOfFundsEnum.cs.
  */
  SOURCE_OF_FUNDS: [
    { name: 'enum.sourceOfFunds.retain' as const, value: 'Retain' as const },
    { name: 'enum.sourceOfFunds.pension' as const, value: 'Pension' as const },
    { name: 'enum.sourceOfFunds.investmentIncomePropertyInheritance' as const, value: 'InvestmentIncomePropertyInheritance' as const },
    { name: 'enum.sourceOfFunds.propertyInheritance' as const, value: 'PropertyInheritance' as const },
    { name: 'enum.sourceOfFunds.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbTradingMethodEnum.cs.
  */
  TRADING_METHOD: [
    { name: 'enum.tradingMethod.GUItrading' as const, value: 'GUItrading' as const },
    { name: 'enum.tradingMethod.APITrading' as const, value: 'APITrading' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbTradingStyleEnum.cs.
  */
  TRADING_STYLE: [
    { name: 'enum.tradingStyle.fundamentalsTradingWithLongHoldingPeriods' as const, value: 'FundamentalsTradingWithLongHoldingPeriods' as const },
    { name: 'enum.tradingStyle.scalping' as const, value: 'Scalping' as const },
    { name: 'enum.tradingStyle.swingTrading' as const, value: 'SwingTrading' as const },
    { name: 'enum.tradingStyle.HFT' as const, value: 'HFT' as const },
    { name: 'enum.tradingStyle.EA' as const, value: 'EA' as const },
    { name: 'enum.tradingStyle.newsTrading' as const, value: 'NewsTrading' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.QForm.DbYearsRangeEnum.cs.
  */
  YEARS_RANGE: [
    { name: 'enum.yearsRange.noExperience' as const, value: 'NoExperience' as const },
    { name: 'enum.yearsRange.lessThanAYear' as const, value: 'LessThanAYear' as const },
    { name: 'enum.yearsRange.twoFiveYears' as const, value: 'TwoFiveYears' as const },
    { name: 'enum.yearsRange.moreThanFiveYears' as const, value: 'MoreThanFiveYears' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.SenangPay.SenangPayPaymentMethod.cs.
  */
  SENANG_PAY_PAYMENT_METHOD: [
    { name: 'enum.senangPayPaymentMethod.fpx' as const, value: 'Fpx' as const },
    { name: 'enum.senangPayPaymentMethod.boost' as const, value: 'Boost' as const },
    { name: 'enum.senangPayPaymentMethod.touchNGo' as const, value: 'TouchNGo' as const },
    { name: 'enum.senangPayPaymentMethod.grabPay' as const, value: 'GrabPay' as const },
    { name: 'enum.senangPayPaymentMethod.shopeePay' as const, value: 'ShopeePay' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.PaymentAsia.PaymentAsiaAccountType.cs.
  */
  PAYMENT_ASIA_ACCOUNT_TYPE: [
    { name: 'enum.paymentAsiaAccountType.CPF' as const, value: 'CPF' as const },
    { name: 'enum.paymentAsiaAccountType.EMAIL' as const, value: 'EMAIL' as const },
    { name: 'enum.paymentAsiaAccountType.RANDOMKEY' as const, value: 'RANDOMKEY' as const },
    { name: 'enum.paymentAsiaAccountType.PHONE' as const, value: 'PHONE' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Pagsmile.PagsmileAccountType.cs.
  */
  PAGSMILE_ACCOUNT_TYPE: [
    { name: 'enum.pagsmileAccountType.saving' as const, value: 'Saving' as const },
    { name: 'enum.pagsmileAccountType.checking' as const, value: 'Checking' as const },
    { name: 'enum.pagsmileAccountType.debit' as const, value: 'Debit' as const },
    { name: 'enum.pagsmileAccountType.phone' as const, value: 'Phone' as const },
    { name: 'enum.pagsmileAccountType.clabe' as const, value: 'Clabe' as const },
    { name: 'enum.pagsmileAccountType.email' as const, value: 'Email' as const },
    { name: 'enum.pagsmileAccountType.evp' as const, value: 'Evp' as const },
    { name: 'enum.pagsmileAccountType.CPF' as const, value: 'CPF' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.CreateUserFinancialIdentityType.cs.
  */
  CREATE_USER_FINANCIAL_IDENTITY_TYPE: [
    { name: 'enum.createUserFinancialIdentityType.none' as const, value: 'None' as const },
    { name: 'enum.createUserFinancialIdentityType.bankAccount' as const, value: 'BankAccount' as const },
    { name: 'enum.createUserFinancialIdentityType.digitalWallet' as const, value: 'DigitalWallet' as const },
    { name: 'enum.createUserFinancialIdentityType.card' as const, value: 'Card' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbDataChangeRequestStatus.cs.
  */
  DATA_CHANGE_REQUEST_STATUS: [
    { name: 'enum.dataChangeRequestStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.dataChangeRequestStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.dataChangeRequestStatus.declined' as const, value: 'Declined' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbDeclineReasonWithdrawal.cs.
  */
  DECLINE_REASON_WITHDRAWAL: [
    { name: 'enum.declineReasonWithdrawal.incorrectAccountNumber' as const, value: 'IncorrectAccountNumber' as const },
    { name: 'enum.declineReasonWithdrawal.invalidCryptoWalletAccount' as const, value: 'InvalidCryptoWalletAccount' as const },
    { name: 'enum.declineReasonWithdrawal.ptkWalletRegistrationFailed' as const, value: 'PtkWalletRegistrationFailed' as const },
    { name: 'enum.declineReasonWithdrawal.fullNameClarification' as const, value: 'FullNameClarification' as const },
    { name: 'enum.declineReasonWithdrawal.incorrectMethod' as const, value: 'IncorrectMethod' as const },
    { name: 'enum.declineReasonWithdrawal.minimumWithdrawalThresholdIsNotReached' as const, value: 'MinimumWithdrawalThresholdIsNotReached' as const },
    { name: 'enum.declineReasonWithdrawal.cancelledByYourself' as const, value: 'CancelledByYourself' as const },
    { name: 'enum.declineReasonWithdrawal.multipleWithdrawalRequests' as const, value: 'MultipleWithdrawalRequests' as const },
    { name: 'enum.declineReasonWithdrawal.paymentAccountHasBeenLimited' as const, value: 'PaymentAccountHasBeenLimited' as const },
    { name: 'enum.declineReasonWithdrawal.incorrectBeneficiaryAccountName' as const, value: 'IncorrectBeneficiaryAccountName' as const },
    { name: 'enum.declineReasonWithdrawal.incorrectBeneficiaryBankName' as const, value: 'IncorrectBeneficiaryBankName' as const },
    { name: 'enum.declineReasonWithdrawal.bankNotMatchProvidedBankStatement' as const, value: 'BankNotMatchProvidedBankStatement' as const },
    { name: 'enum.declineReasonWithdrawal.accountNotMatchProvidedBankStatement' as const, value: 'AccountNotMatchProvidedBankStatement' as const },
    { name: 'enum.declineReasonWithdrawal.firstTimeWithdrawal' as const, value: 'FirstTimeWithdrawal' as const },
    { name: 'enum.declineReasonWithdrawal.firstTimeCryptoWithdrawal' as const, value: 'FirstTimeCryptoWithdrawal' as const },
    { name: 'enum.declineReasonWithdrawal.missingDepositDocuments' as const, value: 'MissingDepositDocuments' as const },
    { name: 'enum.declineReasonWithdrawal.techIssue' as const, value: 'TechIssue' as const },
    { name: 'enum.declineReasonWithdrawal.submittedAccountNumberUnsupported' as const, value: 'SubmittedAccountNumberUnsupported' as const },
    { name: 'enum.declineReasonWithdrawal.holdForSpecificReason' as const, value: 'HoldForSpecificReason' as const },
    { name: 'enum.declineReasonWithdrawal.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbDepositAdminActionEnum.cs.
  */
  DEPOSIT_ADMIN_ACTION: [
    { name: 'enum.depositAdminAction.none' as const, value: 'None' as const },
    { name: 'enum.depositAdminAction.preAuthorized' as const, value: 'PreAuthorized' as const },
    { name: 'enum.depositAdminAction.postTransaction' as const, value: 'PostTransaction' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbDepositAdminActionEnum.cs.
  */
  USER_BANK_ACCOUNT_DEPOSIT_ADMIN_ACTION: [
    { name: 'enum.depositAdminAction.none' as const, value: 'None' as const },
    { name: 'enum.depositAdminAction.preAuthorized' as const, value: 'PreAuthorized' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbFinancialIdentityType.cs.
  */
  FINANCIAL_IDENTITY_TYPE: [
    { name: 'enum.financialIdentityType.bankAccount' as const, value: 'BankAccount' as const },
    { name: 'enum.financialIdentityType.digitalWallet' as const, value: 'DigitalWallet' as const },
    { name: 'enum.financialIdentityType.card' as const, value: 'Card' as const },
    { name: 'enum.financialIdentityType.cryptoWallet' as const, value: 'CryptoWallet' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPreAuthorizedDocumentType.cs.
  */
  PRE_AUTHORIZED_DOCUMENT_TYPE: [
    { name: 'enum.preAuthorizedDocumentType.proofOfOwnership' as const, value: 'ProofOfOwnership' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPspCallbackStatus.cs.
  */
  PSP_CALLBACK_STATUS: [
    { name: 'enum.pspCallbackStatus.inProgress' as const, value: 'InProgress' as const },
    { name: 'enum.pspCallbackStatus.failed' as const, value: 'Failed' as const },
    { name: 'enum.pspCallbackStatus.completed' as const, value: 'Completed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPspFollowUpReason.cs.
  */
  PSP_FOLLOW_UP_REASON: [
    { name: 'enum.pspFollowUpReason.incorrectBankStatementAndDepositSlip' as const, value: 'IncorrectBankStatementAndDepositSlip' as const },
    { name: 'enum.pspFollowUpReason.incorrectDepositSlip' as const, value: 'IncorrectDepositSlip' as const },
    { name: 'enum.pspFollowUpReason.incorrectBankStatement' as const, value: 'IncorrectBankStatement' as const },
    { name: 'enum.pspFollowUpReason.missingBankStatementAndDepositSlip' as const, value: 'MissingBankStatementAndDepositSlip' as const },
    { name: 'enum.pspFollowUpReason.missingProofOfDeposit' as const, value: 'MissingProofOfDeposit' as const },
    { name: 'enum.pspFollowUpReason.missingBankStatement' as const, value: 'MissingBankStatement' as const },
    { name: 'enum.pspFollowUpReason.bankStatementNotWithinMonth' as const, value: 'BankStatementNotWithinMonth' as const },
    { name: 'enum.pspFollowUpReason.bankStatementIncomplete' as const, value: 'BankStatementIncomplete' as const },
    { name: 'enum.pspFollowUpReason.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPspOperationExecutionType.cs.
  */
  PSP_OPERATION_EXECUTION_TYPE: [
    { name: 'enum.pspOperationExecutionType.automatic' as const, value: 'Automatic' as const },
    { name: 'enum.pspOperationExecutionType.manual' as const, value: 'Manual' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPspOperationFieldVerificationStatus.cs.
  */
  PSP_OPERATION_FIELD_VERIFICATION_STATUS: [
    { name: 'enum.pspOperationFieldVerificationStatus.unknown' as const, value: 'Unknown' as const },
    { name: 'enum.pspOperationFieldVerificationStatus.verified' as const, value: 'Verified' as const },
    { name: 'enum.pspOperationFieldVerificationStatus.failed' as const, value: 'Failed' as const },
    { name: 'enum.pspOperationFieldVerificationStatus.verifiedByPreviousOperationsCompletedByAdmin' as const, value: 'VerifiedByPreviousOperationsCompletedByAdmin' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPspOperationFileItemTypeEnum.cs.
  */
  PSP_OPERATION_FILE_ITEM_TYPE: [
    { name: 'enum.pspOperationFileItemType.depositBankStatement' as const, value: 'DepositBankStatement' as const },
    { name: 'enum.pspOperationFileItemType.depositBankPayslip' as const, value: 'DepositBankPayslip' as const },
    { name: 'enum.pspOperationFileItemType.localDepositBankStatement' as const, value: 'LocalDepositBankStatement' as const },
    { name: 'enum.pspOperationFileItemType.localDepositBankTransfer' as const, value: 'LocalDepositBankTransfer' as const },
    { name: 'enum.pspOperationFileItemType.localDepositBankDocuments' as const, value: 'LocalDepositBankDocuments' as const },
    { name: 'enum.pspOperationFileItemType.wireTransferBankDocuments' as const, value: 'WireTransferBankDocuments' as const },
    { name: 'enum.pspOperationFileItemType.proofAccount' as const, value: 'ProofAccount' as const },
    { name: 'enum.pspOperationFileItemType.proofTransaction' as const, value: 'ProofTransaction' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbPspOperationStatusEnum.cs.
  */
  PSP_OPERATION_STATUS: [
    { name: 'enum.pspOperationStatus.inProgress' as const, value: 'InProgress' as const },
    { name: 'enum.pspOperationStatus.failed' as const, value: 'Failed' as const },
    { name: 'enum.pspOperationStatus.completed' as const, value: 'Completed' as const },
    { name: 'enum.pspOperationStatus.pending' as const, value: 'Pending' as const },
    { name: 'enum.pspOperationStatus.cancelled' as const, value: 'Cancelled' as const },
    { name: 'enum.pspOperationStatus.onHold' as const, value: 'OnHold' as const },
    { name: 'enum.pspOperationStatus.timedOut' as const, value: 'TimedOut' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbUserBankAccountDeclineReason.cs.
  */
  USER_BANK_ACCOUNT_DECLINE_REASON: [
    { name: 'enum.userBankAccountDeclineReason.incorrectBankStatement' as const, value: 'IncorrectBankStatement' as const },
    { name: 'enum.userBankAccountDeclineReason.missingBankStatement' as const, value: 'MissingBankStatement' as const },
    { name: 'enum.userBankAccountDeclineReason.bankStatementNotWithinThreeMonths' as const, value: 'BankStatementNotWithinThreeMonths' as const },
    { name: 'enum.userBankAccountDeclineReason.bankStatementIncomplete' as const, value: 'BankStatementIncomplete' as const },
    { name: 'enum.userBankAccountDeclineReason.others' as const, value: 'Others' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbUserFinancialIdentityDeclineReason.cs.
  */
  USER_FINANCIAL_IDENTITY_DECLINE_REASON: [
    { name: 'enum.userFinancialIdentityDeclineReason.others' as const, value: 'Others' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbUserFinancialIdentityStatus.cs.
  */
  USER_FINANCIAL_IDENTITY_STATUS: [
    { name: 'enum.userFinancialIdentityStatus.created' as const, value: 'Created' as const },
    { name: 'enum.userFinancialIdentityStatus.verified' as const, value: 'Verified' as const },
    { name: 'enum.userFinancialIdentityStatus.rejected' as const, value: 'Rejected' as const },
    { name: 'enum.userFinancialIdentityStatus.actionRequired' as const, value: 'ActionRequired' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DbUserNameAliasDeclineReason.cs.
  */
  USER_NAME_ALIAS_DECLINE_REASON: [
    { name: 'enum.userNameAliasDeclineReason.others' as const, value: 'Others' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.DepositFinancialIdentityType.cs.
  */
  DEPOSIT_FINANCIAL_IDENTITY_TYPE: [
    { name: 'enum.depositFinancialIdentityType.bankAccount' as const, value: 'BankAccount' as const },
    { name: 'enum.depositFinancialIdentityType.digitalWallet' as const, value: 'DigitalWallet' as const },
    { name: 'enum.depositFinancialIdentityType.card' as const, value: 'Card' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.MaskedBankAccountNumberType.cs.
  */
  MASKED_BANK_ACCOUNT_NUMBER_TYPE: [
    { name: 'enum.maskedBankAccountNumberType.all' as const, value: 'All' as const },
    { name: 'enum.maskedBankAccountNumberType.lastFive' as const, value: 'LastFive' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.PspActionAllowedEnum.cs.
  */
  PSP_ACTION_ALLOWED: [
    { name: 'enum.pspActionAllowed.deposit' as const, value: 'Deposit' as const },
    { name: 'enum.pspActionAllowed.withdrawal' as const, value: 'Withdrawal' as const },
    { name: 'enum.pspActionAllowed.all' as const, value: 'All' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.PspCurrencyEnum.cs.
  */
  PSP_CURRENCY: [
    { name: 'enum.pspCurrency.USD' as const, value: 'USD' as const },
    { name: 'enum.pspCurrency.EUR' as const, value: 'EUR' as const },
    { name: 'enum.pspCurrency.IDR' as const, value: 'IDR' as const },
    { name: 'enum.pspCurrency.RMB' as const, value: 'RMB' as const },
    { name: 'enum.pspCurrency.CNY' as const, value: 'CNY' as const },
    { name: 'enum.pspCurrency.CNH' as const, value: 'CNH' as const },
    { name: 'enum.pspCurrency.MYR' as const, value: 'MYR' as const },
    { name: 'enum.pspCurrency.GBP' as const, value: 'GBP' as const },
    { name: 'enum.pspCurrency.THB' as const, value: 'THB' as const },
    { name: 'enum.pspCurrency.VND' as const, value: 'VND' as const },
    { name: 'enum.pspCurrency.BND' as const, value: 'BND' as const },
    { name: 'enum.pspCurrency.BTC' as const, value: 'BTC' as const },
    { name: 'enum.pspCurrency.USC' as const, value: 'USC' as const },
    { name: 'enum.pspCurrency.USDT' as const, value: 'USDT' as const },
    { name: 'enum.pspCurrency.PHP' as const, value: 'PHP' as const },
    { name: 'enum.pspCurrency.NGN' as const, value: 'NGN' as const },
    { name: 'enum.pspCurrency.ZAR' as const, value: 'ZAR' as const },
    { name: 'enum.pspCurrency.INR' as const, value: 'INR' as const },
    { name: 'enum.pspCurrency.BRL' as const, value: 'BRL' as const },
    { name: 'enum.pspCurrency.CLP' as const, value: 'CLP' as const },
    { name: 'enum.pspCurrency.MXN' as const, value: 'MXN' as const },
    { name: 'enum.pspCurrency.COP' as const, value: 'COP' as const },
    { name: 'enum.pspCurrency.PEN' as const, value: 'PEN' as const },
    { name: 'enum.pspCurrency.LAK' as const, value: 'LAK' as const },
    { name: 'enum.pspCurrency.PKR' as const, value: 'PKR' as const },
    { name: 'enum.pspCurrency.BDT' as const, value: 'BDT' as const },
    { name: 'enum.pspCurrency.UZS' as const, value: 'UZS' as const },
    { name: 'enum.pspCurrency.HKD' as const, value: 'HKD' as const },
    { name: 'enum.pspCurrency.ETH' as const, value: 'ETH' as const },
    { name: 'enum.pspCurrency.BNB' as const, value: 'BNB' as const },
    { name: 'enum.pspCurrency.ALL' as const, value: 'ALL' as const },
    { name: 'enum.pspCurrency.AED' as const, value: 'AED' as const },
    { name: 'enum.pspCurrency.ARS' as const, value: 'ARS' as const },
    { name: 'enum.pspCurrency.AZN' as const, value: 'AZN' as const },
    { name: 'enum.pspCurrency.BHD' as const, value: 'BHD' as const },
    { name: 'enum.pspCurrency.BOB' as const, value: 'BOB' as const },
    { name: 'enum.pspCurrency.CDF' as const, value: 'CDF' as const },
    { name: 'enum.pspCurrency.CRC' as const, value: 'CRC' as const },
    { name: 'enum.pspCurrency.DZD' as const, value: 'DZD' as const },
    { name: 'enum.pspCurrency.EGP' as const, value: 'EGP' as const },
    { name: 'enum.pspCurrency.ETB' as const, value: 'ETB' as const },
    { name: 'enum.pspCurrency.GHS' as const, value: 'GHS' as const },
    { name: 'enum.pspCurrency.GTQ' as const, value: 'GTQ' as const },
    { name: 'enum.pspCurrency.JMD' as const, value: 'JMD' as const },
    { name: 'enum.pspCurrency.JOD' as const, value: 'JOD' as const },
    { name: 'enum.pspCurrency.KES' as const, value: 'KES' as const },
    { name: 'enum.pspCurrency.KHR' as const, value: 'KHR' as const },
    { name: 'enum.pspCurrency.KZT' as const, value: 'KZT' as const },
    { name: 'enum.pspCurrency.LKR' as const, value: 'LKR' as const },
    { name: 'enum.pspCurrency.MAD' as const, value: 'MAD' as const },
    { name: 'enum.pspCurrency.MGA' as const, value: 'MGA' as const },
    { name: 'enum.pspCurrency.MMK' as const, value: 'MMK' as const },
    { name: 'enum.pspCurrency.MNT' as const, value: 'MNT' as const },
    { name: 'enum.pspCurrency.MVR' as const, value: 'MVR' as const },
    { name: 'enum.pspCurrency.MWK' as const, value: 'MWK' as const },
    { name: 'enum.pspCurrency.MZN' as const, value: 'MZN' as const },
    { name: 'enum.pspCurrency.NAD' as const, value: 'NAD' as const },
    { name: 'enum.pspCurrency.NIO' as const, value: 'NIO' as const },
    { name: 'enum.pspCurrency.NPR' as const, value: 'NPR' as const },
    { name: 'enum.pspCurrency.OMR' as const, value: 'OMR' as const },
    { name: 'enum.pspCurrency.PYG' as const, value: 'PYG' as const },
    { name: 'enum.pspCurrency.QAR' as const, value: 'QAR' as const },
    { name: 'enum.pspCurrency.RUB' as const, value: 'RUB' as const },
    { name: 'enum.pspCurrency.SAR' as const, value: 'SAR' as const },
    { name: 'enum.pspCurrency.TZS' as const, value: 'TZS' as const },
    { name: 'enum.pspCurrency.TND' as const, value: 'TND' as const },
    { name: 'enum.pspCurrency.TRY' as const, value: 'TRY' as const },
    { name: 'enum.pspCurrency.UGX' as const, value: 'UGX' as const },
    { name: 'enum.pspCurrency.XAF' as const, value: 'XAF' as const },
    { name: 'enum.pspCurrency.YER' as const, value: 'YER' as const },
    { name: 'enum.pspCurrency.UAH' as const, value: 'UAH' as const },
    { name: 'enum.pspCurrency.VES' as const, value: 'VES' as const },
    { name: 'enum.pspCurrency.ZMW' as const, value: 'ZMW' as const },
    { name: 'enum.pspCurrency.ZWL' as const, value: 'ZWL' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.PspFeeModeEnum.cs.
  */
  PSP_FEE_MODE: [
    { name: 'enum.pspFeeMode.membersAreaFee' as const, value: 'MembersAreaFee' as const },
    { name: 'enum.pspFeeMode.paymentSystemFee' as const, value: 'PaymentSystemFee' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.PspOperationPromoteTypeEnum.cs.
  */
  PSP_OPERATION_PROMOTE_TYPE: [
    { name: 'enum.pspOperationPromoteType.commit' as const, value: 'Commit' as const },
    { name: 'enum.pspOperationPromoteType.approve' as const, value: 'Approve' as const },
    { name: 'enum.pspOperationPromoteType.reject' as const, value: 'Reject' as const },
    { name: 'enum.pspOperationPromoteType.refund' as const, value: 'Refund' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.PspOperationUserBankAccountWithdrawalStatus.cs.
  */
  PSP_OPERATION_USER_BANK_ACCOUNT_WITHDRAWAL_STATUS: [
    { name: 'enum.pspOperationUserBankAccountWithdrawalStatus.created' as const, value: 'Created' as const },
    { name: 'enum.pspOperationUserBankAccountWithdrawalStatus.verified' as const, value: 'Verified' as const },
    { name: 'enum.pspOperationUserBankAccountWithdrawalStatus.rejected' as const, value: 'Rejected' as const },
    { name: 'enum.pspOperationUserBankAccountWithdrawalStatus.actionRequired' as const, value: 'ActionRequired' as const },
    { name: 'enum.pspOperationUserBankAccountWithdrawalStatus.mismatched' as const, value: 'Mismatched' as const },
    { name: 'enum.pspOperationUserBankAccountWithdrawalStatus.multipleAccounts' as const, value: 'MultipleAccounts' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.PspTipsPositionEnum.cs.
  */
  PSP_TIPS_POSITION: [
    { name: 'enum.pspTipsPosition.top' as const, value: 'Top' as const },
    { name: 'enum.pspTipsPosition.bottom' as const, value: 'Bottom' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.Base.WithdrawalFinancialIdentityType.cs.
  */
  WITHDRAWAL_FINANCIAL_IDENTITY_TYPE: [
    { name: 'enum.withdrawalFinancialIdentityType.bankAccount' as const, value: 'BankAccount' as const },
    { name: 'enum.withdrawalFinancialIdentityType.cryptoWallet' as const, value: 'CryptoWallet' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Psp.AkontoPay.AkontoPayPaymentModeEnum.cs.
  */
  AKONTO_PAY_PAYMENT_MODE: [
    { name: 'enum.akontoPayPaymentMode.UPI' as const, value: 'UPI' as const },
    { name: 'enum.akontoPayPaymentMode.netbanking' as const, value: 'Netbanking' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Partnership.Activities.PartnershipActivityCategory.cs.
  */
  PARTNERSHIP_ACTIVITY_CATEGORY: [
    { name: 'enum.partnershipActivityCategory.newUserRegistration' as const, value: 'NewUserRegistration' as const },
    { name: 'enum.partnershipActivityCategory.userStatusChange' as const, value: 'UserStatusChange' as const },
    { name: 'enum.partnershipActivityCategory.newTradingAccount' as const, value: 'NewTradingAccount' as const },
    { name: 'enum.partnershipActivityCategory.deposit' as const, value: 'Deposit' as const },
    { name: 'enum.partnershipActivityCategory.withdrawal' as const, value: 'Withdrawal' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbCustomNotificationGroupTypeEnum.cs.
  */
  CUSTOM_NOTIFICATION_GROUP_TYPE: [
    { name: 'enum.customNotificationGroupType.send' as const, value: 'Send' as const },
    { name: 'enum.customNotificationGroupType.doNotSend' as const, value: 'DoNotSend' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbCustomNotificationStatusEnum.cs.
  */
  CUSTOM_NOTIFICATION_STATUS: [
    { name: 'enum.customNotificationStatus.draft' as const, value: 'Draft' as const },
    { name: 'enum.customNotificationStatus.scheduled' as const, value: 'Scheduled' as const },
    { name: 'enum.customNotificationStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.customNotificationStatus.sent' as const, value: 'Sent' as const },
    { name: 'enum.customNotificationStatus.failed' as const, value: 'Failed' as const },
    { name: 'enum.customNotificationStatus.cancelled' as const, value: 'Cancelled' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationCategoryEnum.cs.
  */
  NOTIFICATION_CATEGORY: [
    { name: 'enum.notificationCategory.marketing' as const, value: 'Marketing' as const },
    { name: 'enum.notificationCategory.transactional' as const, value: 'Transactional' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterByEnum.cs.
  */
  NOTIFICATION_GROUP_FILTER_BY: [
    { name: 'enum.notificationGroupFilterBy.country' as const, value: 'Country' as const },
    { name: 'enum.notificationGroupFilterBy.language' as const, value: 'Language' as const },
    { name: 'enum.notificationGroupFilterBy.status' as const, value: 'Status' as const },
    { name: 'enum.notificationGroupFilterBy.clientSourceType' as const, value: 'ClientSourceType' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterOperatorTypeEnum.cs.
  */
  NOTIFICATION_GROUP_FILTER_OPERATOR_TYPE: [
    { name: 'enum.notificationGroupFilterOperatorType.equal' as const, value: 'Equal' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notEqual' as const, value: 'NotEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.greaterThanOrEqual' as const, value: 'GreaterThanOrEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.greaterThan' as const, value: 'GreaterThan' as const },
    { name: 'enum.notificationGroupFilterOperatorType.lessThanOrEqual' as const, value: 'LessThanOrEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.lessThan' as const, value: 'LessThan' as const },
    { name: 'enum.notificationGroupFilterOperatorType.in' as const, value: 'In' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notIn' as const, value: 'NotIn' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNull' as const, value: 'IsNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNullOrEmpty' as const, value: 'IsNullOrEmpty' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNull' as const, value: 'IsNotNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNullOrEmpty' as const, value: 'IsNotNullOrEmpty' as const },
    { name: 'enum.notificationGroupFilterOperatorType.between' as const, value: 'Between' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isTrue' as const, value: 'IsTrue' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isFalse' as const, value: 'IsFalse' as const },
    { name: 'enum.notificationGroupFilterOperatorType.like' as const, value: 'Like' as const },
    { name: 'enum.notificationGroupFilterOperatorType.startWith' as const, value: 'StartWith' as const },
    { name: 'enum.notificationGroupFilterOperatorType.endWith' as const, value: 'EndWith' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterOperatorTypeEnum.cs.
  */
  BOOLEAN_NOTIFICATION_GROUP_FILTER_OPERATOR_TYPE: [
    { name: 'enum.notificationGroupFilterOperatorType.isNull' as const, value: 'IsNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNull' as const, value: 'IsNotNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isTrue' as const, value: 'IsTrue' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isFalse' as const, value: 'IsFalse' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterOperatorTypeEnum.cs.
  */
  ENUM_NOTIFICATION_GROUP_FILTER_OPERATOR_TYPE: [
    { name: 'enum.notificationGroupFilterOperatorType.equal' as const, value: 'Equal' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notEqual' as const, value: 'NotEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.in' as const, value: 'In' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notIn' as const, value: 'NotIn' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNull' as const, value: 'IsNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNull' as const, value: 'IsNotNull' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterOperatorTypeEnum.cs.
  */
  ENUM_AS_STRING_NOTIFICATION_GROUP_FILTER_OPERATOR_TYPE: [
    { name: 'enum.notificationGroupFilterOperatorType.equal' as const, value: 'Equal' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notEqual' as const, value: 'NotEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.in' as const, value: 'In' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notIn' as const, value: 'NotIn' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNull' as const, value: 'IsNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNullOrEmpty' as const, value: 'IsNullOrEmpty' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNull' as const, value: 'IsNotNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNullOrEmpty' as const, value: 'IsNotNullOrEmpty' as const },
    { name: 'enum.notificationGroupFilterOperatorType.like' as const, value: 'Like' as const },
    { name: 'enum.notificationGroupFilterOperatorType.startWith' as const, value: 'StartWith' as const },
    { name: 'enum.notificationGroupFilterOperatorType.endWith' as const, value: 'EndWith' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterOperatorTypeEnum.cs.
  */
  NUMERIC_NOTIFICATION_GROUP_FILTER_OPERATOR_TYPE: [
    { name: 'enum.notificationGroupFilterOperatorType.equal' as const, value: 'Equal' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notEqual' as const, value: 'NotEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.greaterThanOrEqual' as const, value: 'GreaterThanOrEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.greaterThan' as const, value: 'GreaterThan' as const },
    { name: 'enum.notificationGroupFilterOperatorType.lessThanOrEqual' as const, value: 'LessThanOrEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.lessThan' as const, value: 'LessThan' as const },
    { name: 'enum.notificationGroupFilterOperatorType.between' as const, value: 'Between' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterOperatorTypeEnum.cs.
  */
  STRING_NOTIFICATION_GROUP_FILTER_OPERATOR_TYPE: [
    { name: 'enum.notificationGroupFilterOperatorType.equal' as const, value: 'Equal' as const },
    { name: 'enum.notificationGroupFilterOperatorType.notEqual' as const, value: 'NotEqual' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNull' as const, value: 'IsNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNullOrEmpty' as const, value: 'IsNullOrEmpty' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNull' as const, value: 'IsNotNull' as const },
    { name: 'enum.notificationGroupFilterOperatorType.isNotNullOrEmpty' as const, value: 'IsNotNullOrEmpty' as const },
    { name: 'enum.notificationGroupFilterOperatorType.like' as const, value: 'Like' as const },
    { name: 'enum.notificationGroupFilterOperatorType.startWith' as const, value: 'StartWith' as const },
    { name: 'enum.notificationGroupFilterOperatorType.endWith' as const, value: 'EndWith' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupFilterTypeEnum.cs.
  */
  NOTIFICATION_GROUP_FILTER_TYPE: [
    { name: 'enum.notificationGroupFilterType.enum' as const, value: 'Enum' as const },
    { name: 'enum.notificationGroupFilterType.enumAsString' as const, value: 'EnumAsString' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationGroupTypeEnum.cs.
  */
  NOTIFICATION_GROUP_TYPE: [
    { name: 'enum.notificationGroupType.static' as const, value: 'Static' as const },
    { name: 'enum.notificationGroupType.dynamic' as const, value: 'Dynamic' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.DbNotificationMethodEnum.cs.
  */
  NOTIFICATION_METHOD: [
    { name: 'enum.notificationMethod.email' as const, value: 'Email' as const },
    { name: 'enum.notificationMethod.sms' as const, value: 'Sms' as const },
    { name: 'enum.notificationMethod.push' as const, value: 'Push' as const },
    { name: 'enum.notificationMethod.popup' as const, value: 'Popup' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notes.DbActionTypeEnum.cs.
  */
  ACTION_TYPE: [
    { name: 'enum.actionType.promote' as const, value: 'Promote' as const },
    { name: 'enum.actionType.lock' as const, value: 'Lock' as const },
    { name: 'enum.actionType.archive' as const, value: 'Archive' as const },
    { name: 'enum.actionType.show' as const, value: 'Show' as const },
    { name: 'enum.actionType.activate' as const, value: 'Activate' as const },
    { name: 'enum.actionType.note' as const, value: 'Note' as const },
    { name: 'enum.actionType.create' as const, value: 'Create' as const },
    { name: 'enum.actionType.update' as const, value: 'Update' as const },
    { name: 'enum.actionType.followUp' as const, value: 'FollowUp' as const },
    { name: 'enum.actionType.tradingPlatformAction' as const, value: 'TradingPlatformAction' as const },
    { name: 'enum.actionType.background' as const, value: 'Background' as const },
    { name: 'enum.actionType.permissionAndAccess' as const, value: 'PermissionAndAccess' as const },
    { name: 'enum.actionType.security' as const, value: 'Security' as const },
    { name: 'enum.actionType.delete' as const, value: 'Delete' as const },
    { name: 'enum.actionType.reprocess' as const, value: 'Reprocess' as const },
    { name: 'enum.actionType.callback' as const, value: 'Callback' as const },
    { name: 'enum.actionType.state' as const, value: 'State' as const },
    { name: 'enum.actionType.sendToVerification' as const, value: 'SendToVerification' as const },
    { name: 'enum.actionType.subscription' as const, value: 'Subscription' as const },
    { name: 'enum.actionType.localization' as const, value: 'Localization' as const },
    { name: 'enum.actionType.request' as const, value: 'Request' as const },
    { name: 'enum.actionType.response' as const, value: 'Response' as const },
    { name: 'enum.actionType.comment' as const, value: 'Comment' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notes.DbItemTypeEnum.cs.
  */
  ITEM_TYPE: [
    { name: 'enum.itemType.user' as const, value: 'User' as const },
    { name: 'enum.itemType.QForm' as const, value: 'QForm' as const },
    { name: 'enum.itemType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.itemType.userDocument' as const, value: 'UserDocument' as const },
    { name: 'enum.itemType.issue' as const, value: 'Issue' as const },
    { name: 'enum.itemType.component' as const, value: 'Component' as const },
    { name: 'enum.itemType.notificationTemplate' as const, value: 'NotificationTemplate' as const },
    { name: 'enum.itemType.pspOperation' as const, value: 'PspOperation' as const },
    { name: 'enum.itemType.externalJob' as const, value: 'ExternalJob' as const },
    { name: 'enum.itemType.tradingAccountType' as const, value: 'TradingAccountType' as const },
    { name: 'enum.itemType.tradingAccountTypeCategory' as const, value: 'TradingAccountTypeCategory' as const },
    { name: 'enum.itemType.tradingGroup' as const, value: 'TradingGroup' as const },
    { name: 'enum.itemType.salesUser' as const, value: 'SalesUser' as const },
    { name: 'enum.itemType.businessManager' as const, value: 'BusinessManager' as const },
    { name: 'enum.itemType.userBankAccount' as const, value: 'UserBankAccount' as const },
    { name: 'enum.itemType.shortLink' as const, value: 'ShortLink' as const },
    { name: 'enum.itemType.mamMasterAccount' as const, value: 'MamMasterAccount' as const },
    { name: 'enum.itemType.group' as const, value: 'Group' as const },
    { name: 'enum.itemType.autoAssignmentRule' as const, value: 'AutoAssignmentRule' as const },
    { name: 'enum.itemType.bannerConfiguration' as const, value: 'BannerConfiguration' as const },
    { name: 'enum.itemType.urlDomain' as const, value: 'UrlDomain' as const },
    { name: 'enum.itemType.userDigitalWalletAccount' as const, value: 'UserDigitalWalletAccount' as const },
    { name: 'enum.itemType.onboardingConfiguration' as const, value: 'OnboardingConfiguration' as const },
    { name: 'enum.itemType.userCard' as const, value: 'UserCard' as const },
    { name: 'enum.itemType.tradingBonusLink' as const, value: 'TradingBonusLink' as const },
    { name: 'enum.itemType.notificationGroup' as const, value: 'NotificationGroup' as const },
    { name: 'enum.itemType.kytVerification' as const, value: 'KytVerification' as const },
    { name: 'enum.itemType.kytVerificationOperation' as const, value: 'KytVerificationOperation' as const },
    { name: 'enum.itemType.tradingSymbol' as const, value: 'TradingSymbol' as const },
    { name: 'enum.itemType.metaServer' as const, value: 'MetaServer' as const },
    { name: 'enum.itemType.userNameAlias' as const, value: 'UserNameAlias' as const },
    { name: 'enum.itemType.videoConfiguration' as const, value: 'VideoConfiguration' as const },
    { name: 'enum.itemType.customNotification' as const, value: 'CustomNotification' as const },
    { name: 'enum.itemType.companyAccount' as const, value: 'CompanyAccount' as const },
    { name: 'enum.itemType.companyTransfer' as const, value: 'CompanyTransfer' as const },
    { name: 'enum.itemType.contest' as const, value: 'Contest' as const },
    { name: 'enum.itemType.legalDocument' as const, value: 'LegalDocument' as const },
    { name: 'enum.itemType.emailTemplate' as const, value: 'EmailTemplate' as const },
    { name: 'enum.itemType.paymentSystemConsent' as const, value: 'PaymentSystemConsent' as const },
    { name: 'enum.itemType.trustedDevice' as const, value: 'TrustedDevice' as const },
    { name: 'enum.itemType.dataChangeRequest' as const, value: 'DataChangeRequest' as const },
    { name: 'enum.itemType.userCryptoWalletAccount' as const, value: 'UserCryptoWalletAccount' as const },
    { name: 'enum.itemType.bank' as const, value: 'Bank' as const },
    { name: 'enum.itemType.digitalWallet' as const, value: 'DigitalWallet' as const },
    { name: 'enum.itemType.loyaltyProgram' as const, value: 'LoyaltyProgram' as const },
    { name: 'enum.itemType.tradingPlatformBrandingSettings' as const, value: 'TradingPlatformBrandingSettings' as const },
    { name: 'enum.itemType.customPushNotification' as const, value: 'CustomPushNotification' as const },
    { name: 'enum.itemType.notificationCategory' as const, value: 'NotificationCategory' as const },
    { name: 'enum.itemType.importItem' as const, value: 'ImportItem' as const },
    { name: 'enum.itemType.faq' as const, value: 'Faq' as const },
    { name: 'enum.itemType.clientSideTranslation' as const, value: 'ClientSideTranslation' as const },
    { name: 'enum.itemType.documentConfiguration' as const, value: 'DocumentConfiguration' as const },
    { name: 'enum.itemType.legalTradingPlatform' as const, value: 'LegalTradingPlatform' as const },
    { name: 'enum.itemType.marketingBannerCategory' as const, value: 'MarketingBannerCategory' as const },
    { name: 'enum.itemType.kytVerificationWithdrawalAttempt' as const, value: 'KytVerificationWithdrawalAttempt' as const },
    { name: 'enum.itemType.customTag' as const, value: 'CustomTag' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.MAM.DbMamAllocationModeEnum.cs.
  */
  MAM_ALLOCATION_MODE: [
    { name: 'enum.mamAllocationMode.equity' as const, value: 'Equity' as const },
    { name: 'enum.mamAllocationMode.lot' as const, value: 'Lot' as const },
    { name: 'enum.mamAllocationMode.balance' as const, value: 'Balance' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.MAM.DbMamMasterAccountStatusEnum.cs.
  */
  MAM_MASTER_ACCOUNT_STATUS: [
    { name: 'enum.mamMasterAccountStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.mamMasterAccountStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.mamMasterAccountStatus.draft' as const, value: 'Draft' as const },
    { name: 'enum.mamMasterAccountStatus.inProgress' as const, value: 'InProgress' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.MAM.DbMamMasterAccountStatusEnum.cs.
  */
  PROMOTE_MAM_MASTER_ACCOUNT_STATUS: [
    { name: 'enum.mamMasterAccountStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.mamMasterAccountStatus.approved' as const, value: 'Approved' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyOperationCategoryEnum.cs.
  */
  LOYALTY_OPERATION_CATEGORY: [
    { name: 'enum.loyaltyOperationCategory.manualAdjustment' as const, value: 'ManualAdjustment' as const },
    { name: 'enum.loyaltyOperationCategory.depositProcessor' as const, value: 'DepositProcessor' as const },
    { name: 'enum.loyaltyOperationCategory.tradingVolumeProcessor' as const, value: 'TradingVolumeProcessor' as const },
    { name: 'enum.loyaltyOperationCategory.redeemRequest' as const, value: 'RedeemRequest' as const },
    { name: 'enum.loyaltyOperationCategory.netDepositProcessor' as const, value: 'NetDepositProcessor' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyOperationStatusEnum.cs.
  */
  LOYALTY_OPERATION_STATUS: [
    { name: 'enum.loyaltyOperationStatus.pending' as const, value: 'Pending' as const },
    { name: 'enum.loyaltyOperationStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.loyaltyOperationStatus.insufficientBalance' as const, value: 'InsufficientBalance' as const },
    { name: 'enum.loyaltyOperationStatus.insufficientBlockedBalance' as const, value: 'InsufficientBlockedBalance' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyOperationTypeEnum.cs.
  */
  LOYALTY_OPERATION_TYPE: [
    { name: 'enum.loyaltyOperationType.deposit' as const, value: 'Deposit' as const },
    { name: 'enum.loyaltyOperationType.withdrawal' as const, value: 'Withdrawal' as const },
    { name: 'enum.loyaltyOperationType.block' as const, value: 'Block' as const },
    { name: 'enum.loyaltyOperationType.unblock' as const, value: 'Unblock' as const },
    { name: 'enum.loyaltyOperationType.correction' as const, value: 'Correction' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyParticipantRedeemStatusEnum.cs.
  */
  LOYALTY_PARTICIPANT_REDEEM_STATUS: [
    { name: 'enum.loyaltyParticipantRedeemStatus.new' as const, value: 'New' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.pending' as const, value: 'Pending' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.cancelling' as const, value: 'Cancelling' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.cancelled' as const, value: 'Cancelled' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.approving' as const, value: 'Approving' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.rejecting' as const, value: 'Rejecting' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.rejected' as const, value: 'Rejected' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.delivering' as const, value: 'Delivering' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.delivered' as const, value: 'Delivered' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.undelivered' as const, value: 'Undelivered' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.failed' as const, value: 'Failed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyParticipantRedeemStatusEnum.cs.
  */
  DELIVERING_PROMOTE_LOYALTY_PARTICIPANT_REDEEM_STATUS: [
    { name: 'enum.loyaltyParticipantRedeemStatus.delivering' as const, value: 'Delivering' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.delivered' as const, value: 'Delivered' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.undelivered' as const, value: 'Undelivered' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyParticipantRedeemStatusEnum.cs.
  */
  PENDING_PROMOTE_LOYALTY_PARTICIPANT_REDEEM_STATUS: [
    { name: 'enum.loyaltyParticipantRedeemStatus.pending' as const, value: 'Pending' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.approving' as const, value: 'Approving' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.rejecting' as const, value: 'Rejecting' as const },
    { name: 'enum.loyaltyParticipantRedeemStatus.delivering' as const, value: 'Delivering' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyProcessorTypeEnum.cs.
  */
  LOYALTY_PROCESSOR_TYPE: [
    { name: 'enum.loyaltyProcessorType.tradingVolume' as const, value: 'TradingVolume' as const },
    { name: 'enum.loyaltyProcessorType.deposit' as const, value: 'Deposit' as const },
    { name: 'enum.loyaltyProcessorType.netDeposit' as const, value: 'NetDeposit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyProgramRedeemAccountTypeEnum.cs.
  */
  LOYALTY_PROGRAM_REDEEM_ACCOUNT_TYPE: [
    { name: 'enum.loyaltyProgramRedeemAccountType.walletAccount' as const, value: 'WalletAccount' as const },
    { name: 'enum.loyaltyProgramRedeemAccountType.tradingAccount' as const, value: 'TradingAccount' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.LoyaltyProgram.DbLoyaltyRedeemTypeEnum.cs.
  */
  LOYALTY_REDEEM_TYPE: [
    { name: 'enum.loyaltyRedeemType.balance' as const, value: 'Balance' as const },
    { name: 'enum.loyaltyRedeemType.credit' as const, value: 'Credit' as const },
    { name: 'enum.loyaltyRedeemType.material' as const, value: 'Material' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Logging.DbLoginHistoryTypeEnum.cs.
  */
  LOGIN_HISTORY_TYPE: [
    { name: 'enum.loginHistoryType.login' as const, value: 'Login' as const },
    { name: 'enum.loginHistoryType.dropIn' as const, value: 'DropIn' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.DbLinkEventTypeEnum.cs.
  */
  LINK_EVENT_TYPE: [
    { name: 'enum.linkEventType.resetPinCode' as const, value: 'ResetPinCode' as const },
    { name: 'enum.linkEventType.forgotPassword' as const, value: 'ForgotPassword' as const },
    { name: 'enum.linkEventType.changeEmail' as const, value: 'ChangeEmail' as const },
    { name: 'enum.linkEventType.confirmEmailChange' as const, value: 'ConfirmEmailChange' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.DbShortLinkStatusEnum.cs.
  */
  SHORT_LINK_STATUS: [
    { name: 'enum.shortLinkStatus.draft' as const, value: 'Draft' as const },
    { name: 'enum.shortLinkStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.shortLinkStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.shortLinkStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.shortLinkStatus.expired' as const, value: 'Expired' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.DbShortLinkStatusEnum.cs.
  */
  EXPIRED_PROMOTE_SHORT_LINK_STATUS: [
    { name: 'enum.shortLinkStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.shortLinkStatus.expired' as const, value: 'Expired' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.DbShortLinkStatusEnum.cs.
  */
  PROMOTE_SHORT_LINK_STATUS: [
    { name: 'enum.shortLinkStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.shortLinkStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.shortLinkStatus.expired' as const, value: 'Expired' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.DbShortLinkTypeEnum.cs.
  */
  SHORT_LINK_TYPE: [
    { name: 'enum.shortLinkType.unknown' as const, value: 'Unknown' as const },
    { name: 'enum.shortLinkType.ibInvitation' as const, value: 'IbInvitation' as const },
    { name: 'enum.shortLinkType.salesInvitation' as const, value: 'SalesInvitation' as const },
    { name: 'enum.shortLinkType.advCampaign' as const, value: 'AdvCampaign' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.DbShortLinkVersionEnum.cs.
  */
  SHORT_LINK_VERSION: [
    { name: 'enum.shortLinkVersion.version_1' as const, value: 'Version_1' as const },
    { name: 'enum.shortLinkVersion.version_2' as const, value: 'Version_2' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Links.ShortLinkDestinationTypeEnum.cs.
  */
  SHORT_LINK_DESTINATION_TYPE: [
    { name: 'enum.shortLinkDestinationType.homePage' as const, value: 'HomePage' as const },
    { name: 'enum.shortLinkDestinationType.membersArea' as const, value: 'MembersArea' as const },
    { name: 'enum.shortLinkDestinationType.partnershipPortal' as const, value: 'PartnershipPortal' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyt.DbKytVerificationApiLogTypeEnum.cs.
  */
  KYT_VERIFICATION_API_LOG_TYPE: [
    { name: 'enum.kytVerificationApiLogType.user' as const, value: 'User' as const },
    { name: 'enum.kytVerificationApiLogType.transfer' as const, value: 'Transfer' as const },
    { name: 'enum.kytVerificationApiLogType.withdrawalAttempt' as const, value: 'WithdrawalAttempt' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyt.DbKytVerificationRiskScoreEnum.cs.
  */
  KYT_VERIFICATION_RISK_SCORE: [
    { name: 'enum.kytVerificationRiskScore.low' as const, value: 'Low' as const },
    { name: 'enum.kytVerificationRiskScore.medium' as const, value: 'Medium' as const },
    { name: 'enum.kytVerificationRiskScore.high' as const, value: 'High' as const },
    { name: 'enum.kytVerificationRiskScore.severe' as const, value: 'Severe' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyt.DbKytVerificationStatusEnum.cs.
  */
  KYT_VERIFICATION_STATUS: [
    { name: 'enum.kytVerificationStatus.initiated' as const, value: 'Initiated' as const },
    { name: 'enum.kytVerificationStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.kytVerificationStatus.finished' as const, value: 'Finished' as const },
    { name: 'enum.kytVerificationStatus.error' as const, value: 'Error' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyc.DbKycVerificationCallbackTypeEnum.cs.
  */
  KYC_VERIFICATION_CALLBACK_TYPE: [
    { name: 'enum.kycVerificationCallbackType.applicantCreated' as const, value: 'ApplicantCreated' as const },
    { name: 'enum.kycVerificationCallbackType.verificationPending' as const, value: 'VerificationPending' as const },
    { name: 'enum.kycVerificationCallbackType.applicantPrechecked' as const, value: 'ApplicantPrechecked' as const },
    { name: 'enum.kycVerificationCallbackType.applicantReviewed' as const, value: 'ApplicantReviewed' as const },
    { name: 'enum.kycVerificationCallbackType.infoUpdated' as const, value: 'InfoUpdated' as const },
    { name: 'enum.kycVerificationCallbackType.verificationPaused' as const, value: 'VerificationPaused' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyc.DbKycVerificationStatusEnum.cs.
  */
  KYC_VERIFICATION_STATUS: [
    { name: 'enum.kycVerificationStatus.initiated' as const, value: 'Initiated' as const },
    { name: 'enum.kycVerificationStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.kycVerificationStatus.approved' as const, value: 'Approved' as const },
    { name: 'enum.kycVerificationStatus.declined' as const, value: 'Declined' as const },
    { name: 'enum.kycVerificationStatus.error' as const, value: 'Error' as const },
    { name: 'enum.kycVerificationStatus.retry' as const, value: 'Retry' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyc.DbKycVerificationTypeEnum.cs.
  */
  KYC_VERIFICATION_TYPE: [
    { name: 'enum.kycVerificationType.newUser' as const, value: 'NewUser' as const },
    { name: 'enum.kycVerificationType.registeredUser' as const, value: 'RegisteredUser' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Kyc.DbUnverifiedUsersBatchStatusEnum.cs.
  */
  UNVERIFIED_USERS_BATCH_STATUS: [
    { name: 'enum.unverifiedUsersBatchStatus.created' as const, value: 'Created' as const },
    { name: 'enum.unverifiedUsersBatchStatus.inProcess' as const, value: 'InProcess' as const },
    { name: 'enum.unverifiedUsersBatchStatus.completed' as const, value: 'Completed' as const },
    { name: 'enum.unverifiedUsersBatchStatus.failed' as const, value: 'Failed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Issue.DbIssueStatusEnum.cs.
  */
  ISSUE_STATUS: [
    { name: 'enum.issueStatus.open' as const, value: 'Open' as const },
    { name: 'enum.issueStatus.inProgress' as const, value: 'InProgress' as const },
    { name: 'enum.issueStatus.resolved' as const, value: 'Resolved' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Issue.DbIssueTypeEnum.cs.
  */
  ISSUE_TYPE: [
    { name: 'enum.issueType.accountOpeningMatter' as const, value: 'AccountOpeningMatter' as const },
    { name: 'enum.issueType.accountMatter' as const, value: 'AccountMatter' as const },
    { name: 'enum.issueType.fundsMatter' as const, value: 'FundsMatter' as const },
    { name: 'enum.issueType.ITsupport' as const, value: 'ITsupport' as const },
    { name: 'enum.issueType.others' as const, value: 'Others' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbFileImportItemTypeEnum.cs.
  */
  FILE_IMPORT_ITEM_TYPE: [
    { name: 'enum.fileImportItemType.tradingSymbol' as const, value: 'TradingSymbol' as const },
    { name: 'enum.fileImportItemType.distributionList' as const, value: 'DistributionList' as const },
    { name: 'enum.fileImportItemType.user' as const, value: 'User' as const },
    { name: 'enum.fileImportItemType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.fileImportItemType.ibSettings' as const, value: 'IbSettings' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbFileImportItemTypeEnum.cs.
  */
  MAIN_FILE_IMPORT_ITEM_TYPE: [
    { name: 'enum.fileImportItemType.user' as const, value: 'User' as const },
    { name: 'enum.fileImportItemType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.fileImportItemType.ibSettings' as const, value: 'IbSettings' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbImageClientTypeEnum.cs.
  */
  IMAGE_CLIENT_TYPE: [
    { name: 'enum.imageClientType.membersAreaDesktop' as const, value: 'MembersAreaDesktop' as const },
    { name: 'enum.imageClientType.tradingPlatformDesktop' as const, value: 'TradingPlatformDesktop' as const },
    { name: 'enum.imageClientType.tradingPlatformMobile' as const, value: 'TradingPlatformMobile' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbImageItemTypeEnum.cs.
  */
  IMAGE_ITEM_TYPE: [
    { name: 'enum.imageItemType.notificationTemplate' as const, value: 'NotificationTemplate' as const },
    { name: 'enum.imageItemType.tradingPlatformBrandingSettings' as const, value: 'TradingPlatformBrandingSettings' as const },
    { name: 'enum.imageItemType.loyaltyProgramRedeem' as const, value: 'LoyaltyProgramRedeem' as const },
    { name: 'enum.imageItemType.legalTradingPlatform' as const, value: 'LegalTradingPlatform' as const },
    { name: 'enum.imageItemType.videoConfiguration' as const, value: 'VideoConfiguration' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbImageSizeTypeEnum.cs.
  */
  IMAGE_SIZE_TYPE: [
    { name: 'enum.imageSizeType.small' as const, value: 'Small' as const },
    { name: 'enum.imageSizeType.middle' as const, value: 'Middle' as const },
    { name: 'enum.imageSizeType.fullWidth' as const, value: 'FullWidth' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbImportItemRecordStatusEnum.cs.
  */
  IMPORT_ITEM_RECORD_STATUS: [
    { name: 'enum.importItemRecordStatus.success' as const, value: 'Success' as const },
    { name: 'enum.importItemRecordStatus.failed' as const, value: 'Failed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbImportItemStatusEnum.cs.
  */
  IMPORT_ITEM_STATUS: [
    { name: 'enum.importItemStatus.new' as const, value: 'New' as const },
    { name: 'enum.importItemStatus.csvProcessing' as const, value: 'CsvProcessing' as const },
    { name: 'enum.importItemStatus.readyForPreImportProcessing' as const, value: 'ReadyForPreImportProcessing' as const },
    { name: 'enum.importItemStatus.preImportProcessing' as const, value: 'PreImportProcessing' as const },
    { name: 'enum.importItemStatus.readyForExecuting' as const, value: 'ReadyForExecuting' as const },
    { name: 'enum.importItemStatus.preExecuting' as const, value: 'PreExecuting' as const },
    { name: 'enum.importItemStatus.executing' as const, value: 'Executing' as const },
    { name: 'enum.importItemStatus.finished' as const, value: 'Finished' as const },
    { name: 'enum.importItemStatus.failed' as const, value: 'Failed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.FileImport.DbImportModeEnum.cs.
  */
  IMPORT_MODE: [
    { name: 'enum.importMode.insert' as const, value: 'Insert' as const },
    { name: 'enum.importMode.update' as const, value: 'Update' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbDeclineReasonEnum.cs.
  */
  DECLINE_REASON: [
    { name: 'enum.declineReason.fullNameClarification' as const, value: 'FullNameClarification' as const },
    { name: 'enum.declineReason.clientClarification' as const, value: 'ClientClarification' as const },
    { name: 'enum.declineReason.addressClarification' as const, value: 'AddressClarification' as const },
    { name: 'enum.declineReason.dateOfBirthClarification' as const, value: 'DateOfBirthClarification' as const },
    { name: 'enum.declineReason.incompleteProfile' as const, value: 'IncompleteProfile' as const },
    { name: 'enum.declineReason.blurryDocuments' as const, value: 'BlurryDocuments' as const },
    { name: 'enum.declineReason.documentsRequest' as const, value: 'DocumentsRequest' as const },
    { name: 'enum.declineReason.expiredID' as const, value: 'ExpiredID' as const },
    { name: 'enum.declineReason.frontSideCopyIDRequest' as const, value: 'FrontSideCopyIDRequest' as const },
    { name: 'enum.declineReason.backSideCopyIDRequest' as const, value: 'BackSideCopyIDRequest' as const },
    { name: 'enum.declineReason.coloredIDRequest' as const, value: 'ColoredIDRequest' as const },
    { name: 'enum.declineReason.incorrectDocumentNumber' as const, value: 'IncorrectDocumentNumber' as const },
    { name: 'enum.declineReason.proofOfResidencyRequest' as const, value: 'ProofOfResidencyRequest' as const },
    { name: 'enum.declineReason.notUnderClientName' as const, value: 'NotUnderClientName' as const },
    { name: 'enum.declineReason.notDatedWithin6Months' as const, value: 'NotDatedWithin6Months' as const },
    { name: 'enum.declineReason.multipleEmailRegistered' as const, value: 'MultipleEmailRegistered' as const },
    { name: 'enum.declineReason.identityClarification' as const, value: 'IdentityClarification' as const },
    { name: 'enum.declineReason.kycVerificationFailed' as const, value: 'KycVerificationFailed' as const },
    { name: 'enum.declineReason.incorrectSignature' as const, value: 'IncorrectSignature' as const },
    { name: 'enum.declineReason.bankCardRequest' as const, value: 'BankCardRequest' as const },
    { name: 'enum.declineReason.others' as const, value: 'Others' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbDocumentStatusEnum.cs.
  */
  DOCUMENT_STATUS: [
    { name: 'enum.documentStatus.toVerify' as const, value: 'ToVerify' as const },
    { name: 'enum.documentStatus.approve' as const, value: 'Approve' as const },
    { name: 'enum.documentStatus.reject' as const, value: 'Reject' as const },
    { name: 'enum.documentStatus.inProcess' as const, value: 'InProcess' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbDocumentStatusEnum.cs.
  */
  PROMOTE_DOCUMENT_STATUS: [
    { name: 'enum.documentStatus.approve' as const, value: 'Approve' as const },
    { name: 'enum.documentStatus.reject' as const, value: 'Reject' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbDocumentSubTypeEnum.cs.
  */
  DOCUMENT_SUB_TYPE: [
    { name: 'enum.documentSubType.frontSide' as const, value: 'FrontSide' as const },
    { name: 'enum.documentSubType.backSide' as const, value: 'BackSide' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbFaqCategoryEnum.cs.
  */
  FAQ_CATEGORY: [
    { name: 'enum.faqCategory.registration' as const, value: 'Registration' as const },
    { name: 'enum.faqCategory.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.faqCategory.depositAndWithdrawal' as const, value: 'DepositAndWithdrawal' as const },
    { name: 'enum.faqCategory.metaTrader4' as const, value: 'MetaTrader4' as const },
    { name: 'enum.faqCategory.forex' as const, value: 'Forex' as const },
    { name: 'enum.faqCategory.forexTrading' as const, value: 'ForexTrading' as const },
    { name: 'enum.faqCategory.socialTrading' as const, value: 'SocialTrading' as const },
    { name: 'enum.faqCategory.KYC' as const, value: 'KYC' as const },
    { name: 'enum.faqCategory.metaTrader5' as const, value: 'MetaTrader5' as const },
    { name: 'enum.faqCategory.edgeTradingPlatform' as const, value: 'EdgeTradingPlatform' as const },
    { name: 'enum.faqCategory.edgeTradingMobileApplication' as const, value: 'EdgeTradingMobileApplication' as const },
    { name: 'enum.faqCategory.edgeTradingWebTrader' as const, value: 'EdgeTradingWebTrader' as const },
    { name: 'enum.faqCategory.contest' as const, value: 'Contest' as const },
    { name: 'enum.faqCategory.loyaltyProgram' as const, value: 'LoyaltyProgram' as const },
    { name: 'enum.faqCategory.oneTimePassword' as const, value: 'OneTimePassword' as const },
    { name: 'enum.faqCategory.MAM' as const, value: 'MAM' as const },
    { name: 'enum.faqCategory.accountType' as const, value: 'AccountType' as const },
    { name: 'enum.faqCategory.partnership' as const, value: 'Partnership' as const },
    { name: 'enum.faqCategory.leverageAndMargin' as const, value: 'LeverageAndMargin' as const },
    { name: 'enum.faqCategory.tradingHours' as const, value: 'TradingHours' as const },
    { name: 'enum.faqCategory.orderTypes' as const, value: 'OrderTypes' as const },
    { name: 'enum.faqCategory.spreadsAndCommissions' as const, value: 'SpreadsAndCommissions' as const },
    { name: 'enum.faqCategory.riskManagement' as const, value: 'RiskManagement' as const },
    { name: 'enum.faqCategory.tradingStrategy' as const, value: 'TradingStrategy' as const },
    { name: 'enum.faqCategory.technicalAnalysis' as const, value: 'TechnicalAnalysis' as const },
    { name: 'enum.faqCategory.fundamentalAnalysis' as const, value: 'FundamentalAnalysis' as const },
    { name: 'enum.faqCategory.tradingTools' as const, value: 'TradingTools' as const },
    { name: 'enum.faqCategory.economicCalendar' as const, value: 'EconomicCalendar' as const },
    { name: 'enum.faqCategory.chartingTools' as const, value: 'ChartingTools' as const },
    { name: 'enum.faqCategory.regulatoryCompliance' as const, value: 'RegulatoryCompliance' as const },
    { name: 'enum.faqCategory.securityFunds' as const, value: 'SecurityFunds' as const },
    { name: 'enum.faqCategory.bonusProgram' as const, value: 'BonusProgram' as const },
    { name: 'enum.faqCategory.tradingSignals' as const, value: 'TradingSignals' as const },
    { name: 'enum.faqCategory.marketNewsAndUpdates' as const, value: 'MarketNewsAndUpdates' as const },
    { name: 'enum.faqCategory.apiTrading' as const, value: 'ApiTrading' as const },
    { name: 'enum.faqCategory.automatedTrading' as const, value: 'AutomatedTrading' as const },
    { name: 'enum.faqCategory.tradingTutorialsAndEducation' as const, value: 'TradingTutorialsAndEducation' as const },
    { name: 'enum.faqCategory.promotions' as const, value: 'Promotions' as const },
    { name: 'enum.faqCategory.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbFileTypeEnum.cs.
  */
  FILE_TYPE: [
    { name: 'enum.fileType.unknown' as const, value: 'Unknown' as const },
    { name: 'enum.fileType.image' as const, value: 'Image' as const },
    { name: 'enum.fileType.pdf' as const, value: 'Pdf' as const },
    { name: 'enum.fileType.html' as const, value: 'Html' as const },
    { name: 'enum.fileType.excel' as const, value: 'Excel' as const },
    { name: 'enum.fileType.csv' as const, value: 'Csv' as const },
    { name: 'enum.fileType.zip' as const, value: 'Zip' as const },
    { name: 'enum.fileType.word' as const, value: 'Word' as const },
    { name: 'enum.fileType.text' as const, value: 'Text' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbLegalPlatformSectionTypeEnum.cs.
  */
  LEGAL_PLATFORM_SECTION_TYPE: [
    { name: 'enum.legalPlatformSectionType.platforms' as const, value: 'Platforms' as const },
    { name: 'enum.legalPlatformSectionType.tools' as const, value: 'Tools' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbLegalPlatformTypeEnum.cs.
  */
  LEGAL_PLATFORM_TYPE: [
    { name: 'enum.legalPlatformType.downloadMT4' as const, value: 'DownloadMT4' as const },
    { name: 'enum.legalPlatformType.MT4Android' as const, value: 'MT4Android' as const },
    { name: 'enum.legalPlatformType.MT4iOS' as const, value: 'MT4iOS' as const },
    { name: 'enum.legalPlatformType.MT4Web' as const, value: 'MT4Web' as const },
    { name: 'enum.legalPlatformType.MT4Mac' as const, value: 'MT4Mac' as const },
    { name: 'enum.legalPlatformType.MT4Windows' as const, value: 'MT4Windows' as const },
    { name: 'enum.legalPlatformType.downloadMT5' as const, value: 'DownloadMT5' as const },
    { name: 'enum.legalPlatformType.MT5Android' as const, value: 'MT5Android' as const },
    { name: 'enum.legalPlatformType.MT5iOS' as const, value: 'MT5iOS' as const },
    { name: 'enum.legalPlatformType.MT5Web' as const, value: 'MT5Web' as const },
    { name: 'enum.legalPlatformType.MT5Mac' as const, value: 'MT5Mac' as const },
    { name: 'enum.legalPlatformType.MT5Windows' as const, value: 'MT5Windows' as const },
    { name: 'enum.legalPlatformType.downloadEdge' as const, value: 'DownloadEdge' as const },
    { name: 'enum.legalPlatformType.edgeAndroid' as const, value: 'EdgeAndroid' as const },
    { name: 'enum.legalPlatformType.edgeiOS' as const, value: 'EdgeiOS' as const },
    { name: 'enum.legalPlatformType.edgeWeb' as const, value: 'EdgeWeb' as const },
    { name: 'enum.legalPlatformType.edgeMac' as const, value: 'EdgeMac' as const },
    { name: 'enum.legalPlatformType.edgeWindows' as const, value: 'EdgeWindows' as const },
    { name: 'enum.legalPlatformType.recognia' as const, value: 'Recognia' as const },
    { name: 'enum.legalPlatformType.tradingCentral' as const, value: 'TradingCentral' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbLegalSectionTypeEnum.cs.
  */
  LEGAL_SECTION_TYPE: [
    { name: 'enum.legalSectionType.legal' as const, value: 'Legal' as const },
    { name: 'enum.legalSectionType.digitalMarketing' as const, value: 'DigitalMarketing' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbLegalTypeEnum.cs.
  */
  LEGAL_TYPE: [
    { name: 'enum.legalType.riskDisclosure' as const, value: 'RiskDisclosure' as const },
    { name: 'enum.legalType.termsAndConditions' as const, value: 'TermsAndConditions' as const },
    { name: 'enum.legalType.liquidityGuidelines' as const, value: 'LiquidityGuidelines' as const },
    { name: 'enum.legalType.informationDisclosure' as const, value: 'InformationDisclosure' as const },
    { name: 'enum.legalType.introductionDisclosure' as const, value: 'IntroductionDisclosure' as const },
    { name: 'enum.legalType.clientAgreement' as const, value: 'ClientAgreement' as const },
    { name: 'enum.legalType.commissionAuthorizationForm' as const, value: 'CommissionAuthorizationForm' as const },
    { name: 'enum.legalType.privacyPolicy' as const, value: 'PrivacyPolicy' as const },
    { name: 'enum.legalType.indemnificationAcknowledgement' as const, value: 'IndemnificationAcknowledgement' as const },
    { name: 'enum.legalType.depositAndWithdrawalPolicy' as const, value: 'DepositAndWithdrawalPolicy' as const },
    { name: 'enum.legalType.birthdayBonusTermsAndConditions' as const, value: 'BirthdayBonusTermsAndConditions' as const },
    { name: 'enum.legalType.cookiePolicy' as const, value: 'CookiePolicy' as const },
    { name: 'enum.legalType.bonusTermsAndConditions' as const, value: 'BonusTermsAndConditions' as const },
    { name: 'enum.legalType.contest' as const, value: 'Contest' as const },
    { name: 'enum.legalType.dataProtectionPolicy' as const, value: 'DataProtectionPolicy' as const },
    { name: 'enum.legalType.nonDisclosureAgreement' as const, value: 'NonDisclosureAgreement' as const },
    { name: 'enum.legalType.serviceLevelAgreement' as const, value: 'ServiceLevelAgreement' as const },
    { name: 'enum.legalType.acceptableUsePolicy' as const, value: 'AcceptableUsePolicy' as const },
    { name: 'enum.legalType.disputeResolutionPolicy' as const, value: 'DisputeResolutionPolicy' as const },
    { name: 'enum.legalType.intellectualPropertyAgreement' as const, value: 'IntellectualPropertyAgreement' as const },
    { name: 'enum.legalType.endUserLicenseAgreement' as const, value: 'EndUserLicenseAgreement' as const },
    { name: 'enum.legalType.codeOfConduct' as const, value: 'CodeOfConduct' as const },
    { name: 'enum.legalType.antiMoneyLaunderingPolicy' as const, value: 'AntiMoneyLaunderingPolicy' as const },
    { name: 'enum.legalType.knowYourCustomerPolicy' as const, value: 'KnowYourCustomerPolicy' as const },
    { name: 'enum.legalType.tradingPolicy' as const, value: 'TradingPolicy' as const },
    { name: 'enum.legalType.refundPolicy' as const, value: 'RefundPolicy' as const },
    { name: 'enum.legalType.disclaimerNotice' as const, value: 'DisclaimerNotice' as const },
    { name: 'enum.legalType.other' as const, value: 'Other' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbLegalUrlDestinationType.cs.
  */
  LEGAL_URL_DESTINATION_TYPE: [
    { name: 'enum.legalUrlDestinationType.webSite' as const, value: 'WebSite' as const },
    { name: 'enum.legalUrlDestinationType.application' as const, value: 'Application' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbRecogniaPageEnum.cs.
  */
  RECOGNIA_PAGE: [
    { name: 'enum.recogniaPage.economicCalendar' as const, value: 'EconomicCalendar' as const },
    { name: 'enum.recogniaPage.featuredForex' as const, value: 'FeaturedForex' as const },
    { name: 'enum.recogniaPage.forexIdeas' as const, value: 'ForexIdeas' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Documents.DbRecogniaWidgetEnum.cs.
  */
  RECOGNIA_WIDGET: [
    { name: 'enum.recogniaWidget.overallMentions' as const, value: 'OverallMentions' as const },
    { name: 'enum.recogniaWidget.mentionsSources' as const, value: 'MentionsSources' as const },
    { name: 'enum.recogniaWidget.newsFeed' as const, value: 'NewsFeed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DocumentConfiguration.DbDocumentCategoryEnum.cs.
  */
  DOCUMENT_CATEGORY: [
    { name: 'enum.documentCategory.categoryA' as const, value: 'CategoryA' as const },
    { name: 'enum.documentCategory.categoryB' as const, value: 'CategoryB' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DocumentConfiguration.DbUserDocumentTypeEnum.cs.
  */
  USER_DOCUMENT_TYPE: [
    { name: 'enum.userDocumentType.individual' as const, value: 'Individual' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.CopyTrading.DbAllocationMethodEnum.cs.
  */
  ALLOCATION_METHOD: [
    { name: 'enum.allocationMethod.equity' as const, value: 'Equity' as const },
    { name: 'enum.allocationMethod.balance' as const, value: 'Balance' as const },
    { name: 'enum.allocationMethod.lot' as const, value: 'Lot' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.CopyTrading.DbTradingAccountHistoryTypeEnum.cs.
  */
  TRADING_ACCOUNT_HISTORY_TYPE: [
    { name: 'enum.tradingAccountHistoryType.masterAccountWasOpened' as const, value: 'MasterAccountWasOpened' as const },
    { name: 'enum.tradingAccountHistoryType.masterAccountWasChanged' as const, value: 'MasterAccountWasChanged' as const },
    { name: 'enum.tradingAccountHistoryType.masterAccountWasUnlinked' as const, value: 'MasterAccountWasUnlinked' as const },
    { name: 'enum.tradingAccountHistoryType.masterAccountWasLinked' as const, value: 'MasterAccountWasLinked' as const },
    { name: 'enum.tradingAccountHistoryType.investorAccountWasOpened' as const, value: 'InvestorAccountWasOpened' as const },
    { name: 'enum.tradingAccountHistoryType.investorAccountWasUnlinked' as const, value: 'InvestorAccountWasUnlinked' as const },
    { name: 'enum.tradingAccountHistoryType.investorAccountWasLinked' as const, value: 'InvestorAccountWasLinked' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Company.DbCompanyTransferStatusEnum.cs.
  */
  COMPANY_TRANSFER_STATUS: [
    { name: 'enum.companyTransferStatus.created' as const, value: 'Created' as const },
    { name: 'enum.companyTransferStatus.verified' as const, value: 'Verified' as const },
    { name: 'enum.companyTransferStatus.onComplianceReview' as const, value: 'OnComplianceReview' as const },
    { name: 'enum.companyTransferStatus.inProgress' as const, value: 'InProgress' as const },
    { name: 'enum.companyTransferStatus.completed' as const, value: 'Completed' as const },
    { name: 'enum.companyTransferStatus.rejected' as const, value: 'Rejected' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Common.DbApplicationTypeEnum.cs.
  */
  APPLICATION_TYPE: [
    { name: 'enum.applicationType.mobile' as const, value: 'Mobile' as const },
    { name: 'enum.applicationType.desktop' as const, value: 'Desktop' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Common.DbYesNoEnum.cs.
  */
  YES_NO: [
    { name: 'enum.yesNo.no' as const, value: 'No' as const },
    { name: 'enum.yesNo.yes' as const, value: 'Yes' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Common.ExportTypeEnum.cs.
  */
  EXPORT_TYPE: [
    { name: 'enum.exportType.excel' as const, value: 'Excel' as const },
    { name: 'enum.exportType.csv' as const, value: 'Csv' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Common.GreaterLessEnum.cs.
  */
  GREATER_LESS: [
    { name: 'enum.greaterLess.less' as const, value: 'Less' as const },
    { name: 'enum.greaterLess.lessOrEqual' as const, value: 'LessOrEqual' as const },
    { name: 'enum.greaterLess.greater' as const, value: 'Greater' as const },
    { name: 'enum.greaterLess.greaterOrEqual' as const, value: 'GreaterOrEqual' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Branding.UrlDomainTypeEnum.cs.
  */
  URL_DOMAIN_TYPE: [
    { name: 'enum.urlDomainType.homePage' as const, value: 'HomePage' as const },
    { name: 'enum.urlDomainType.membersArea' as const, value: 'MembersArea' as const },
    { name: 'enum.urlDomainType.partnershipPortal' as const, value: 'PartnershipPortal' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.BannerConfiguration.DbBannerConfigurationFileTypeEnum.cs.
  */
  BANNER_CONFIGURATION_FILE_TYPE: [
    { name: 'enum.bannerConfigurationFileType.regular' as const, value: 'Regular' as const },
    { name: 'enum.bannerConfigurationFileType.popUp' as const, value: 'PopUp' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.BannerConfiguration.DbBannerLocationEnum.cs.
  */
  BANNER_LOCATION: [
    { name: 'enum.bannerLocation.EWallet' as const, value: 'EWallet' as const },
    { name: 'enum.bannerLocation.tradingPlatforms' as const, value: 'TradingPlatforms' as const },
    { name: 'enum.bannerLocation.tradingAccounts' as const, value: 'TradingAccounts' as const },
    { name: 'enum.bannerLocation.notifications' as const, value: 'Notifications' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.BannerConfiguration.DbBannerSizeEnum.cs.
  */
  BANNER_SIZE: [
    { name: 'enum.bannerSize.small' as const, value: 'Small' as const },
    { name: 'enum.bannerSize.middle' as const, value: 'Middle' as const },
    { name: 'enum.bannerSize.fullWidth' as const, value: 'FullWidth' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.BannerConfiguration.DbBannerStyleEnum.cs.
  */
  BANNER_STYLE: [
    { name: 'enum.bannerStyle.bold' as const, value: 'Bold' as const },
    { name: 'enum.bannerStyle.italic' as const, value: 'Italic' as const },
    { name: 'enum.bannerStyle.underline' as const, value: 'Underline' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.BannerConfiguration.DbBannerTargetEnum.cs.
  */
  BANNER_TARGET: [
    { name: 'enum.bannerTarget.mobile' as const, value: 'Mobile' as const },
    { name: 'enum.bannerTarget.desktop' as const, value: 'Desktop' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Background.BackgroundJobStatusEnum.cs.
  */
  BACKGROUND_JOB_STATUS: [
    { name: 'enum.backgroundJobStatus.created' as const, value: 'Created' as const },
    { name: 'enum.backgroundJobStatus.enqueued' as const, value: 'Enqueued' as const },
    { name: 'enum.backgroundJobStatus.started' as const, value: 'Started' as const },
    { name: 'enum.backgroundJobStatus.succeeded' as const, value: 'Succeeded' as const },
    { name: 'enum.backgroundJobStatus.failed' as const, value: 'Failed' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Background.BackgroundJobTypeEnum.cs.
  */
  BACKGROUND_JOB_TYPE: [
    { name: 'enum.backgroundJobType.recurring' as const, value: 'Recurring' as const },
    { name: 'enum.backgroundJobType.immediate' as const, value: 'Immediate' as const },
    { name: 'enum.backgroundJobType.scheduled' as const, value: 'Scheduled' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.AvailableCountries.DbAvailableCountryItemTypeEnum.cs.
  */
  AVAILABLE_COUNTRY_ITEM_TYPE: [
    { name: 'enum.availableCountryItemType.bannerConfiguration' as const, value: 'BannerConfiguration' as const },
    { name: 'enum.availableCountryItemType.tradingAccountType' as const, value: 'TradingAccountType' as const },
    { name: 'enum.availableCountryItemType.autoAssignmentRule' as const, value: 'AutoAssignmentRule' as const },
    { name: 'enum.availableCountryItemType.urlDomain' as const, value: 'UrlDomain' as const },
    { name: 'enum.availableCountryItemType.component' as const, value: 'Component' as const },
    { name: 'enum.availableCountryItemType.tradingAccountTypeCategory' as const, value: 'TradingAccountTypeCategory' as const },
    { name: 'enum.availableCountryItemType.onboardingConfiguration' as const, value: 'OnboardingConfiguration' as const },
    { name: 'enum.availableCountryItemType.contest' as const, value: 'Contest' as const },
    { name: 'enum.availableCountryItemType.loyaltyProgram' as const, value: 'LoyaltyProgram' as const },
    { name: 'enum.availableCountryItemType.faq' as const, value: 'Faq' as const },
    { name: 'enum.availableCountryItemType.documentConfiguration' as const, value: 'DocumentConfiguration' as const },
    { name: 'enum.availableCountryItemType.marketingBannerCategory' as const, value: 'MarketingBannerCategory' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.AvailableCountries.DbCountryAccessTypeEnum.cs.
  */
  COUNTRY_ACCESS_TYPE: [
    { name: 'enum.countryAccessType.allowed' as const, value: 'Allowed' as const },
    { name: 'enum.countryAccessType.forbidden' as const, value: 'Forbidden' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.AutoAssignmentRule.ReassignmentTypeEnum.cs.
  */
  REASSIGNMENT_TYPE: [
    { name: 'enum.reassignmentType.allUsers' as const, value: 'AllUsers' as const },
    { name: 'enum.reassignmentType.specificIB' as const, value: 'SpecificIB' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Acl.DbCaptchaProviderEnum.cs.
  */
  CAPTCHA_PROVIDER: [
    { name: 'enum.captchaProvider.google' as const, value: 'Google' as const },
    { name: 'enum.captchaProvider.reCaptcha' as const, value: 'ReCaptcha' as const },
    { name: 'enum.captchaProvider.HCaptcha' as const, value: 'HCaptcha' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Acl.DbCaptchaVerifyModeEnum.cs.
  */
  CAPTCHA_VERIFY_MODE: [
    { name: 'enum.captchaVerifyMode.success' as const, value: 'Success' as const },
    { name: 'enum.captchaVerifyMode.score' as const, value: 'Score' as const },
    { name: 'enum.captchaVerifyMode.successAndScore' as const, value: 'SuccessAndScore' as const },
  ],

  /*
    Auto generated from file Features.Domain.FeaturesEnum.cs.
  */
  FEATURES: [
    { name: 'enum.features.socialTrading' as const, value: 'SocialTrading' as const },
    { name: 'enum.features.tradingContests' as const, value: 'TradingContests' as const },
    { name: 'enum.features.bonuses' as const, value: 'Bonuses' as const },
    { name: 'enum.features.aloGatewayPsp' as const, value: 'AloGatewayPsp' as const },
    { name: 'enum.features.MAM' as const, value: 'MAM' as const },
    { name: 'enum.features.educationalPortal' as const, value: 'EducationalPortal' as const },
    { name: 'enum.features.loyaltyPrograms' as const, value: 'LoyaltyPrograms' as const },
    { name: 'enum.features.akontoPayPsp' as const, value: 'AkontoPayPsp' as const },
    { name: 'enum.features.asiaBanksPsp' as const, value: 'AsiaBanksPsp' as const },
    { name: 'enum.features.astroPayPsp' as const, value: 'AstroPayPsp' as const },
    { name: 'enum.features.bitoloPsp' as const, value: 'BitoloPsp' as const },
    { name: 'enum.features.bitWorldPsp' as const, value: 'BitWorldPsp' as const },
    { name: 'enum.features.BVNKPsp' as const, value: 'BVNKPsp' as const },
    { name: 'enum.features.carboPayPsp' as const, value: 'CarboPayPsp' as const },
    { name: 'enum.features.chinaUnionPayPsp' as const, value: 'ChinaUnionPayPsp' as const },
    { name: 'enum.features.chinaWowsPayPsp' as const, value: 'ChinaWowsPayPsp' as const },
    { name: 'enum.features.chipPayPsp' as const, value: 'ChipPayPsp' as const },
    { name: 'enum.features.dragonPayPsp' as const, value: 'DragonPayPsp' as const },
    { name: 'enum.features.exlinkPsp' as const, value: 'ExlinkPsp' as const },
    { name: 'enum.features.fasapayPsp' as const, value: 'FasapayPsp' as const },
    { name: 'enum.features.FXMBPsp' as const, value: 'FXMBPsp' as const },
    { name: 'enum.features.GBPrimePayPsp' as const, value: 'GBPrimePayPsp' as const },
    { name: 'enum.features.help2PayPsp' as const, value: 'Help2PayPsp' as const },
    { name: 'enum.features.inotcPayPsp' as const, value: 'InotcPayPsp' as const },
    { name: 'enum.features.monetixPsp' as const, value: 'MonetixPsp' as const },
    { name: 'enum.features.MTPayPsp' as const, value: 'MTPayPsp' as const },
    { name: 'enum.features.netellerPsp' as const, value: 'NetellerPsp' as const },
    { name: 'enum.features.nowPayPsp' as const, value: 'NowPayPsp' as const },
    { name: 'enum.features.orbitalPsp' as const, value: 'OrbitalPsp' as const },
    { name: 'enum.features.pagsmilePsp' as const, value: 'PagsmilePsp' as const },
    { name: 'enum.features.paymentAsiaFPXPsp' as const, value: 'PaymentAsiaFPXPsp' as const },
    { name: 'enum.features.paymePsp' as const, value: 'PaymePsp' as const },
    { name: 'enum.features.payRetailersPsp' as const, value: 'PayRetailersPsp' as const },
    { name: 'enum.features.paySolPsp' as const, value: 'PaySolPsp' as const },
    { name: 'enum.features.perfectMoneyPsp' as const, value: 'PerfectMoneyPsp' as const },
    { name: 'enum.features.PPspayPsp' as const, value: 'PPspayPsp' as const },
    { name: 'enum.features.proTokensPsp' as const, value: 'ProTokensPsp' as const },
    { name: 'enum.features.RPNPayPsp' as const, value: 'RPNPayPsp' as const },
    { name: 'enum.features.skrillPsp' as const, value: 'SkrillPsp' as const },
    { name: 'enum.features.spayzPsp' as const, value: 'SpayzPsp' as const },
    { name: 'enum.features.transact365Psp' as const, value: 'Transact365Psp' as const },
    { name: 'enum.features.usePayPsp' as const, value: 'UsePayPsp' as const },
    { name: 'enum.features.VNPayPsp' as const, value: 'VNPayPsp' as const },
    { name: 'enum.features.walaoPayPsp' as const, value: 'WalaoPayPsp' as const },
    { name: 'enum.features.winTechPsp' as const, value: 'WinTechPsp' as const },
    { name: 'enum.features.wireTransferPsp' as const, value: 'WireTransferPsp' as const },
    { name: 'enum.features.wowsPayPsp' as const, value: 'WowsPayPsp' as const },
    { name: 'enum.features.zotaPayPsp' as const, value: 'ZotaPayPsp' as const },
    { name: 'enum.features.customNotifications' as const, value: 'CustomNotifications' as const },
    { name: 'enum.features.emailTemplates' as const, value: 'EmailTemplates' as const },
    { name: 'enum.features.surepayPsp' as const, value: 'SurepayPsp' as const },
    { name: 'enum.features.customPushNotifications' as const, value: 'CustomPushNotifications' as const },
    { name: 'enum.features.senangPay' as const, value: 'SenangPay' as const },
    { name: 'enum.features.paremitPsp' as const, value: 'ParemitPsp' as const },
    { name: 'enum.features.awepayPsp' as const, value: 'AwepayPsp' as const },
    { name: 'enum.features.fivePayPsp' as const, value: 'FivePayPsp' as const },
    { name: 'enum.features.leanXPsp' as const, value: 'LeanXPsp' as const },
    { name: 'enum.features.sticpayPsp' as const, value: 'SticpayPsp' as const },
    { name: 'enum.features.partnershipPortal' as const, value: 'PartnershipPortal' as const },
    { name: 'enum.features.ubankconnectPsp' as const, value: 'UbankconnectPsp' as const },
    { name: 'enum.features.edgePayPsp' as const, value: 'EdgePayPsp' as const },
  ],

  /*
    Auto generated from file User.Domain.Components.Params.BirthdayBonusEventProcessorParametersClientSourceTypeEnum.cs.
  */
  BIRTHDAY_BONUS_EVENT_PROCESSOR_PARAMETERS_CLIENT_SOURCE_TYPE: [
    { name: 'enum.birthdayBonusEventProcessorParametersClientSourceType.all' as const, value: 'All' as const },
    { name: 'enum.birthdayBonusEventProcessorParametersClientSourceType.direct' as const, value: 'Direct' as const },
    { name: 'enum.birthdayBonusEventProcessorParametersClientSourceType.ibTree' as const, value: 'IbTree' as const },
  ],

  /*
    Auto generated from file Contests.Domain.Contests.Enums.ContestKpiTypeEnum.cs.
  */
  CONTEST_KPI_TYPE: [
    { name: 'enum.contestKpiType.profitabilityOnStartingBalance' as const, value: 'ProfitabilityOnStartingBalance' as const },
    { name: 'enum.contestKpiType.maxDrawdown' as const, value: 'MaxDrawdown' as const },
    { name: 'enum.contestKpiType.averageDrawdown' as const, value: 'AverageDrawdown' as const },
    { name: 'enum.contestKpiType.combined' as const, value: 'Combined' as const },
    { name: 'enum.contestKpiType.profitability' as const, value: 'Profitability' as const },
  ],

  /*
    Auto generated from file Contests.Domain.Contests.Enums.ContestStatusEnum.cs.
  */
  CONTEST_STATUS: [
    { name: 'enum.contestStatus.startingSoon' as const, value: 'StartingSoon' as const },
    { name: 'enum.contestStatus.ongoing' as const, value: 'Ongoing' as const },
    { name: 'enum.contestStatus.finished' as const, value: 'Finished' as const },
    { name: 'enum.contestStatus.cancelled' as const, value: 'Cancelled' as const },
    { name: 'enum.contestStatus.new' as const, value: 'New' as const },
  ],

  /*
    Auto generated from file Contests.Domain.Contests.Enums.ContestStatusEnum.cs.
  */
  USER_CONTEST_STATUS: [
    { name: 'enum.contestStatus.startingSoon' as const, value: 'StartingSoon' as const },
    { name: 'enum.contestStatus.ongoing' as const, value: 'Ongoing' as const },
    { name: 'enum.contestStatus.finished' as const, value: 'Finished' as const },
    { name: 'enum.contestStatus.cancelled' as const, value: 'Cancelled' as const },
  ],

  /*
    Auto generated from file Contests.Domain.Common.Models.ContestOwnerType.cs.
  */
  CONTEST_OWNER_TYPE: [
    { name: 'enum.contestOwnerType.my' as const, value: 'My' as const },
    { name: 'enum.contestOwnerType.others' as const, value: 'Others' as const },
  ],

  /*
    Auto generated from file CopyTrading.Domain.Enums.MasterRatingAccountTypeEnum.cs.
  */
  MASTER_RATING_ACCOUNT_TYPE: [
    { name: 'enum.masterRatingAccountType.ECN' as const, value: 'ECN' as const },
    { name: 'enum.masterRatingAccountType.standard' as const, value: 'Standard' as const },
    { name: 'enum.masterRatingAccountType.cent' as const, value: 'Cent' as const },
  ],

  /*
    Auto generated from file Reporting.Domain.Jobs.CombinedTradingPlatformSummary.Models.AccountType.cs.
  */
  ACCOUNT_TYPE: [
    { name: 'enum.accountType.mamMasterAccounts' as const, value: 'MamMasterAccounts' as const },
    { name: 'enum.accountType.test' as const, value: 'Test' as const },
    { name: 'enum.accountType.staff' as const, value: 'Staff' as const },
    { name: 'enum.accountType.localDepositor' as const, value: 'LocalDepositor' as const },
    { name: 'enum.accountType.client' as const, value: 'Client' as const },
  ],

  /*
    Auto generated from file Reporting.Domain.Jobs.CombinedTradingPlatformSummary.Models.PLFormulaType.cs.
  */
  P_L_FORMULA_TYPE: [
    { name: 'enum.PLFormulaType.agentCommissionIncluded' as const, value: 'AgentCommissionIncluded' as const },
    { name: 'enum.PLFormulaType.ibRebateIncluded' as const, value: 'IbRebateIncluded' as const },
  ],

  /*
    Auto generated from file Trading.Domain.TradingAccounts.TradingAccounts.Enums.TradingBonusStopOutModeEnum.cs.
  */
  TRADING_BONUS_STOP_OUT_MODE: [
    { name: 'enum.tradingBonusStopOutMode.default' as const, value: 'Default' as const },
    { name: 'enum.tradingBonusStopOutMode.enabled' as const, value: 'Enabled' as const },
    { name: 'enum.tradingBonusStopOutMode.disabled' as const, value: 'Disabled' as const },
  ],

  /*
    Auto generated from file PaymentSystems.Domain.AutoWithdrawals.Components.Models.CountryDefault.cs.
  */
  COUNTRY_DEFAULT: [
    { name: 'enum.countryDefault.allEnabled' as const, value: 'AllEnabled' as const },
    { name: 'enum.countryDefault.allDisabled' as const, value: 'AllDisabled' as const },
  ],

  /*
    Auto generated from file LoyaltyPrograms.Domain.LoyaltyPrograms.Enums.LoyaltyProgramStatusEnum.cs.
  */
  LOYALTY_PROGRAM_STATUS: [
    { name: 'enum.loyaltyProgramStatus.new' as const, value: 'New' as const },
    { name: 'enum.loyaltyProgramStatus.ongoing' as const, value: 'Ongoing' as const },
    { name: 'enum.loyaltyProgramStatus.finished' as const, value: 'Finished' as const },
  ],

  /*
    Auto generated from file Messages.Domain.Jobs.MessageCleaning.BatchProcessingMode.cs.
  */
  BATCH_PROCESSING_MODE: [
    { name: 'enum.batchProcessingMode.one' as const, value: 'One' as const },
    { name: 'enum.batchProcessingMode.all' as const, value: 'All' as const },
  ],

  /*
    Auto generated from file Partnership.Domain.Metrics.Models.ExtraPropertyName.cs.
  */
  EXTRA_PROPERTY_NAME: [
    { name: 'enum.extraPropertyName.symbolName' as const, value: 'SymbolName' as const },
    { name: 'enum.extraPropertyName.userFullName' as const, value: 'UserFullName' as const },
    { name: 'enum.extraPropertyName.ibCode' as const, value: 'IbCode' as const },
  ],

  /*
    Auto generated from file Partnership.Domain.Metrics.Models.IbMetricGroupingType.cs.
  */
  IB_METRIC_GROUPING_TYPE: [
    { name: 'enum.ibMetricGroupingType.sum' as const, value: 'Sum' as const },
    { name: 'enum.ibMetricGroupingType.runningSum' as const, value: 'RunningSum' as const },
  ],

  /*
    Auto generated from file Partnership.Domain.Metrics.Models.Dashboard.DashboardIbMetricType.cs.
  */
  DASHBOARD_IB_METRIC_TYPE: [
    { name: 'enum.dashboardIbMetricType.total' as const, value: 'Total' as const },
    { name: 'enum.dashboardIbMetricType.series' as const, value: 'Series' as const },
    { name: 'enum.dashboardIbMetricType.topNShares' as const, value: 'TopNShares' as const },
    { name: 'enum.dashboardIbMetricType.error' as const, value: 'Error' as const },
  ],

  /*
    Auto generated from file Partnership.Domain.Metrics.Enums.IbDashboardWidgetMetricPeriod.cs.
  */
  IB_DASHBOARD_WIDGET_METRIC_PERIOD: [
    { name: 'enum.ibDashboardWidgetMetricPeriod.today' as const, value: 'Today' as const },
    { name: 'enum.ibDashboardWidgetMetricPeriod.currentWeek' as const, value: 'CurrentWeek' as const },
    { name: 'enum.ibDashboardWidgetMetricPeriod.currentMonth' as const, value: 'CurrentMonth' as const },
    { name: 'enum.ibDashboardWidgetMetricPeriod.yesterday' as const, value: 'Yesterday' as const },
    { name: 'enum.ibDashboardWidgetMetricPeriod.lastWeek' as const, value: 'LastWeek' as const },
    { name: 'enum.ibDashboardWidgetMetricPeriod.lastMonth' as const, value: 'LastMonth' as const },
  ],

  /*
    Auto generated from file Partnership.Domain.Metrics.Enums.IbMetricType.cs.
  */
  IB_METRIC_TYPE: [
    { name: 'enum.ibMetricType.totalSum' as const, value: 'TotalSum' as const },
    { name: 'enum.ibMetricType.sumByDate' as const, value: 'SumByDate' as const },
    { name: 'enum.ibMetricType.runningSumByDate' as const, value: 'RunningSumByDate' as const },
    { name: 'enum.ibMetricType.topNBy' as const, value: 'TopNBy' as const },
  ],

  /*
    Auto generated from file Partnership.Domain.Metrics.Enums.IbRelation.cs.
  */
  IB_RELATION: [
    { name: 'enum.ibRelation.direct' as const, value: 'Direct' as const },
    { name: 'enum.ibRelation.subIb' as const, value: 'SubIb' as const },
  ],

  /*
    Auto generated from file MembersArea.Acl.Models.ClosedReport.ClosedTradesSide.cs.
  */
  CLOSED_TRADES_SIDE: [
    { name: 'enum.closedTradesSide.buy' as const, value: 'Buy' as const },
    { name: 'enum.closedTradesSide.sell' as const, value: 'Sell' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.ThirdPartyService.DbCRMEntityTypeEnum.cs.
  */
  CRM_ENTITY_TYPE: [
    { name: 'enum.CRMEntityType.tradingUser' as const, value: 'TradingUser' as const },
    { name: 'enum.CRMEntityType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.CRMEntityType.tradingTransfer' as const, value: 'TradingTransfer' as const },
    { name: 'enum.CRMEntityType.case' as const, value: 'Case' as const },
    { name: 'enum.CRMEntityType.firstDeposit' as const, value: 'FirstDeposit' as const },
    { name: 'enum.CRMEntityType.lastLogin' as const, value: 'LastLogin' as const },
    { name: 'enum.CRMEntityType.profileVerification' as const, value: 'ProfileVerification' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.ThirdPartyService.DbCRMEntityTypeEnum.cs.
  */
  SYNC_SWITCHABLE_CRM_ENTITY_TYPE: [
    { name: 'enum.CRMEntityType.tradingUser' as const, value: 'TradingUser' as const },
    { name: 'enum.CRMEntityType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.CRMEntityType.tradingTransfer' as const, value: 'TradingTransfer' as const },
    { name: 'enum.CRMEntityType.case' as const, value: 'Case' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.ThirdPartyService.DbCRMTypeEnum.cs.
  */
  CRM_TYPE: [
    { name: 'enum.CRMType.hubSpot' as const, value: 'HubSpot' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.ThirdPartyService.CRMUniqueEntityTypeEnum.cs.
  */
  CRM_UNIQUE_ENTITY_TYPE: [
    { name: 'enum.CRMUniqueEntityType.user' as const, value: 'User' as const },
    { name: 'enum.CRMUniqueEntityType.tradingAccount' as const, value: 'TradingAccount' as const },
    { name: 'enum.CRMUniqueEntityType.tradingTransfer' as const, value: 'TradingTransfer' as const },
    { name: 'enum.CRMUniqueEntityType.case' as const, value: 'Case' as const },
    { name: 'enum.CRMUniqueEntityType.owner' as const, value: 'Owner' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.Mt4CmdEnum.cs.
  */
  MT4_CMD: [
    { name: 'enum.mt4Cmd.buy' as const, value: 'Buy' as const },
    { name: 'enum.mt4Cmd.sell' as const, value: 'Sell' as const },
    { name: 'enum.mt4Cmd.buyLimit' as const, value: 'BuyLimit' as const },
    { name: 'enum.mt4Cmd.sellLimit' as const, value: 'SellLimit' as const },
    { name: 'enum.mt4Cmd.buyStop' as const, value: 'BuyStop' as const },
    { name: 'enum.mt4Cmd.sellStop' as const, value: 'SellStop' as const },
    { name: 'enum.mt4Cmd.balance' as const, value: 'Balance' as const },
    { name: 'enum.mt4Cmd.credit' as const, value: 'Credit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.Mt5.Mt5Action.cs.
  */
  MT5_ACTION: [
    { name: 'enum.mt5Action.buy' as const, value: 'Buy' as const },
    { name: 'enum.mt5Action.sell' as const, value: 'Sell' as const },
    { name: 'enum.mt5Action.balance' as const, value: 'Balance' as const },
    { name: 'enum.mt5Action.credit' as const, value: 'Credit' as const },
    { name: 'enum.mt5Action.charge' as const, value: 'Charge' as const },
    { name: 'enum.mt5Action.correction' as const, value: 'Correction' as const },
    { name: 'enum.mt5Action.bonus' as const, value: 'Bonus' as const },
    { name: 'enum.mt5Action.commission' as const, value: 'Commission' as const },
    { name: 'enum.mt5Action.commissionDaily' as const, value: 'CommissionDaily' as const },
    { name: 'enum.mt5Action.commissionMonthly' as const, value: 'CommissionMonthly' as const },
    { name: 'enum.mt5Action.agentDaily' as const, value: 'AgentDaily' as const },
    { name: 'enum.mt5Action.agentMonthly' as const, value: 'AgentMonthly' as const },
    { name: 'enum.mt5Action.interestRate' as const, value: 'InterestRate' as const },
    { name: 'enum.mt5Action.buyCanceled' as const, value: 'BuyCanceled' as const },
    { name: 'enum.mt5Action.sellCanceled' as const, value: 'SellCanceled' as const },
    { name: 'enum.mt5Action.dividend' as const, value: 'Dividend' as const },
    { name: 'enum.mt5Action.dividendFranked' as const, value: 'DividendFranked' as const },
    { name: 'enum.mt5Action.tax' as const, value: 'Tax' as const },
    { name: 'enum.mt5Action.agent' as const, value: 'Agent' as const },
    { name: 'enum.mt5Action.soCompensation' as const, value: 'SoCompensation' as const },
    { name: 'enum.mt5Action.soCompensationCredit' as const, value: 'SoCompensationCredit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Trading.Mt5.Mt5Action.cs.
  */
  HISTORY_MT5_ACTION: [
    { name: 'enum.mt5Action.buy' as const, value: 'Buy' as const },
    { name: 'enum.mt5Action.sell' as const, value: 'Sell' as const },
    { name: 'enum.mt5Action.balance' as const, value: 'Balance' as const },
    { name: 'enum.mt5Action.credit' as const, value: 'Credit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbEventTypeEnum.cs.
  */
  NOTIFICATION_EVENT: [
    { name: 'enum.eventType.registration' as const, value: 'Registration' as const },
    { name: 'enum.eventType.emailVerificationCode' as const, value: 'EmailVerificationCode' as const },
    { name: 'enum.eventType.changePassword' as const, value: 'ChangePassword' as const },
    { name: 'enum.eventType.passwordRecoveryLink' as const, value: 'PasswordRecoveryLink' as const },
    { name: 'enum.eventType.passwordRecovery' as const, value: 'PasswordRecovery' as const },
    { name: 'enum.eventType.createPinCode' as const, value: 'CreatePinCode' as const },
    { name: 'enum.eventType.pinCodeResetLink' as const, value: 'PinCodeResetLink' as const },
    { name: 'enum.eventType.userApproved' as const, value: 'UserApproved' as const },
    { name: 'enum.eventType.userDeclined' as const, value: 'UserDeclined' as const },
    { name: 'enum.eventType.QFormVerified' as const, value: 'QFormVerified' as const },
    { name: 'enum.eventType.QFormNotVerified' as const, value: 'QFormNotVerified' as const },
    { name: 'enum.eventType.openTradingAccount' as const, value: 'OpenTradingAccount' as const },
    { name: 'enum.eventType.openTradingAccountUnderIB' as const, value: 'OpenTradingAccountUnderIB' as const },
    { name: 'enum.eventType.openCommissionTradingAccount' as const, value: 'OpenCommissionTradingAccount' as const },
    { name: 'enum.eventType.accountEnabled' as const, value: 'AccountEnabled' as const },
    { name: 'enum.eventType.accountDisabled' as const, value: 'AccountDisabled' as const },
    { name: 'enum.eventType.salesRegistrationLink' as const, value: 'SalesRegistrationLink' as const },
    { name: 'enum.eventType.changeLeverage' as const, value: 'ChangeLeverage' as const },
    { name: 'enum.eventType.pspSkippingProcessing_Admin' as const, value: 'PspSkippingProcessing_Admin' as const },
    { name: 'enum.eventType.createConfirmationCode' as const, value: 'CreateConfirmationCode' as const },
    { name: 'enum.eventType.withdrawalPassCodeValidationFailed' as const, value: 'WithdrawalPassCodeValidationFailed' as const },
    { name: 'enum.eventType.birthdayBonus' as const, value: 'BirthdayBonus' as const },
    { name: 'enum.eventType.changeMasterPassword' as const, value: 'ChangeMasterPassword' as const },
    { name: 'enum.eventType.changeInvestorPassword' as const, value: 'ChangeInvestorPassword' as const },
    { name: 'enum.eventType.withdrawalRequestNotification_Admin' as const, value: 'WithdrawalRequestNotification_Admin' as const },
    { name: 'enum.eventType.withdrawalProcessed' as const, value: 'WithdrawalProcessed' as const },
    { name: 'enum.eventType.withdrawalRejected' as const, value: 'WithdrawalRejected' as const },
    { name: 'enum.eventType.withdrawalInProgress' as const, value: 'WithdrawalInProgress' as const },
    { name: 'enum.eventType.depositCompleted' as const, value: 'DepositCompleted' as const },
    { name: 'enum.eventType.depositRejected' as const, value: 'DepositRejected' as const },
    { name: 'enum.eventType.depositInProgress' as const, value: 'DepositInProgress' as const },
    { name: 'enum.eventType.depositRequestNotification_Admin' as const, value: 'DepositRequestNotification_Admin' as const },
    { name: 'enum.eventType.promoteApproveDocument' as const, value: 'PromoteApproveDocument' as const },
    { name: 'enum.eventType.promoteRejectDocument' as const, value: 'PromoteRejectDocument' as const },
    { name: 'enum.eventType.localDepositRequest' as const, value: 'LocalDepositRequest' as const },
    { name: 'enum.eventType.localWithdrawalRequest' as const, value: 'LocalWithdrawalRequest' as const },
    { name: 'enum.eventType.createTicket_Admin' as const, value: 'CreateTicket_Admin' as const },
    { name: 'enum.eventType.assignToTicket_Admin' as const, value: 'AssignToTicket_Admin' as const },
    { name: 'enum.eventType.createTicket' as const, value: 'CreateTicket' as const },
    { name: 'enum.eventType.deleteTicket' as const, value: 'DeleteTicket' as const },
    { name: 'enum.eventType.ticketChangeStatus' as const, value: 'TicketChangeStatus' as const },
    { name: 'enum.eventType.QFormVerificationRequest_Admin' as const, value: 'QFormVerificationRequest_Admin' as const },
    { name: 'enum.eventType.userInDeclinedStatus_Admin' as const, value: 'UserInDeclinedStatus_Admin' as const },
    { name: 'enum.eventType.userRegisteredUnderIb' as const, value: 'UserRegisteredUnderIb' as const },
    { name: 'enum.eventType.depositInProgressNotification_Sales' as const, value: 'DepositInProgressNotification_Sales' as const },
    { name: 'enum.eventType.withdrawalInProgressNotification_Sales' as const, value: 'WithdrawalInProgressNotification_Sales' as const },
    { name: 'enum.eventType.accountsArchiverReport_Admin' as const, value: 'AccountsArchiverReport_Admin' as const },
    { name: 'enum.eventType.depositCompletedNotification_Sales' as const, value: 'DepositCompletedNotification_Sales' as const },
    { name: 'enum.eventType.openTradingAccount_Admin' as const, value: 'OpenTradingAccount_Admin' as const },
    { name: 'enum.eventType.withdrawalCompletedNotification_Sales' as const, value: 'WithdrawalCompletedNotification_Sales' as const },
    { name: 'enum.eventType.changeEmailLink' as const, value: 'ChangeEmailLink' as const },
    { name: 'enum.eventType.changeEmail' as const, value: 'ChangeEmail' as const },
    { name: 'enum.eventType.draftUsers' as const, value: 'DraftUsers' as const },
    { name: 'enum.eventType.commissionHistoryReport_Admin' as const, value: 'CommissionHistoryReport_Admin' as const },
    { name: 'enum.eventType.walletOperationsReport_Admin' as const, value: 'WalletOperationsReport_Admin' as const },
    { name: 'enum.eventType.tradingBonusReport_Admin' as const, value: 'TradingBonusReport_Admin' as const },
    { name: 'enum.eventType.pspOperationsReport_Admin' as const, value: 'PspOperationsReport_Admin' as const },
    { name: 'enum.eventType.accountInactiveDays' as const, value: 'AccountInactiveDays' as const },
    { name: 'enum.eventType.beforeArchiving' as const, value: 'BeforeArchiving' as const },
    { name: 'enum.eventType.walletAccountsReport_Admin' as const, value: 'WalletAccountsReport_Admin' as const },
    { name: 'enum.eventType.kycVerificationUserDeclined_Admin' as const, value: 'KycVerificationUserDeclined_Admin' as const },
    { name: 'enum.eventType.kycVerificationsStuck_Admin' as const, value: 'KycVerificationsStuck_Admin' as const },
    { name: 'enum.eventType.newDepositDocumentsUploaded_Admin' as const, value: 'NewDepositDocumentsUploaded_Admin' as const },
    { name: 'enum.eventType.depositFollowUp' as const, value: 'DepositFollowUp' as const },
    { name: 'enum.eventType.accountInactivityFees' as const, value: 'AccountInactivityFees' as const },
    { name: 'enum.eventType.depositOnHoldReport_Admin' as const, value: 'DepositOnHoldReport_Admin' as const },
    { name: 'enum.eventType.userInDraftStatus_Admin' as const, value: 'UserInDraftStatus_Admin' as const },
    { name: 'enum.eventType.userInProcessStatus_Admin' as const, value: 'UserInProcessStatus_Admin' as const },
    { name: 'enum.eventType.userInApprovedStatus_Admin' as const, value: 'UserInApprovedStatus_Admin' as const },
    { name: 'enum.eventType.firstDeposit' as const, value: 'FirstDeposit' as const },
    { name: 'enum.eventType.accountInactivityFeesSecond' as const, value: 'AccountInactivityFeesSecond' as const },
    { name: 'enum.eventType.accountInactivityFeesThird' as const, value: 'AccountInactivityFeesThird' as const },
    { name: 'enum.eventType.accountInactivityFeesFourth' as const, value: 'AccountInactivityFeesFourth' as const },
    { name: 'enum.eventType.kycNotStarted' as const, value: 'KycNotStarted' as const },
    { name: 'enum.eventType.kycPassedNoDepositFirst' as const, value: 'KycPassedNoDepositFirst' as const },
    { name: 'enum.eventType.kycPassedNoDepositSecond' as const, value: 'KycPassedNoDepositSecond' as const },
    { name: 'enum.eventType.kycPassedNoDepositThird' as const, value: 'KycPassedNoDepositThird' as const },
    { name: 'enum.eventType.salesLeadRegistered' as const, value: 'SalesLeadRegistered' as const },
    { name: 'enum.eventType.depositInProgressNotification_BDM' as const, value: 'DepositInProgressNotification_BDM' as const },
    { name: 'enum.eventType.depositCompletedNotification_BDM' as const, value: 'DepositCompletedNotification_BDM' as const },
    { name: 'enum.eventType.withdrawalInProgressNotification_BDM' as const, value: 'WithdrawalInProgressNotification_BDM' as const },
    { name: 'enum.eventType.withdrawalCompletedNotification_BDM' as const, value: 'WithdrawalCompletedNotification_BDM' as const },
    { name: 'enum.eventType.verifyProfileFirstReminder' as const, value: 'VerifyProfileFirstReminder' as const },
    { name: 'enum.eventType.verifyProfileSecondReminder' as const, value: 'VerifyProfileSecondReminder' as const },
    { name: 'enum.eventType.userUpdateRequired' as const, value: 'UserUpdateRequired' as const },
    { name: 'enum.eventType.userUrgentUpdate' as const, value: 'UserUrgentUpdate' as const },
    { name: 'enum.eventType.allocationUpdate' as const, value: 'AllocationUpdate' as const },
    { name: 'enum.eventType.profitSharingUpdate' as const, value: 'ProfitSharingUpdate' as const },
    { name: 'enum.eventType.bonusAccountDepositCompleted_Admin' as const, value: 'BonusAccountDepositCompleted_Admin' as const },
    { name: 'enum.eventType.bonusAccountWithdrawalCompleted_Admin' as const, value: 'BonusAccountWithdrawalCompleted_Admin' as const },
    { name: 'enum.eventType.stopCopyingForMasterInitiatedByInvestor' as const, value: 'StopCopyingForMasterInitiatedByInvestor' as const },
    { name: 'enum.eventType.stopCopyingForInvestorInitiatedByInvestor' as const, value: 'StopCopyingForInvestorInitiatedByInvestor' as const },
    { name: 'enum.eventType.stopCopyingForMasterInitiatedByMaster' as const, value: 'StopCopyingForMasterInitiatedByMaster' as const },
    { name: 'enum.eventType.stopCopyingForInvestorInitiatedByMaster' as const, value: 'StopCopyingForInvestorInitiatedByMaster' as const },
    { name: 'enum.eventType.limitOfInvestorsExceededForMaster' as const, value: 'LimitOfInvestorsExceededForMaster' as const },
    { name: 'enum.eventType.kytVerificationOperation_Admin' as const, value: 'KytVerificationOperation_Admin' as const },
    { name: 'enum.eventType.kytVerificationWithdrawalAttempt_Admin' as const, value: 'KytVerificationWithdrawalAttempt_Admin' as const },
    { name: 'enum.eventType.shortLinkApproved' as const, value: 'ShortLinkApproved' as const },
    { name: 'enum.eventType.shortLinkDeclined' as const, value: 'ShortLinkDeclined' as const },
    { name: 'enum.eventType.shortLinkExpired' as const, value: 'ShortLinkExpired' as const },
    { name: 'enum.eventType.shortLinkRequest_Admin' as const, value: 'ShortLinkRequest_Admin' as const },
    { name: 'enum.eventType.kycProfileDiscrepancyNotification_Admin' as const, value: 'KycProfileDiscrepancyNotification_Admin' as const },
    { name: 'enum.eventType.mobileCodeRequest_Admin' as const, value: 'MobileCodeRequest_Admin' as const },
    { name: 'enum.eventType.lpoaSubmitted_Admin' as const, value: 'LpoaSubmitted_Admin' as const },
    { name: 'enum.eventType.lpoaCompletedForManager' as const, value: 'LpoaCompletedForManager' as const },
    { name: 'enum.eventType.lpoaCompletedForInvestor' as const, value: 'LpoaCompletedForInvestor' as const },
    { name: 'enum.eventType.lpoaTerminationWasInitiatedForManager' as const, value: 'LpoaTerminationWasInitiatedForManager' as const },
    { name: 'enum.eventType.lpoaTerminationWasInitiatedForInvestor' as const, value: 'LpoaTerminationWasInitiatedForInvestor' as const },
    { name: 'enum.eventType.lpoaWasTerminatedForManager' as const, value: 'LpoaWasTerminatedForManager' as const },
    { name: 'enum.eventType.lpoaWasTerminatedForInvestor' as const, value: 'LpoaWasTerminatedForInvestor' as const },
    { name: 'enum.eventType.profitSharingWasChangedForMamInvestor' as const, value: 'ProfitSharingWasChangedForMamInvestor' as const },
    { name: 'enum.eventType.profitSharingWasChanged_Sales' as const, value: 'ProfitSharingWasChanged_Sales' as const },
    { name: 'enum.eventType.userRegisteredRebateThreshold_Admin' as const, value: 'UserRegisteredRebateThreshold_Admin' as const },
    { name: 'enum.eventType.mamManagerLinkSubmitted_Admin' as const, value: 'MamManagerLinkSubmitted_Admin' as const },
    { name: 'enum.eventType.mamManagerLinkApproved' as const, value: 'MamManagerLinkApproved' as const },
    { name: 'enum.eventType.mamManagerLinkDeclined' as const, value: 'MamManagerLinkDeclined' as const },
    { name: 'enum.eventType.accountInactivityFeesFirst_Sales' as const, value: 'AccountInactivityFeesFirst_Sales' as const },
    { name: 'enum.eventType.accountInactivityFeesSecond_Sales' as const, value: 'AccountInactivityFeesSecond_Sales' as const },
    { name: 'enum.eventType.accountInactivityFeesThird_Sales' as const, value: 'AccountInactivityFeesThird_Sales' as const },
    { name: 'enum.eventType.accountInactivityFeesFourth_Sales' as const, value: 'AccountInactivityFeesFourth_Sales' as const },
    { name: 'enum.eventType.userInDeclinedStatus_Sales' as const, value: 'UserInDeclinedStatus_Sales' as const },
    { name: 'enum.eventType.changeEmail_Admin' as const, value: 'ChangeEmail_Admin' as const },
    { name: 'enum.eventType.assignUserToSalesUser_Sales' as const, value: 'AssignUserToSalesUser_Sales' as const },
    { name: 'enum.eventType.userDeletion_Admin' as const, value: 'UserDeletion_Admin' as const },
    { name: 'enum.eventType.autoStopCopyingForInvestor' as const, value: 'AutoStopCopyingForInvestor' as const },
    { name: 'enum.eventType.autoStopCopyingWarningForInvestor' as const, value: 'AutoStopCopyingWarningForInvestor' as const },
    { name: 'enum.eventType.tradingAccountArchive' as const, value: 'TradingAccountArchive' as const },
    { name: 'enum.eventType.userInUrgentUpdateStatus_Sales' as const, value: 'UserInUrgentUpdateStatus_Sales' as const },
    { name: 'enum.eventType.tradingAccountArchive_Admin' as const, value: 'TradingAccountArchive_Admin' as const },
    { name: 'enum.eventType.bonusExpiry' as const, value: 'BonusExpiry' as const },
    { name: 'enum.eventType.bonusExpiry_Sales' as const, value: 'BonusExpiry_Sales' as const },
    { name: 'enum.eventType.uploadCardDocuments' as const, value: 'UploadCardDocuments' as const },
    { name: 'enum.eventType.uploadDigitalWalletDocuments' as const, value: 'UploadDigitalWalletDocuments' as const },
    { name: 'enum.eventType.uploadBankAccountDocuments' as const, value: 'UploadBankAccountDocuments' as const },
    { name: 'enum.eventType.kycVerificationUserDeclinedUnsupportedCountry_Admin' as const, value: 'KycVerificationUserDeclinedUnsupportedCountry_Admin' as const },
    { name: 'enum.eventType.withdrawalCancelled' as const, value: 'WithdrawalCancelled' as const },
    { name: 'enum.eventType.tradingPlatformDailyEquityReport_Admin' as const, value: 'TradingPlatformDailyEquityReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformBalanceOperationReport_Admin' as const, value: 'TradingPlatformBalanceOperationReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformAdjustmentReport_Admin' as const, value: 'TradingPlatformAdjustmentReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformInactiveAccountsReport_Admin' as const, value: 'TradingPlatformInactiveAccountsReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformIBDetailReport_Admin' as const, value: 'TradingPlatformIBDetailReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformCreditFacilityReport_Admin' as const, value: 'TradingPlatformCreditFacilityReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformSummaryReport_Admin' as const, value: 'TradingPlatformSummaryReport_Admin' as const },
    { name: 'enum.eventType.topWithdrawalsSummaryReport_Admin' as const, value: 'TopWithdrawalsSummaryReport_Admin' as const },
    { name: 'enum.eventType.topWithdrawalsDetailsReport_Admin' as const, value: 'TopWithdrawalsDetailsReport_Admin' as const },
    { name: 'enum.eventType.topDepositsSummaryReport_Admin' as const, value: 'TopDepositsSummaryReport_Admin' as const },
    { name: 'enum.eventType.topDepositsDetailsReport_Admin' as const, value: 'TopDepositsDetailsReport_Admin' as const },
    { name: 'enum.eventType.userBankAccountSubmission_Admin' as const, value: 'UserBankAccountSubmission_Admin' as const },
    { name: 'enum.eventType.bankAccountSubmissionVerified' as const, value: 'BankAccountSubmissionVerified' as const },
    { name: 'enum.eventType.bankAccountSubmissionRejected' as const, value: 'BankAccountSubmissionRejected' as const },
    { name: 'enum.eventType.bankAccountSubmissionDeclined' as const, value: 'BankAccountSubmissionDeclined' as const },
    { name: 'enum.eventType.manualDepositsReport_Admin' as const, value: 'ManualDepositsReport_Admin' as const },
    { name: 'enum.eventType.nonUsdWalletOperationsReport_Admin' as const, value: 'NonUsdWalletOperationsReport_Admin' as const },
    { name: 'enum.eventType.topIbRebateSummaryReport_Admin' as const, value: 'TopIbRebateSummaryReport_Admin' as const },
    { name: 'enum.eventType.topIbRebateDetailsReport_Admin' as const, value: 'TopIbRebateDetailsReport_Admin' as const },
    { name: 'enum.eventType.tradingGroupNotFound_Admin' as const, value: 'TradingGroupNotFound_Admin' as const },
    { name: 'enum.eventType.volumeBySecuritySummaryReport_Admin' as const, value: 'VolumeBySecuritySummaryReport_Admin' as const },
    { name: 'enum.eventType.volumeBySecurityDetailsReport_Admin' as const, value: 'VolumeBySecurityDetailsReport_Admin' as const },
    { name: 'enum.eventType.contestRatingReport_Admin' as const, value: 'ContestRatingReport_Admin' as const },
    { name: 'enum.eventType.pspBalanceReport_Admin' as const, value: 'PspBalanceReport_Admin' as const },
    { name: 'enum.eventType.combinedTradingPlatformDailyEquityReport_Admin' as const, value: 'CombinedTradingPlatformDailyEquityReport_Admin' as const },
    { name: 'enum.eventType.usdAdjustedWalletAccountReport_Admin' as const, value: 'UsdAdjustedWalletAccountReport_Admin' as const },
    { name: 'enum.eventType.usdAdjustedWalletOperationReport_Admin' as const, value: 'UsdAdjustedWalletOperationReport_Admin' as const },
    { name: 'enum.eventType.countryBasedWalletAccountsReport_Admin' as const, value: 'CountryBasedWalletAccountsReport_Admin' as const },
    { name: 'enum.eventType.pspLatePayment_Admin' as const, value: 'PspLatePayment_Admin' as const },
    { name: 'enum.eventType.manualAdjustmentWalletOperationReport_Admin' as const, value: 'ManualAdjustmentWalletOperationReport_Admin' as const },
    { name: 'enum.eventType.succeedTransactionWalletOperationReport_Admin' as const, value: 'SucceedTransactionWalletOperationReport_Admin' as const },
    { name: 'enum.eventType.tradingVolumeReport_Admin' as const, value: 'TradingVolumeReport_Admin' as const },
    { name: 'enum.eventType.depositWithdrawalReport_Admin' as const, value: 'DepositWithdrawalReport_Admin' as const },
    { name: 'enum.eventType.ibTreeReport_Admin' as const, value: 'IbTreeReport_Admin' as const },
    { name: 'enum.eventType.combinedTradingPlatformSummaryReport_Admin' as const, value: 'CombinedTradingPlatformSummaryReport_Admin' as const },
    { name: 'enum.eventType.clientEquitySummaryReport_Admin' as const, value: 'ClientEquitySummaryReport_Admin' as const },
    { name: 'enum.eventType.equityIbMovementReport_Admin' as const, value: 'EquityIbMovementReport_Admin' as const },
    { name: 'enum.eventType.openTradesReport_Admin' as const, value: 'OpenTradesReport_Admin' as const },
    { name: 'enum.eventType.balanceServerCountryOperationReport_Admin' as const, value: 'BalanceServerCountryOperationReport_Admin' as const },
    { name: 'enum.eventType.pspAutoRefund' as const, value: 'PspAutoRefund' as const },
    { name: 'enum.eventType.summaryAmountByServerCountryReport_Admin' as const, value: 'SummaryAmountByServerCountryReport_Admin' as const },
    { name: 'enum.eventType.equityWalletAccountReport_Admin' as const, value: 'EquityWalletAccountReport_Admin' as const },
    { name: 'enum.eventType.userFromChineseMinoritiesApproved_Admin' as const, value: 'UserFromChineseMinoritiesApproved_Admin' as const },
    { name: 'enum.eventType.requestOtp' as const, value: 'RequestOtp' as const },
    { name: 'enum.eventType.newDataChangeRequestCreated_Admin' as const, value: 'NewDataChangeRequestCreated_Admin' as const },
    { name: 'enum.eventType.trustedDeviceCreated' as const, value: 'TrustedDeviceCreated' as const },
    { name: 'enum.eventType.dataChangeRequestApproved' as const, value: 'DataChangeRequestApproved' as const },
    { name: 'enum.eventType.trustedDeviceDeleted' as const, value: 'TrustedDeviceDeleted' as const },
    { name: 'enum.eventType.dataChangeRequestDeclined' as const, value: 'DataChangeRequestDeclined' as const },
    { name: 'enum.eventType.kycVerificationProhibitUserIbDeclined_Admin' as const, value: 'KycVerificationProhibitUserIbDeclined_Admin' as const },
    { name: 'enum.eventType.pspBalanceLimitThreshold_Admin' as const, value: 'PspBalanceLimitThreshold_Admin' as const },
    { name: 'enum.eventType.userCryptoWalletAccountSubmission_Admin' as const, value: 'UserCryptoWalletAccountSubmission_Admin' as const },
    { name: 'enum.eventType.userCryptoWalletSubmissionVerified' as const, value: 'UserCryptoWalletSubmissionVerified' as const },
    { name: 'enum.eventType.userCryptoWalletSubmissionRejected' as const, value: 'UserCryptoWalletSubmissionRejected' as const },
    { name: 'enum.eventType.userCryptoWalletSubmissionDeclined' as const, value: 'UserCryptoWalletSubmissionDeclined' as const },
    { name: 'enum.eventType.depositTimedOut' as const, value: 'DepositTimedOut' as const },
    { name: 'enum.eventType.withdrawalRejectedNotification_Sales' as const, value: 'WithdrawalRejectedNotification_Sales' as const },
    { name: 'enum.eventType.loyaltyProgramUserJoined' as const, value: 'LoyaltyProgramUserJoined' as const },
    { name: 'enum.eventType.loyaltyProgramPointsAdjusted' as const, value: 'LoyaltyProgramPointsAdjusted' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestSubmitted' as const, value: 'LoyaltyProgramRedeemRequestSubmitted' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestCancelled' as const, value: 'LoyaltyProgramRedeemRequestCancelled' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestRejected' as const, value: 'LoyaltyProgramRedeemRequestRejected' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestApproved' as const, value: 'LoyaltyProgramRedeemRequestApproved' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestDelivering' as const, value: 'LoyaltyProgramRedeemRequestDelivering' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestDelivered' as const, value: 'LoyaltyProgramRedeemRequestDelivered' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestUndelivered' as const, value: 'LoyaltyProgramRedeemRequestUndelivered' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestCreated_Admin' as const, value: 'LoyaltyProgramRedeemRequestCreated_Admin' as const },
    { name: 'enum.eventType.emailTemplate' as const, value: 'EmailTemplate' as const },
    { name: 'enum.eventType.broadcastMessage' as const, value: 'BroadcastMessage' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbEventTypeEnum.cs.
  */
  ADMIN_NOTIFICATION_EVENT: [
    { name: 'enum.eventType.pspSkippingProcessing_Admin' as const, value: 'PspSkippingProcessing_Admin' as const },
    { name: 'enum.eventType.withdrawalRequestNotification_Admin' as const, value: 'WithdrawalRequestNotification_Admin' as const },
    { name: 'enum.eventType.depositRequestNotification_Admin' as const, value: 'DepositRequestNotification_Admin' as const },
    { name: 'enum.eventType.createTicket_Admin' as const, value: 'CreateTicket_Admin' as const },
    { name: 'enum.eventType.assignToTicket_Admin' as const, value: 'AssignToTicket_Admin' as const },
    { name: 'enum.eventType.QFormVerificationRequest_Admin' as const, value: 'QFormVerificationRequest_Admin' as const },
    { name: 'enum.eventType.userInDeclinedStatus_Admin' as const, value: 'UserInDeclinedStatus_Admin' as const },
    { name: 'enum.eventType.accountsArchiverReport_Admin' as const, value: 'AccountsArchiverReport_Admin' as const },
    { name: 'enum.eventType.openTradingAccount_Admin' as const, value: 'OpenTradingAccount_Admin' as const },
    { name: 'enum.eventType.commissionHistoryReport_Admin' as const, value: 'CommissionHistoryReport_Admin' as const },
    { name: 'enum.eventType.walletOperationsReport_Admin' as const, value: 'WalletOperationsReport_Admin' as const },
    { name: 'enum.eventType.tradingBonusReport_Admin' as const, value: 'TradingBonusReport_Admin' as const },
    { name: 'enum.eventType.pspOperationsReport_Admin' as const, value: 'PspOperationsReport_Admin' as const },
    { name: 'enum.eventType.walletAccountsReport_Admin' as const, value: 'WalletAccountsReport_Admin' as const },
    { name: 'enum.eventType.kycVerificationUserDeclined_Admin' as const, value: 'KycVerificationUserDeclined_Admin' as const },
    { name: 'enum.eventType.kycVerificationsStuck_Admin' as const, value: 'KycVerificationsStuck_Admin' as const },
    { name: 'enum.eventType.newDepositDocumentsUploaded_Admin' as const, value: 'NewDepositDocumentsUploaded_Admin' as const },
    { name: 'enum.eventType.depositOnHoldReport_Admin' as const, value: 'DepositOnHoldReport_Admin' as const },
    { name: 'enum.eventType.userInDraftStatus_Admin' as const, value: 'UserInDraftStatus_Admin' as const },
    { name: 'enum.eventType.userInProcessStatus_Admin' as const, value: 'UserInProcessStatus_Admin' as const },
    { name: 'enum.eventType.userInApprovedStatus_Admin' as const, value: 'UserInApprovedStatus_Admin' as const },
    { name: 'enum.eventType.bonusAccountDepositCompleted_Admin' as const, value: 'BonusAccountDepositCompleted_Admin' as const },
    { name: 'enum.eventType.bonusAccountWithdrawalCompleted_Admin' as const, value: 'BonusAccountWithdrawalCompleted_Admin' as const },
    { name: 'enum.eventType.kytVerificationOperation_Admin' as const, value: 'KytVerificationOperation_Admin' as const },
    { name: 'enum.eventType.kytVerificationWithdrawalAttempt_Admin' as const, value: 'KytVerificationWithdrawalAttempt_Admin' as const },
    { name: 'enum.eventType.shortLinkRequest_Admin' as const, value: 'ShortLinkRequest_Admin' as const },
    { name: 'enum.eventType.kycProfileDiscrepancyNotification_Admin' as const, value: 'KycProfileDiscrepancyNotification_Admin' as const },
    { name: 'enum.eventType.mobileCodeRequest_Admin' as const, value: 'MobileCodeRequest_Admin' as const },
    { name: 'enum.eventType.lpoaSubmitted_Admin' as const, value: 'LpoaSubmitted_Admin' as const },
    { name: 'enum.eventType.userRegisteredRebateThreshold_Admin' as const, value: 'UserRegisteredRebateThreshold_Admin' as const },
    { name: 'enum.eventType.mamManagerLinkSubmitted_Admin' as const, value: 'MamManagerLinkSubmitted_Admin' as const },
    { name: 'enum.eventType.changeEmail_Admin' as const, value: 'ChangeEmail_Admin' as const },
    { name: 'enum.eventType.userDeletion_Admin' as const, value: 'UserDeletion_Admin' as const },
    { name: 'enum.eventType.tradingAccountArchive_Admin' as const, value: 'TradingAccountArchive_Admin' as const },
    { name: 'enum.eventType.kycVerificationUserDeclinedUnsupportedCountry_Admin' as const, value: 'KycVerificationUserDeclinedUnsupportedCountry_Admin' as const },
    { name: 'enum.eventType.tradingPlatformDailyEquityReport_Admin' as const, value: 'TradingPlatformDailyEquityReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformBalanceOperationReport_Admin' as const, value: 'TradingPlatformBalanceOperationReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformAdjustmentReport_Admin' as const, value: 'TradingPlatformAdjustmentReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformInactiveAccountsReport_Admin' as const, value: 'TradingPlatformInactiveAccountsReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformIBDetailReport_Admin' as const, value: 'TradingPlatformIBDetailReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformCreditFacilityReport_Admin' as const, value: 'TradingPlatformCreditFacilityReport_Admin' as const },
    { name: 'enum.eventType.tradingPlatformSummaryReport_Admin' as const, value: 'TradingPlatformSummaryReport_Admin' as const },
    { name: 'enum.eventType.topWithdrawalsSummaryReport_Admin' as const, value: 'TopWithdrawalsSummaryReport_Admin' as const },
    { name: 'enum.eventType.topWithdrawalsDetailsReport_Admin' as const, value: 'TopWithdrawalsDetailsReport_Admin' as const },
    { name: 'enum.eventType.topDepositsSummaryReport_Admin' as const, value: 'TopDepositsSummaryReport_Admin' as const },
    { name: 'enum.eventType.topDepositsDetailsReport_Admin' as const, value: 'TopDepositsDetailsReport_Admin' as const },
    { name: 'enum.eventType.userBankAccountSubmission_Admin' as const, value: 'UserBankAccountSubmission_Admin' as const },
    { name: 'enum.eventType.manualDepositsReport_Admin' as const, value: 'ManualDepositsReport_Admin' as const },
    { name: 'enum.eventType.nonUsdWalletOperationsReport_Admin' as const, value: 'NonUsdWalletOperationsReport_Admin' as const },
    { name: 'enum.eventType.topIbRebateSummaryReport_Admin' as const, value: 'TopIbRebateSummaryReport_Admin' as const },
    { name: 'enum.eventType.topIbRebateDetailsReport_Admin' as const, value: 'TopIbRebateDetailsReport_Admin' as const },
    { name: 'enum.eventType.tradingGroupNotFound_Admin' as const, value: 'TradingGroupNotFound_Admin' as const },
    { name: 'enum.eventType.volumeBySecuritySummaryReport_Admin' as const, value: 'VolumeBySecuritySummaryReport_Admin' as const },
    { name: 'enum.eventType.volumeBySecurityDetailsReport_Admin' as const, value: 'VolumeBySecurityDetailsReport_Admin' as const },
    { name: 'enum.eventType.contestRatingReport_Admin' as const, value: 'ContestRatingReport_Admin' as const },
    { name: 'enum.eventType.pspBalanceReport_Admin' as const, value: 'PspBalanceReport_Admin' as const },
    { name: 'enum.eventType.combinedTradingPlatformDailyEquityReport_Admin' as const, value: 'CombinedTradingPlatformDailyEquityReport_Admin' as const },
    { name: 'enum.eventType.usdAdjustedWalletAccountReport_Admin' as const, value: 'UsdAdjustedWalletAccountReport_Admin' as const },
    { name: 'enum.eventType.usdAdjustedWalletOperationReport_Admin' as const, value: 'UsdAdjustedWalletOperationReport_Admin' as const },
    { name: 'enum.eventType.countryBasedWalletAccountsReport_Admin' as const, value: 'CountryBasedWalletAccountsReport_Admin' as const },
    { name: 'enum.eventType.pspLatePayment_Admin' as const, value: 'PspLatePayment_Admin' as const },
    { name: 'enum.eventType.manualAdjustmentWalletOperationReport_Admin' as const, value: 'ManualAdjustmentWalletOperationReport_Admin' as const },
    { name: 'enum.eventType.succeedTransactionWalletOperationReport_Admin' as const, value: 'SucceedTransactionWalletOperationReport_Admin' as const },
    { name: 'enum.eventType.tradingVolumeReport_Admin' as const, value: 'TradingVolumeReport_Admin' as const },
    { name: 'enum.eventType.depositWithdrawalReport_Admin' as const, value: 'DepositWithdrawalReport_Admin' as const },
    { name: 'enum.eventType.ibTreeReport_Admin' as const, value: 'IbTreeReport_Admin' as const },
    { name: 'enum.eventType.combinedTradingPlatformSummaryReport_Admin' as const, value: 'CombinedTradingPlatformSummaryReport_Admin' as const },
    { name: 'enum.eventType.clientEquitySummaryReport_Admin' as const, value: 'ClientEquitySummaryReport_Admin' as const },
    { name: 'enum.eventType.equityIbMovementReport_Admin' as const, value: 'EquityIbMovementReport_Admin' as const },
    { name: 'enum.eventType.openTradesReport_Admin' as const, value: 'OpenTradesReport_Admin' as const },
    { name: 'enum.eventType.balanceServerCountryOperationReport_Admin' as const, value: 'BalanceServerCountryOperationReport_Admin' as const },
    { name: 'enum.eventType.userFromChineseMinoritiesApproved_Admin' as const, value: 'UserFromChineseMinoritiesApproved_Admin' as const },
    { name: 'enum.eventType.newDataChangeRequestCreated_Admin' as const, value: 'NewDataChangeRequestCreated_Admin' as const },
    { name: 'enum.eventType.kycVerificationProhibitUserIbDeclined_Admin' as const, value: 'KycVerificationProhibitUserIbDeclined_Admin' as const },
    { name: 'enum.eventType.pspBalanceLimitThreshold_Admin' as const, value: 'PspBalanceLimitThreshold_Admin' as const },
    { name: 'enum.eventType.userCryptoWalletAccountSubmission_Admin' as const, value: 'UserCryptoWalletAccountSubmission_Admin' as const },
    { name: 'enum.eventType.loyaltyProgramRedeemRequestCreated_Admin' as const, value: 'LoyaltyProgramRedeemRequestCreated_Admin' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbEventTypeEnum.cs.
  */
  DELAYED_NOTIFICATION_EVENT: [
    { name: 'enum.eventType.kycNotStarted' as const, value: 'KycNotStarted' as const },
    { name: 'enum.eventType.kycPassedNoDepositFirst' as const, value: 'KycPassedNoDepositFirst' as const },
    { name: 'enum.eventType.kycPassedNoDepositSecond' as const, value: 'KycPassedNoDepositSecond' as const },
    { name: 'enum.eventType.kycPassedNoDepositThird' as const, value: 'KycPassedNoDepositThird' as const },
    { name: 'enum.eventType.verifyProfileFirstReminder' as const, value: 'VerifyProfileFirstReminder' as const },
    { name: 'enum.eventType.verifyProfileSecondReminder' as const, value: 'VerifyProfileSecondReminder' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbEventTypeEnum.cs.
  */
  INACTIVITY_FEES_NOTIFICATION_EVENT: [
    { name: 'enum.eventType.accountInactivityFees' as const, value: 'AccountInactivityFees' as const },
    { name: 'enum.eventType.accountInactivityFeesSecond' as const, value: 'AccountInactivityFeesSecond' as const },
    { name: 'enum.eventType.accountInactivityFeesThird' as const, value: 'AccountInactivityFeesThird' as const },
    { name: 'enum.eventType.accountInactivityFeesFourth' as const, value: 'AccountInactivityFeesFourth' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.DbEventTypeEnum.cs.
  */
  INACTIVITY_FEES_SALES_USER_NOTIFICATION_EVENT: [
    { name: 'enum.eventType.accountInactivityFeesFirst_Sales' as const, value: 'AccountInactivityFeesFirst_Sales' as const },
    { name: 'enum.eventType.accountInactivityFeesSecond_Sales' as const, value: 'AccountInactivityFeesSecond_Sales' as const },
    { name: 'enum.eventType.accountInactivityFeesThird_Sales' as const, value: 'AccountInactivityFeesThird_Sales' as const },
    { name: 'enum.eventType.accountInactivityFeesFourth_Sales' as const, value: 'AccountInactivityFeesFourth_Sales' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.AclRoles.cs.
  */
  ROLES: [
    { name: 'enum.aclRoles.admin' as const, value: 'Admin' as const },
    { name: 'enum.aclRoles.user' as const, value: 'User' as const },
  ],

  /*
    Auto generated from file TradingPlatform.Domain.Abstractions.TradingHistory.Models.TradeType.cs.
  */
  TRADE_TYPE: [
    { name: 'enum.tradeType.buy' as const, value: 'Buy' as const },
    { name: 'enum.tradeType.sell' as const, value: 'Sell' as const },
    { name: 'enum.tradeType.buyLimit' as const, value: 'BuyLimit' as const },
    { name: 'enum.tradeType.sellLimit' as const, value: 'SellLimit' as const },
    { name: 'enum.tradeType.buyStop' as const, value: 'BuyStop' as const },
    { name: 'enum.tradeType.sellStop' as const, value: 'SellStop' as const },
    { name: 'enum.tradeType.balance' as const, value: 'Balance' as const },
    { name: 'enum.tradeType.credit' as const, value: 'Credit' as const },
    { name: 'enum.tradeType.charge' as const, value: 'Charge' as const },
    { name: 'enum.tradeType.correction' as const, value: 'Correction' as const },
    { name: 'enum.tradeType.bonus' as const, value: 'Bonus' as const },
    { name: 'enum.tradeType.commission' as const, value: 'Commission' as const },
    { name: 'enum.tradeType.dailyCommission' as const, value: 'DailyCommission' as const },
    { name: 'enum.tradeType.monthlyCommission' as const, value: 'MonthlyCommission' as const },
    { name: 'enum.tradeType.dailyAgentCommission' as const, value: 'DailyAgentCommission' as const },
    { name: 'enum.tradeType.monthlyAgentCommission' as const, value: 'MonthlyAgentCommission' as const },
    { name: 'enum.tradeType.interestRate' as const, value: 'InterestRate' as const },
    { name: 'enum.tradeType.buyCanceled' as const, value: 'BuyCanceled' as const },
    { name: 'enum.tradeType.sellCanceled' as const, value: 'SellCanceled' as const },
    { name: 'enum.tradeType.dividend' as const, value: 'Dividend' as const },
    { name: 'enum.tradeType.dividendFranked' as const, value: 'DividendFranked' as const },
    { name: 'enum.tradeType.tax' as const, value: 'Tax' as const },
    { name: 'enum.tradeType.agentCommission' as const, value: 'AgentCommission' as const },
    { name: 'enum.tradeType.soCompensation' as const, value: 'SoCompensation' as const },
    { name: 'enum.tradeType.soCompensationCredit' as const, value: 'SoCompensationCredit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.UserBonusProposalStatus.cs.
  */
  USER_BONUS_PROPOSAL_STATUS: [
    { name: 'enum.userBonusProposalStatus.created' as const, value: 'Created' as const },
    { name: 'enum.userBonusProposalStatus.notified' as const, value: 'Notified' as const },
    { name: 'enum.userBonusProposalStatus.accepted' as const, value: 'Accepted' as const },
    { name: 'enum.userBonusProposalStatus.applied' as const, value: 'Applied' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.User.UserBonusProposalType.cs.
  */
  USER_BONUS_PROPOSAL_TYPE: [
    { name: 'enum.userBonusProposalType.creditOnDeposit' as const, value: 'CreditOnDeposit' as const },
  ],

  /*
    Auto generated from file MembersArea.Common.Enums.Notifications.UserNotificationState.cs.
  */
  USER_NOTIFICATION_GRID_ITEM_STATE: [
    { name: 'enum.userNotificationState.none' as const, value: 'None' as const },
    { name: 'enum.userNotificationState.actionIsRequired' as const, value: 'ActionIsRequired' as const },
    { name: 'enum.userNotificationState.accepted' as const, value: 'Accepted' as const },
    { name: 'enum.userNotificationState.rejected' as const, value: 'Rejected' as const },
    { name: 'enum.userNotificationState.applied' as const, value: 'Applied' as const },
  ],


};

export default ENUM_CONSTANTS;
